import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Json: any;
  NaiveDateTime: any;
  UUID4: any;
};

export type Account = {
  __typename?: 'Account';
  appId?: Maybe<Scalars['UUID4']>;
  credits: Array<Credit>;
  id?: Maybe<Scalars['UUID4']>;
  invoicing?: Maybe<Invoicing>;
  managedAddressesOnly?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  sapLink?: Maybe<SapLink>;
  submittedOrders?: Maybe<SubmittedOrderPayload>;
  tags?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
};


export type AccountSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type AccountVerificationLocalization = {
  __typename?: 'AccountVerificationLocalization';
  body: Scalars['String'];
  buttonText: Scalars['String'];
  contactSupportText: Scalars['String'];
  emailSentText: Scalars['String'];
  heading: Scalars['String'];
  invalidLinkText: Scalars['String'];
  tokenExpiredText: Scalars['String'];
  verifySuccessText: Scalars['String'];
};

export type Activity = {
  __typename?: 'Activity';
  activityId: Scalars['String'];
  dateEnd?: Maybe<Scalars['DateTime']>;
  dateStart?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  extraData?: Maybe<Scalars['Json']>;
  freqCap?: Maybe<Scalars['Int']>;
  freqPeriodId?: Maybe<Scalars['Int']>;
  freqPeriodName?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  numPoints: Scalars['Int'];
};

export type ActivityAwarded = {
  __typename?: 'ActivityAwarded';
  awarded?: Maybe<Scalars['Boolean']>;
  numPoints?: Maybe<Scalars['Int']>;
};

export type ActivityCreditByPepdirectActivityIdInput = {
  activityDate: Scalars['DateTime'];
  extraData?: InputMaybe<Scalars['Json']>;
  pepdirectActivityId: Scalars['String'];
};

export type ActivityCreditInput = {
  activityDate: Scalars['DateTime'];
  activityId: Scalars['String'];
  extraData?: InputMaybe<Scalars['Json']>;
};

export type AddItemWithUniqueCustomizationsInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  customizations: Scalars['Json'];
  id?: InputMaybe<Scalars['UUID4']>;
  itemId: Scalars['UUID4'];
  merchandiseId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID4'];
  isDefault?: Maybe<Scalars['Boolean']>;
  isRemovable?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user: User;
  zip: Scalars['String'];
};

export type AddressConfig = {
  __typename?: 'AddressConfig';
  addressNickname?: Maybe<Scalars['Boolean']>;
  addressSpecialInstructions?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['Boolean']>;
  countriesAllowed: Array<CountriesAllowed>;
  isStateRequired?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  phoneNumberCountryCodesAllowed?: Maybe<Array<Maybe<PhoneNumberCountryCodesAllowed>>>;
  requireValidation: ValidationRequirement;
  statesConfig: Array<StatesConfig>;
  taxId?: Maybe<Scalars['Boolean']>;
};

export type AddressVerificationLocalization = {
  __typename?: 'AddressVerificationLocalization';
  addressErrorBoldText: Scalars['String'];
  addressErrorText: Scalars['String'];
  editManuallyText: Scalars['String'];
  editOnlyText: Scalars['String'];
  editOrSuggestionText: Scalars['String'];
  enteredAddressText: Scalars['String'];
  invalidZipCodeText: Scalars['String'];
  keepEnteredButtonText: Scalars['String'];
  reviewAddressText: Scalars['String'];
  suggestedAddressText: Scalars['String'];
  titleText: Scalars['String'];
  useSuggestedButtonText: Scalars['String'];
  zipErrorBoldText: Scalars['String'];
  zipErrorText: Scalars['String'];
};

export type AiDesign = {
  __typename?: 'AiDesign';
  appId: Scalars['UUID4'];
  colors: Array<Maybe<AiDesignColor>>;
  featuredWeight: Scalars['Int'];
  generatedByTenant: Scalars['Boolean'];
  id: Scalars['UUID4'];
  imageUrls: Scalars['Json'];
  insertedAt: Scalars['DateTime'];
  item: Item;
  promptAiEnhanced?: Maybe<Scalars['String']>;
  promptUser?: Maybe<Scalars['String']>;
  traits: Array<Maybe<AiDesignTrait>>;
  userId?: Maybe<Scalars['UUID4']>;
};

export type AiDesignColor = {
  __typename?: 'AiDesignColor';
  hexValue: Scalars['String'];
  name: Scalars['String'];
};

export type AiDesignColorInput = {
  hexValue: Scalars['String'];
  name: Scalars['String'];
};

export type AiDesignFilterInput = {
  colors?: InputMaybe<Array<AiDesignColorInput>>;
  ids?: InputMaybe<Array<Scalars['UUID4']>>;
  /** Used to narrow down designs returned based on who created them. Defaults to [TENANT] */
  sources?: InputMaybe<Array<SourceTypes>>;
  traits?: InputMaybe<Array<AiDesignTraitInput>>;
};

export type AiDesignResult = {
  __typename?: 'AiDesignResult';
  items?: Maybe<Array<AiDesign>>;
  pagination: PaginationData;
};

export type AiDesignSortingInput = {
  sortBy: SortableFields;
  sortOrder: SortableMethods;
};

export type AiDesignTrait = {
  __typename?: 'AiDesignTrait';
  id: Scalars['String'];
};

export type AiDesignTraitInput = {
  /** ID of Dato trait record */
  id: Scalars['String'];
};

export type AllowedState = {
  __typename?: 'AllowedState';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AnalyticsConfig = {
  __typename?: 'AnalyticsConfig';
  gtm?: Maybe<GtmConfig>;
  projectId?: Maybe<Scalars['String']>;
  writeKey?: Maybe<Scalars['String']>;
};

export type ApplePayCard = {
  __typename?: 'ApplePayCard';
  billingAddress?: Maybe<BraintreeAddress>;
  bin: Scalars['String'];
  cardType: Scalars['String'];
  cardholderName: Scalars['String'];
  countryOfIssuance: Scalars['String'];
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  default: Scalars['Boolean'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  expired: Scalars['Boolean'];
  imageUrl: Scalars['String'];
  issuingBank: Scalars['String'];
  last4: Scalars['String'];
  paymentInstrumentName: Scalars['String'];
  productId: Scalars['String'];
  sourceDescription: Scalars['String'];
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  token: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type BasicBehaviour = {
  __typename?: 'BasicBehaviour';
  name: BehaviourEnum;
};

export type Bazaarvoice = {
  __typename?: 'Bazaarvoice';
  encryptedEmail?: Maybe<Scalars['String']>;
  encryptionKeyId?: Maybe<Scalars['String']>;
};

/** Behaviour which may or may not have attributes */
export type Behaviour = BasicBehaviour | BogoBehaviour | DynamicBundlesBehaviour | TieredBehaviour;

export enum BehaviourEnum {
  /** Basic discount logic, discounts all matching items by configured amount. */
  Basic = 'BASIC',
  /** Buy one (or many) get one (or many) at the specified percent off */
  Bogo = 'BOGO',
  /** Buy one (or many) get one (or many) at the specified percent off with specific triggering items */
  BogoAdvanced = 'BOGO_ADVANCED',
  /** Dynamic Bundles discount logic, discounts matching items designated with the campaign_id */
  DynamicBundles = 'DYNAMIC_BUNDLES',
  /** Tiered discount logic, discounts matching items according to a tier structure. */
  Tiered = 'TIERED'
}

export type BogoAttributes = {
  __typename?: 'BogoAttributes';
  applyAmount: Scalars['Int'];
  triggerPoint: Scalars['Int'];
};

export type BogoBehaviour = {
  __typename?: 'BogoBehaviour';
  attributes: BogoAttributes;
  name: BehaviourEnum;
};

export type BotProtection = {
  __typename?: 'BotProtection';
  active: Scalars['Boolean'];
  provider?: Maybe<BotProtectionProvider>;
  siteKey?: Maybe<BotProtectionSiteKey>;
};

export enum BotProtectionProvider {
  GoogleRecaptcha = 'GOOGLE_RECAPTCHA'
}

export type BotProtectionSiteKey = {
  __typename?: 'BotProtectionSiteKey';
  android: Scalars['String'];
  ios: Scalars['String'];
  web: Scalars['String'];
};

export type BraintreeAddress = {
  __typename?: 'BraintreeAddress';
  company?: Maybe<Scalars['String']>;
  countryCodeAlpha2?: Maybe<Scalars['String']>;
  countryCodeAlpha3?: Maybe<Scalars['String']>;
  countryCodeNumeric?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  extendedAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type BrandConfig = {
  __typename?: 'BrandConfig';
  audience: Scalars['String'];
  cdnHost?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  contactUrl?: Maybe<Scalars['String']>;
  copyright: Scalars['String'];
  customCss?: Maybe<Scalars['String']>;
  customTexts: Array<CustomText>;
  customizations: BrandConfigCustomizations;
  email?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  optInTextLocalized: Scalars['String'];
  supportEmail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  trackingFonts?: Maybe<Array<Maybe<BrandConfigTrackingFonts>>>;
  yearsAgeGate?: Maybe<Scalars['Int']>;
};

export type BrandConfigCustomizations = {
  __typename?: 'BrandConfigCustomizations';
  account?: Maybe<BrandConfigCustomizationsAccount>;
  contacts: Array<BrandConfigCustomizationsContact>;
  css: Array<BrandConfigCustomizationsCss>;
  fonts: Array<BrandConfigCustomizationsFont>;
  images: Array<BrandConfigCustomizationsImage>;
  links: Array<BrandConfigCustomizationsLink>;
};

export type BrandConfigCustomizationsAccount = {
  __typename?: 'BrandConfigCustomizationsAccount';
  profilePageTitle?: Maybe<Scalars['String']>;
  signinPageTitle?: Maybe<Scalars['String']>;
  signupPageTitle?: Maybe<Scalars['String']>;
  valueprops: Array<BrandConfigCustomizationsAccountValueprops>;
};

export type BrandConfigCustomizationsAccountValueprops = {
  __typename?: 'BrandConfigCustomizationsAccountValueprops';
  imgUrl?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsContact = {
  __typename?: 'BrandConfigCustomizationsContact';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  showCountry?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsCss = {
  __typename?: 'BrandConfigCustomizationsCss';
  overrides: Array<BrandConfigCustomizationsCssOverride>;
  selector: Scalars['String'];
};

export type BrandConfigCustomizationsCssOverride = {
  __typename?: 'BrandConfigCustomizationsCssOverride';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFont = {
  __typename?: 'BrandConfigCustomizationsFont';
  meta?: Maybe<Array<BrandConfigCustomizationsFontMeta>>;
  name: Scalars['String'];
  style?: Maybe<Scalars['String']>;
  urls: Array<BrandConfigCustomizationsFontSources>;
  weight?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsFontMeta = {
  __typename?: 'BrandConfigCustomizationsFontMeta';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type BrandConfigCustomizationsFontSources = {
  __typename?: 'BrandConfigCustomizationsFontSources';
  format?: Maybe<Scalars['String']>;
  local?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type BrandConfigCustomizationsImage = {
  __typename?: 'BrandConfigCustomizationsImage';
  alt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  src: Scalars['String'];
};

export type BrandConfigCustomizationsLink = {
  __typename?: 'BrandConfigCustomizationsLink';
  location: Scalars['String'];
  newTab: Scalars['Boolean'];
  position: Scalars['Int'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type BrandConfigTrackingFonts = {
  __typename?: 'BrandConfigTrackingFonts';
  font: Scalars['String'];
  isTrackingRequired: Scalars['Boolean'];
  resource: Scalars['String'];
};

export type BundleComponent = {
  __typename?: 'BundleComponent';
  componentPriceItems?: Maybe<Array<Maybe<DynamicBundleItem>>>;
  imgUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  qtyType: Scalars['String'];
  requiredQty: Scalars['Int'];
  subscriptionOption?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BundleItem = {
  __typename?: 'BundleItem';
  imgUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * DynamicBundle are composed of items (CartItem or LineItem) which contain DynamicBundle
 * metadata in a cart. A BundleLineItem is a convenience struct that will create one item
 * that is an accumulation of all the items which are part of a DynamicBundle.
 */
export type BundleLineItem = {
  __typename?: 'BundleLineItem';
  /** components of the bundle other than the primary component */
  bundleComponents: Array<Maybe<BundleComponent>>;
  /** The id of the DynamicBundle */
  bundleId: Scalars['UUID4'];
  /** The cart reference of the DynamicBundle */
  cartBundleReference: Scalars['Int'];
  /** Will contain information of the discount for the DynamicBundle */
  discounts: Array<LineItemDiscount>;
  /** The DynamicBundle the items belong to */
  dynamicBundle: DynamicBundle;
  /** A list of items that are NOT associated with the primary component */
  dynamicBundleItems?: Maybe<Array<DynamicBundleItem>>;
  /** This is the image from the primary component */
  imgUrl?: Maybe<Scalars['String']>;
  /** aggregated gtin item notifications */
  itemNotifications: Array<Scalars['String']>;
  /** This will always the same as subtotal because DynamicBundles are quantity of 1 */
  perUnitPrice: Scalars['Int'];
  /** A list of items that are associated with the primary component */
  primaryBundleItems?: Maybe<Array<DynamicBundleItem>>;
  /** The primary component of the DynamicBundle */
  primaryComponent: BundleComponent;
  /** This is the quantity of all the items that are part of the DynamicBundle */
  quantity: Scalars['Int'];
  /** This is the cumulative strikethrough price of all the items in the DynamicBundle */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  /** This is the total of the items after the discount for the DynamicBundle is applied */
  subtotal: Scalars['Int'];
  /** The title of the primary component for the DynamicBundle */
  title: Scalars['String'];
};

export type CalculateOrderDiscountsInput = {
  orderId?: InputMaybe<Scalars['UUID4']>;
  price?: InputMaybe<PriceInput>;
};

export type CalculateOrderDiscountsPayload = {
  __typename?: 'CalculateOrderDiscountsPayload';
  order?: Maybe<Order>;
};

export type CalculateOrderPayload = {
  __typename?: 'CalculateOrderPayload';
  order?: Maybe<Order>;
};

export type CancelOrderSubscriptionInput = {
  cancelReason: Scalars['String'];
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
};

export type Capabilities = {
  __typename?: 'Capabilities';
  signUp: CapabilitiesSignUp;
  termsAndConditions?: Maybe<CapabilitiesTermsAndConditions>;
};

/**
 * The sign up capability informs consumers of the API if the Tenant
 * allows users to sign up via the Secure Portal.
 */
export type CapabilitiesSignUp = {
  __typename?: 'CapabilitiesSignUp';
  enabled: Scalars['Boolean'];
};

/** The capability to request accepting most recent version of T&C by user. */
export type CapabilitiesTermsAndConditions = {
  __typename?: 'CapabilitiesTermsAndConditions';
  lastVersionUpdatedAt?: Maybe<Scalars['DateTime']>;
};

export type Cart = {
  __typename?: 'Cart';
  appId: Scalars['UUID4'];
  dynamicBundles?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  isGift?: Maybe<Scalars['Boolean']>;
  items: Array<CartItem>;
  lineItems: Array<CartItemsAndBundleItems>;
  loyaltyData?: Maybe<LoyaltyData>;
  /** list of loyalty rewards the user has applied to their cart. Update via applyLoyaltyRewardToCart mutation. */
  loyaltyRewards?: Maybe<Array<Maybe<LoyaltyReward>>>;
  /** the calculated shipping (most tenants have a threshold after which shipping is free) */
  shipping: Scalars['Int'];
  /** SubTotal of the order calculated by adding all line item subtotals. */
  subtotal: Scalars['Int'];
  /** Total of the order calculated by adding all line item totals and shipping. This does NOT include tax calculations */
  total: Scalars['Int'];
  user?: Maybe<User>;
  vendorConfig: Tenant;
};

export type CartBundleComponentInput = {
  componentId: Scalars['UUID4'];
  items?: InputMaybe<Array<CartBundleItemInput>>;
};

export type CartBundleItemInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  customizations?: InputMaybe<Scalars['Json']>;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
};

export type CartDynamicBundleInput = {
  bundleId: Scalars['UUID4'];
  components?: InputMaybe<Array<CartBundleComponentInput>>;
  id?: InputMaybe<Scalars['UUID4']>;
};

export type CartExactDynamicBundleInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  bundleId?: InputMaybe<Scalars['UUID4']>;
  bundleTag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID4']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  customizations?: Maybe<Scalars['Json']>;
  discounts: Array<LineItemDiscount>;
  dynamicBundle?: Maybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  item: Item;
  merchandise?: Maybe<Merchandise>;
  /** The discounted price of the item as an individual unit (rounded up, except for promo-code discounts, which are not adjusted). */
  perUnitPrice: Scalars['Int'];
  quantity: Scalars['Int'];
  /** The original price of the item as an individual unit (either the compare_at_price or or non-discounted price). */
  strikethroughUnitPrice?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  /** calculated by subtracting the discount_total from the items base_price * quantity (except for promo-code discounts, which are not included) */
  subtotal: Scalars['Int'];
};

export type CartItemInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  customizations?: InputMaybe<Scalars['Json']>;
  id?: InputMaybe<Scalars['UUID4']>;
  itemId: Scalars['UUID4'];
  merchandiseId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
};

export type CartItemsAndBundleItems = BundleLineItem | CartItem;

export type CartRemoveDynamicBundleInput = {
  cartBundleReference: Scalars['Int'];
  id: Scalars['UUID4'];
};

export type Category = {
  __typename?: 'Category';
  appId: Scalars['UUID4'];
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
};

export type ChangeUserPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
};

export type Checkout = {
  __typename?: 'Checkout';
  paymentOptions?: Maybe<TenantPaymentOptions>;
  shippingOptions?: Maybe<TenantShippingOptions>;
  showCouponCodeCta?: Maybe<Scalars['Boolean']>;
  vatInclusivePricing?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type CheckoutBreadcrumbsLocalization = {
  __typename?: 'CheckoutBreadcrumbsLocalization';
  address: Scalars['String'];
  payment: Scalars['String'];
  review: Scalars['String'];
  shipping: Scalars['String'];
};

export type CheckoutCouponCodeLocalizations = {
  __typename?: 'CheckoutCouponCodeLocalizations';
  addCouponButtonText: Scalars['String'];
  applyCouponButtonText: Scalars['String'];
  cancelCouponButtonText: Scalars['String'];
  couponCodeLabel: Scalars['String'];
  couponLabel: Scalars['String'];
  couponPlaceholderText: Scalars['String'];
  editCouponButtonText: Scalars['String'];
  removeCouponButtonText: Scalars['String'];
};

export type CheckoutErrorsLocalizations = {
  __typename?: 'CheckoutErrorsLocalizations';
  discount?: Maybe<DiscountLocalizations>;
  genericErrorMsg: Scalars['String'];
  guestCartContainsSubscription?: Maybe<GuestCartContainsSubscriptionLocalizations>;
  insufficientLoyaltyBalance?: Maybe<InsufficientLoyaltyBalanceLocalizations>;
  invalidGiftCard?: Maybe<InvalidGiftCardLocalizations>;
  invalidLoyaltyReward?: Maybe<InvalidLoyaltyRewardLocalizations>;
  itemUnavailable?: Maybe<ItemUnavailableLocalizations>;
  lowStock?: Maybe<LowStockLocalizations>;
  minimumPurchaseAmount: Scalars['String'];
  minimumPurchaseQuantity: Scalars['String'];
  outOfStock?: Maybe<OutOfStockLocalizations>;
  paymentFailureErrorText: Scalars['String'];
  paymentNotAccepted: Scalars['String'];
  purchaseQtyLimit?: Maybe<PurchaseQtyLimitLocalizations>;
  unableToUsePoBox: Scalars['String'];
  unverifiedEmail: Scalars['String'];
  zipCodeRestriction?: Maybe<ZipCodeRestrictionLocalizations>;
};

export type CheckoutGiftCardLocalizations = {
  __typename?: 'CheckoutGiftCardLocalizations';
  addCouponGiftButtonText: Scalars['String'];
  addGiftButtonText: Scalars['String'];
  giftCardEndingIn: Scalars['String'];
  giftNumberLabel: Scalars['String'];
  giftNumberPlaceholderText: Scalars['String'];
  giftPinLabel: Scalars['String'];
  giftPinPlaceholderText: Scalars['String'];
};

export type CheckoutGiftFormLocalizations = {
  __typename?: 'CheckoutGiftFormLocalizations';
  emailFieldLabel: Scalars['String'];
  gifteeFieldLabel: Scalars['String'];
  infoText: Scalars['String'];
  messageFieldLabel: Scalars['String'];
  sendAsGiftText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
};

/**
 * Returns a map of all checkout elements and their translations.
 *
 * Example:
 *     ```
 *     query {
 *       localization {
 *         checkout {
 *           breadcrumbs {
 *             shipping
 *           }
 *         }
 *       }
 *     }
 *     ```
 */
export type CheckoutLocalization = {
  __typename?: 'CheckoutLocalization';
  breadcrumbs?: Maybe<CheckoutBreadcrumbsLocalization>;
  couponCode?: Maybe<CheckoutCouponCodeLocalizations>;
  errors?: Maybe<CheckoutErrorsLocalizations>;
  giftCard?: Maybe<CheckoutGiftCardLocalizations>;
  giftForm?: Maybe<CheckoutGiftFormLocalizations>;
  orderDetails?: Maybe<CheckoutOrderDetailsLocalizations>;
  orderStatusPage?: Maybe<CheckoutOrderStatusPageLocalizations>;
  orderSummary?: Maybe<CheckoutOrderSummaryLocalizations>;
  pageTitlesInHead?: Maybe<CheckoutPageTitlesLocalization>;
  paymentStep?: Maybe<CheckoutPaymentStepLocalizations>;
  rdd?: Maybe<CheckoutRddLocalizations>;
  reviewStep?: Maybe<CheckoutReviewStepLocalizations>;
  shippingMethodStep?: Maybe<CheckoutShippingMethodStepLocalizations>;
  shippingStep?: Maybe<CheckoutShippingStepLocalizations>;
};

export type CheckoutOrderDetailsLocalizations = {
  __typename?: 'CheckoutOrderDetailsLocalizations';
  billingSameAsShippingText: Scalars['String'];
  cardholderNameText: Scalars['String'];
  expiresText: Scalars['String'];
  invoiceTermsText: Scalars['String'];
  invoiceText: Scalars['String'];
  poNumberText: Scalars['String'];
  shippingMethodText: Scalars['String'];
};

export type CheckoutOrderStatusPageLocalizations = {
  __typename?: 'CheckoutOrderStatusPageLocalizations';
  continueShoppingButtonText: Scalars['String'];
  headingText: Scalars['String'];
  notFoundMsg: Scalars['String'];
  orderConfirmationShipmentText: Scalars['String'];
  orderDateText: Scalars['String'];
  orderDetailsHeadingText: Scalars['String'];
  orderDetailsNote: Scalars['String'];
  orderDetailsText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  printButtonText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
};

export type CheckoutOrderSummaryLocalizations = {
  __typename?: 'CheckoutOrderSummaryLocalizations';
  bulkDiscountText: Scalars['String'];
  bundleDiscountText: Scalars['String'];
  bundleItemDefaultText: Scalars['String'];
  cartHeadingText: Scalars['String'];
  freeShipLabel: Scalars['String'];
  itemPlural: Scalars['String'];
  itemSingular: Scalars['String'];
  regulatoryTaxLabel: Scalars['String'];
  salesTaxLabel: Scalars['String'];
  shippingLabel: Scalars['String'];
  subtotalLabel: Scalars['String'];
  totalLabel: Scalars['String'];
  whatsIncludedText: Scalars['String'];
  yourOrderText: Scalars['String'];
};

export type CheckoutPageTitlesLocalization = {
  __typename?: 'CheckoutPageTitlesLocalization';
  checkout: Scalars['String'];
  status: Scalars['String'];
};

export type CheckoutPaymentStepLocalizations = {
  __typename?: 'CheckoutPaymentStepLocalizations';
  addCardHeadingText: Scalars['String'];
  addPaymentButtonText: Scalars['String'];
  addPaymentHeadingText: Scalars['String'];
  billingAddressHeadingText: Scalars['String'];
  billingSameAsShippingText: Scalars['String'];
  continueToReviewButtonText: Scalars['String'];
  giftCardCoversFullAmountDescription: Scalars['String'];
  giftCardCoversFullAmountTitle: Scalars['String'];
  headingText: Scalars['String'];
  sectionHeadingText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
};

export type CheckoutRddLocalizations = {
  __typename?: 'CheckoutRddLocalizations';
  changeDateText: Scalars['String'];
  headingText: Scalars['String'];
  needOrderSoonerText: Scalars['String'];
  noteText: Scalars['String'];
  selectDateText: Scalars['String'];
  yourRequestedDateText: Scalars['String'];
};

export type CheckoutReviewStepLocalizations = {
  __typename?: 'CheckoutReviewStepLocalizations';
  agreeToTermsText: Scalars['String'];
  editButtonText: Scalars['String'];
  emailNote: Scalars['String'];
  giftEmailNote: Scalars['String'];
  giftMessageNote: Scalars['String'];
  giftShippingHeadingText: Scalars['String'];
  headingText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
  submitOrderButtonText: Scalars['String'];
};

export type CheckoutShippingMethodStepLocalizations = {
  __typename?: 'CheckoutShippingMethodStepLocalizations';
  freeText: Scalars['String'];
  headingText: Scalars['String'];
  selectShippingMethodText: Scalars['String'];
};

export type CheckoutShippingStepLocalizations = {
  __typename?: 'CheckoutShippingStepLocalizations';
  addAddressButtonText: Scalars['String'];
  addAddressHeadingText: Scalars['String'];
  additionalPhoneNumberLabel: Scalars['String'];
  addressHeadingText: Scalars['String'];
  contactNoteText: Scalars['String'];
  continueToPaymentButtonText: Scalars['String'];
  continueToShippingMethodButtonText: Scalars['String'];
  savedAddressHeadingText: Scalars['String'];
  shipAlertText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
};

export type CodeSubmitted = {
  __typename?: 'CodeSubmitted';
  numPoints?: Maybe<Scalars['Int']>;
};

export type Component = {
  __typename?: 'Component';
  discount?: Maybe<Discount>;
  id: Scalars['UUID4'];
  items?: Maybe<Array<Item>>;
  name: Scalars['String'];
  qtyType: Scalars['String'];
  requiredQty: Scalars['Int'];
  subscriptionOption: SubscriptionOption;
};

export type ComponentsLocalization = {
  __typename?: 'ComponentsLocalization';
  addressVerification?: Maybe<AddressVerificationLocalization>;
  customNotFound?: Maybe<CustomNotFoundLocalization>;
  errorModal?: Maybe<ErrorModalLocalization>;
  exchangeReturnByDate?: Maybe<ExchangeReturnByDateLocalization>;
  footer?: Maybe<FooterLocalization>;
  orderProcessing?: Maybe<OrderProcessing>;
  price?: Maybe<PriceLocalization>;
};

export type ContactConfig = {
  __typename?: 'ContactConfig';
  shippingAddressConfig: AddressConfig;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  bazaarvoice?: Maybe<Bazaarvoice>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<EmbeddedAddress>;
  shippingMethod?: Maybe<EmbeddedShippingMethod>;
  user?: Maybe<User>;
  userString?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type ContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<EmbeddedAddressInput>;
  username?: InputMaybe<Scalars['String']>;
};

export type CountriesAllowed = {
  __typename?: 'CountriesAllowed';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePaymentMethodInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  deviceData: Scalars['String'];
  nonce: Scalars['String'];
};

export type CreateRegistrationRecordInput = {
  customData?: InputMaybe<Scalars['Json']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  gtin: Scalars['String'];
  purchaseDate: Scalars['Date'];
  purchaseLocation?: InputMaybe<Scalars['String']>;
  utmData?: InputMaybe<UtmDataInput>;
};

/** Response when an order is created during checkout */
export type CreatedOrder = {
  __typename?: 'CreatedOrder';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  compositeId?: Maybe<Scalars['String']>;
  contactInfo?: Maybe<ContactInfo>;
  /** User's own internal id for the order */
  customerPo?: Maybe<Scalars['String']>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  orderSubscription?: Maybe<OrderSubscription>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  submissionUid?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Credit = {
  __typename?: 'Credit';
  activeFrom: Scalars['Date'];
  activeUntil?: Maybe<Scalars['Date']>;
  availableAmount: Scalars['Int'];
  frozen: Scalars['Boolean'];
  id: Scalars['UUID4'];
  notes?: Maybe<Scalars['String']>;
  pendingAmount: Scalars['Int'];
  settledAmount: Scalars['Int'];
  spentAmount: Scalars['Int'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  billingAddress?: Maybe<BraintreeAddress>;
  cardType: Scalars['String'];
  cardholderName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  default: Scalars['Boolean'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  isRemovable?: Maybe<Scalars['Boolean']>;
  last4: Scalars['String'];
  token: Scalars['String'];
  uniqueNumberIdentifier: Scalars['String'];
};

export type CreditCardTooltipLocalization = {
  __typename?: 'CreditCardTooltipLocalization';
  cardsWith3DigitsNote: Scalars['String'];
  cardsWith3DigitsText: Scalars['String'];
  cardsWith4DigitsNote: Scalars['String'];
  cardsWith4DigitsText: Scalars['String'];
  cvv3DigitAlt: Scalars['String'];
  cvv4DigitAlt: Scalars['String'];
  headingText: Scalars['String'];
};

export type CustomDataInput = {
  customData: Scalars['Json'];
};

export type CustomNotFoundLocalization = {
  __typename?: 'CustomNotFoundLocalization';
  cartButtonText: Scalars['String'];
  headingText: Scalars['String'];
  homeButtonText: Scalars['String'];
  subHeadingText: Scalars['String'];
};

export type CustomText = {
  __typename?: 'CustomText';
  body: Array<Scalars['String']>;
  links: Array<CustomTextLink>;
  location: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type CustomTextLink = {
  __typename?: 'CustomTextLink';
  displayValue: Scalars['String'];
  key: Scalars['String'];
  linkValue: Scalars['String'];
  type: Scalars['String'];
};

/** Used for item customizations maps */
export type Customization = GatoradeIdBottle | GatoradeTowel | LegacyCustomization;

export type DeleteCreditCardInput = {
  token: Scalars['String'];
};

export type DeletePaymentMethodInput = {
  token: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  activeFrom: Scalars['DateTime'];
  activeUntil?: Maybe<Scalars['DateTime']>;
  amount?: Maybe<Scalars['Int']>;
  appId?: Maybe<Scalars['UUID4']>;
  behaviour: Behaviour;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isPercent?: Maybe<Scalars['Boolean']>;
  isPromoCodeRequired?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  promoCode?: Maybe<Scalars['String']>;
  type?: Maybe<DiscountType>;
  typeDependentValue?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['Int']>;
};

export type DiscountLocalizations = {
  __typename?: 'DiscountLocalizations';
  discountCannotApplyToSubscription: Scalars['String'];
  discountExceedsSubtotal: Scalars['String'];
  discountHeadingText: Scalars['String'];
  discountNotFound: Scalars['String'];
  discountNoteText: Scalars['String'];
  discountPromoCodeRequiresEmail: Scalars['String'];
  discountPromoCodeRequiresEmailOrLogin: Scalars['String'];
  discountTooLarge: Scalars['String'];
};

export enum DiscountType {
  /** The discount is specific to a bundle */
  DynamicBundle = 'DYNAMIC_BUNDLE',
  /** Currently unused */
  GiftCard = 'GIFT_CARD',
  /** The discount is specific to a single item */
  Item = 'ITEM',
  /** The discount is specific to the discount's itemSet */
  ItemSet = 'ITEM_SET',
  /** The discount is specific to a subscription */
  Subscription = 'SUBSCRIPTION',
  /** The discount is specific to an entire tenant */
  Tenant = 'TENANT',
  /** The discount is specific to a specific vendor */
  Vendor = 'VENDOR'
}

export type Discounts = {
  __typename?: 'Discounts';
  discounts?: Maybe<Array<Discount>>;
};

export type DiscountsInput = {
  activeFrom: Scalars['DateTime'];
  activeUntil?: InputMaybe<Scalars['DateTime']>;
  amount?: InputMaybe<Scalars['Int']>;
  appId?: InputMaybe<Scalars['UUID4']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  isPercent?: InputMaybe<Scalars['Boolean']>;
  isPromoCodeRequired?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  promoCode?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  typeDependentValue?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Scalars['Int']>;
};

export type DynamicBundle = {
  __typename?: 'DynamicBundle';
  appId: Scalars['UUID4'];
  components?: Maybe<Array<Component>>;
  discount?: Maybe<Discount>;
  discountPrice: Scalars['Int'];
  id: Scalars['UUID4'];
  inventoryQty?: Maybe<Scalars['Int']>;
  minRetailPrice: Scalars['Int'];
  name: Scalars['String'];
  primaryComponent: Component;
  tag: Scalars['String'];
};

export type DynamicBundleItem = {
  __typename?: 'DynamicBundleItem';
  analyticsDetails?: Maybe<Scalars['Json']>;
  /** A list of customizations the item associated contains */
  customizations?: Maybe<Array<Customization>>;
  discounts?: Maybe<Array<LineItemDiscount>>;
  item: Item;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
};

export type DynamicBundlesBehaviour = {
  __typename?: 'DynamicBundlesBehaviour';
  name: BehaviourEnum;
};

export type EmailNewsletterSignupInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  source?: InputMaybe<SourceType>;
};

export type EmailOptInLocalization = {
  __typename?: 'EmailOptInLocalization';
  body: Scalars['String'];
  defaultLabelText: Scalars['String'];
  privacyPolicyLinkText: Scalars['String'];
  termsOfUseLinkText: Scalars['String'];
};

export type EmailSspInput = {
  businessAddress: Scalars['String'];
  businessName: Scalars['String'];
  businessType: Scalars['String'];
  city: Scalars['String'];
  emailField: Scalars['String'];
  existingCustomer: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  manageAndOrder: Scalars['String'];
  numberOfUsers: Scalars['String'];
  phoneNumber: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type EmailSspResponse = {
  __typename?: 'EmailSspResponse';
  status: Scalars['String'];
};

export type EmbeddedAddress = {
  __typename?: 'EmbeddedAddress';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  validated?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type EmbeddedAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  validated?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type EmbeddedCategory = {
  __typename?: 'EmbeddedCategory';
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
};

export type EmbeddedDiscount = {
  __typename?: 'EmbeddedDiscount';
  amount?: Maybe<Scalars['Int']>;
  isPercent?: Maybe<Scalars['Boolean']>;
};

export type EmbeddedGiftCard = {
  __typename?: 'EmbeddedGiftCard';
  amount: Scalars['Int'];
  appliedAmount: Scalars['Int'];
  giftCardId: Scalars['String'];
  last4: Scalars['String'];
  requestReference: Scalars['String'];
  transactionId: Scalars['String'];
  type: Scalars['String'];
};

export type EmbeddedItem = {
  __typename?: 'EmbeddedItem';
  awaitingImportCorrection?: Maybe<Scalars['Boolean']>;
  brandName?: Maybe<Scalars['String']>;
  bundleOnly?: Maybe<Scalars['Boolean']>;
  categories?: Maybe<EmbeddedCategory>;
  color?: Maybe<Scalars['String']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  containerType?: Maybe<Scalars['String']>;
  countryCity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designerBio?: Maybe<Scalars['String']>;
  dimensionUnits?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  fluidOzPerPack?: Maybe<Scalars['Decimal']>;
  gasExchangeInfo?: Maybe<EmbeddedItemGasExchangeInfo>;
  height?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  imgUrl?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['UUID4']>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isApproved?: Maybe<Scalars['Boolean']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  isPending?: Maybe<Scalars['Boolean']>;
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  meltRisk?: Maybe<Scalars['Boolean']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  onMarketplace?: Maybe<Scalars['Boolean']>;
  pointsPrice?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  primaryCategoryPriority?: Maybe<Scalars['Int']>;
  productPacks?: Maybe<Scalars['Int']>;
  productsPerPack?: Maybe<Scalars['Int']>;
  returnsPolicy?: Maybe<Scalars['String']>;
  secondaryCategoryPriority?: Maybe<Scalars['Int']>;
  shippingInfo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugHash?: Maybe<Scalars['String']>;
  subscriptionMetadata?: Maybe<EmbeddedItemSubscriptionMetadata>;
  subscriptionOnly?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['String']>;
  taxCodeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['UUID4']>;
  virtual?: Maybe<Scalars['Boolean']>;
  weightOz?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type EmbeddedItemGasExchangeInfo = {
  __typename?: 'EmbeddedItemGasExchangeInfo';
  enabled: Scalars['Boolean'];
  missingCylinder?: Maybe<Item>;
  missingCylinderId?: Maybe<Scalars['UUID4']>;
};

export type EmbeddedItemSubscriptionMetadata = {
  __typename?: 'EmbeddedItemSubscriptionMetadata';
  discount?: Maybe<EmbeddedDiscount>;
  isSubscribable: Scalars['Boolean'];
  subscriptionPrice?: Maybe<Scalars['Int']>;
};

export type EmbeddedShippingMethod = {
  __typename?: 'EmbeddedShippingMethod';
  code?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * Uses custom oneOf directive.  Input is one of the following fields.
 * We can associate a different source id with each
 * of the input types for Salesforce.
 *
 * Noting here that one tenant uses the same input but wants a different
 * source id according to where the pop up is displayed for the user
 * to enter information.
 */
export type EngagementSignupInput = {
  identifier1?: InputMaybe<Newsletter1SignupInput>;
  identifier2?: InputMaybe<OutOfStockInput>;
  identifier3?: InputMaybe<Newsletter2SignupInput>;
  identifier4?: InputMaybe<Newsletter3SignupInput>;
  identifier5?: InputMaybe<SmsInput>;
  identifier6?: InputMaybe<SmsInputLoggedUser>;
  identifier7?: InputMaybe<CustomDataInput>;
  identifier8?: InputMaybe<StockNotificationInput>;
};

export type ErrorModalLocalization = {
  __typename?: 'ErrorModalLocalization';
  errorHeadingText: Scalars['String'];
  okText: Scalars['String'];
  visitOurLinkForAssistanceText: Scalars['String'];
};

export type ExchangeReturnByDateLocalization = {
  __typename?: 'ExchangeReturnByDateLocalization';
  exchangeText: Scalars['String'];
  returnByText: Scalars['String'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type FieldMeasure = {
  __typename?: 'FieldMeasure';
  eqv?: Maybe<Scalars['Int']>;
  eunit?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type FindAddressInput = {
  container?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type FooterLocalization = {
  __typename?: 'FooterLocalization';
  allRightsReserved: Scalars['String'];
};

export type FormsAccountLocalization = {
  __typename?: 'FormsAccountLocalization';
  firstNameLabel: Scalars['String'];
  lastNameLabel: Scalars['String'];
};

export type FormsAddressLocalization = {
  __typename?: 'FormsAddressLocalization';
  autocompletePlaceholderText: Scalars['String'];
  cardholderNameLabel: Scalars['String'];
  cityLabel: Scalars['String'];
  companyLabel: Scalars['String'];
  countryLabel: Scalars['String'];
  emailLabel: Scalars['String'];
  firstNameLabel: Scalars['String'];
  isDefaultLabel: Scalars['String'];
  lastNameLabel: Scalars['String'];
  line1Label: Scalars['String'];
  line2Label: Scalars['String'];
  manuallyEnterAddressText: Scalars['String'];
  nicknameLabel: Scalars['String'];
  phoneLabel: Scalars['String'];
  phoneNumberLabel: Scalars['String'];
  regionText: Scalars['String'];
  requiredFieldsText: Scalars['String'];
  requiredText: Scalars['String'];
  specialInstructionsLabel: Scalars['String'];
  stateLabel: Scalars['String'];
  taxIdLabel: Scalars['String'];
  zipLabel: Scalars['String'];
};

export type FormsCreditCardLocalization = {
  __typename?: 'FormsCreditCardLocalization';
  cardNumberLabel: Scalars['String'];
  cardSavedForGasExchangeNote: Scalars['String'];
  cardSavedForSubsNote: Scalars['String'];
  cardholderNameLabel: Scalars['String'];
  cvvLabel: Scalars['String'];
  cvvTooltip?: Maybe<CreditCardTooltipLocalization>;
  expirationDateLabel: Scalars['String'];
  saveCardForLaterText: Scalars['String'];
  securityNote: Scalars['String'];
};

export type FormsForgotPasswordLocalization = {
  __typename?: 'FormsForgotPasswordLocalization';
  backToLoginText: Scalars['String'];
  contactLinkContentText: Scalars['String'];
  contactLinkText: Scalars['String'];
  emailLabelText: Scalars['String'];
  formDescriptionText: Scalars['String'];
  headingText: Scalars['String'];
  submitButtonText: Scalars['String'];
  submittedText: Scalars['String'];
};

export type FormsLocalization = {
  __typename?: 'FormsLocalization';
  account?: Maybe<FormsAccountLocalization>;
  address?: Maybe<FormsAddressLocalization>;
  creditCard?: Maybe<FormsCreditCardLocalization>;
  forgotPassword?: Maybe<FormsForgotPasswordLocalization>;
  resetPassword?: Maybe<FormsResetPasswordLocalization>;
  signIn?: Maybe<FormsSignInLocalization>;
  signup?: Maybe<FormsSignupLocalization>;
  tos?: Maybe<FormsTosLocalization>;
  validation?: Maybe<FormsValidationLocalization>;
};

export type FormsResetPasswordLocalization = {
  __typename?: 'FormsResetPasswordLocalization';
  contactLinkContentText: Scalars['String'];
  contactLinkText: Scalars['String'];
  headingText: Scalars['String'];
  passwordInputLabelText: Scalars['String'];
  requestNewLinkContentText: Scalars['String'];
  requestNewLinkText: Scalars['String'];
  resetTokenDefaultErrorText: Scalars['String'];
  resetTokenExpiredErrorText: Scalars['String'];
  resetTokenIdErrorText: Scalars['String'];
  resetTokenMismatchErrorText: Scalars['String'];
  resetTokenNotFoundErrorText: Scalars['String'];
  resetTokenUnableToDecodeErrorText: Scalars['String'];
  submitText: Scalars['String'];
};

export type FormsSignInLocalization = {
  __typename?: 'FormsSignInLocalization';
  accountLockedErrorText: Scalars['String'];
  emailInputPlaceholderText: Scalars['String'];
  forgotPasswordButtonText: Scalars['String'];
  genericErrorText: Scalars['String'];
  headingDefaultText: Scalars['String'];
  headingText: Scalars['String'];
  loginButtonText: Scalars['String'];
  passwordInputPlaceholderText: Scalars['String'];
  signUpButtonText: Scalars['String'];
  signUpDefaultHeadingText: Scalars['String'];
  signUpHeadingText: Scalars['String'];
};

export type FormsSignupLocalization = {
  __typename?: 'FormsSignupLocalization';
  accountLogoAltText: Scalars['String'];
  ageRequirementErrorText: Scalars['String'];
  birthdayLabelText: Scalars['String'];
  createAccountPageHeadingText: Scalars['String'];
  dayLabelText: Scalars['String'];
  emailLabelText: Scalars['String'];
  emailOptIn?: Maybe<EmailOptInLocalization>;
  emailPlaceholderText: Scalars['String'];
  errorResetPasswordLinkText: Scalars['String'];
  errorText: Scalars['String'];
  firstNameLabelText: Scalars['String'];
  firstNamePlaceholderText: Scalars['String'];
  headingText: Scalars['String'];
  lastNameLabelText: Scalars['String'];
  lastNamePlaceholderText: Scalars['String'];
  monthLabelText: Scalars['String'];
  passwordLabelText: Scalars['String'];
  passwordPlaceholderText: Scalars['String'];
  submitText: Scalars['String'];
  yearLabelText: Scalars['String'];
};

export type FormsTosLocalization = {
  __typename?: 'FormsTosLocalization';
  body: Scalars['String'];
  errorText: Scalars['String'];
  tosLinkText: Scalars['String'];
};

export type FormsValidationLocalization = {
  __typename?: 'FormsValidationLocalization';
  companyRequiredWithTaxIdErrorText: Scalars['String'];
  dayRequiredErrorText: Scalars['String'];
  emailRequiredErrorText: Scalars['String'];
  fieldRequiredErrorText: Scalars['String'];
  invalidDateErrorText: Scalars['String'];
  invalidPasswordErrorText: Scalars['String'];
  invalidPhoneErrorText: Scalars['String'];
  invalidTaxIdErrorText: Scalars['String'];
  invalidTaxIdLengthErrorText: Scalars['String'];
  monthRequiredErrorText: Scalars['String'];
  newPasswordRequiredErrorText: Scalars['String'];
  passwordRequiredErrorText: Scalars['String'];
  requiredErrorText: Scalars['String'];
  signupPasswordRequiredErrorText: Scalars['String'];
  taxIdRequiredWithCompanyErrorText: Scalars['String'];
  wrongEmailErrorText: Scalars['String'];
  yearRequiredErrorText: Scalars['String'];
};

export type FoundAddress = {
  __typename?: 'FoundAddress';
  description?: Maybe<Scalars['String']>;
  highlight?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FoundItems = {
  __typename?: 'FoundItems';
  items?: Maybe<Array<FoundAddress>>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  externalFulfillmentId?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  items: Array<FulfillmentItem>;
  orderId?: Maybe<Scalars['UUID4']>;
  status?: Maybe<StatusLabels>;
  taxServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  tracking?: Maybe<TrackingNumber>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseCode?: Maybe<Scalars['String']>;
};

export type FulfillmentItem = {
  __typename?: 'FulfillmentItem';
  insertedAt: Scalars['DateTime'];
  item?: Maybe<Item>;
  quantity?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type GatoradeIdBottle = {
  __typename?: 'GatoradeIdBottle';
  bottleLidFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'blank', 'diy_strip', or 'text' */
  bottleLidFeatureType?: Maybe<Scalars['String']>;
  bottleLidFontColor?: Maybe<Scalars['String']>;
  bottleLidFontColorValue?: Maybe<Scalars['String']>;
  bottleLidFontType?: Maybe<Scalars['String']>;
  bottleLidLogo?: Maybe<Scalars['String']>;
  bottleLidLogoImage?: Maybe<Scalars['String']>;
  bottleLidNumber?: Maybe<Scalars['String']>;
  /** Values: 'logo' or 'number' */
  bottleLidNumberType?: Maybe<Scalars['String']>;
  bottleLidPattern?: Maybe<Scalars['String']>;
  bottleLidPrimaryColor?: Maybe<Scalars['String']>;
  bottleLidPrintFileUrl?: Maybe<Scalars['String']>;
  bottleLidSecondaryColor?: Maybe<Scalars['String']>;
  bottleLidStrokeColor?: Maybe<Scalars['String']>;
  bottleLidStrokeColorValue?: Maybe<Scalars['String']>;
  bottleLidStrokeWeight?: Maybe<Scalars['String']>;
  bottleLidThumbnailImage?: Maybe<Scalars['String']>;
  bottleSideFeatureLogo?: Maybe<Scalars['String']>;
  bottleSideFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'text' or 'logo' */
  bottleSideFeatureType?: Maybe<Scalars['String']>;
  bottleSideFontColor?: Maybe<Scalars['String']>;
  bottleSideFontColorValue?: Maybe<Scalars['String']>;
  bottleSideFontType?: Maybe<Scalars['String']>;
  bottleSideLogoUrl?: Maybe<Scalars['String']>;
  bottleSideMascotAccentColor?: Maybe<Scalars['String']>;
  bottleSideMascotAccentColorValue?: Maybe<Scalars['String']>;
  bottleSideMascotBaseColor?: Maybe<Scalars['String']>;
  bottleSideMascotBaseColorValue?: Maybe<Scalars['String']>;
  bottleSideMascotName?: Maybe<Scalars['String']>;
  bottleSideMascotNonCustomColor?: Maybe<Scalars['String']>;
  bottleSideMascotNonCustomColorValue?: Maybe<Scalars['String']>;
  bottleSidePattern?: Maybe<Scalars['String']>;
  bottleSidePatternImage?: Maybe<Scalars['String']>;
  bottleSidePrimaryColor?: Maybe<Scalars['String']>;
  bottleSidePrimaryColorValue?: Maybe<Scalars['String']>;
  bottleSidePrintFileUrl?: Maybe<Scalars['String']>;
  bottleSideSecondaryColor?: Maybe<Scalars['String']>;
  bottleSideSecondaryColorValue?: Maybe<Scalars['String']>;
  bottleSideStrokeColor?: Maybe<Scalars['String']>;
  bottleSideStrokeColorValue?: Maybe<Scalars['String']>;
  bottleSideStrokeWeight?: Maybe<Scalars['String']>;
  bottleSideThumbnailImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enhancerVariantGtin?: Maybe<Scalars['String']>;
};

export type GatoradeTowel = {
  __typename?: 'GatoradeTowel';
  text?: Maybe<Scalars['String']>;
  towelFeatureLogo?: Maybe<Scalars['String']>;
  towelFeatureText?: Maybe<Scalars['String']>;
  /** Values: 'text' or 'logo' */
  towelFeatureType?: Maybe<Scalars['String']>;
  towelFontColor?: Maybe<Scalars['String']>;
  towelFontColorValue?: Maybe<Scalars['String']>;
  towelFontType?: Maybe<Scalars['String']>;
  towelLogoUrl?: Maybe<Scalars['String']>;
  towelMascotAccentColor?: Maybe<Scalars['String']>;
  towelMascotAccentColorValue?: Maybe<Scalars['String']>;
  towelMascotBaseColor?: Maybe<Scalars['String']>;
  towelMascotBaseColorValue?: Maybe<Scalars['String']>;
  towelMascotName?: Maybe<Scalars['String']>;
  towelMascotNonCustomColor?: Maybe<Scalars['String']>;
  towelMascotNonCustomColorValue?: Maybe<Scalars['String']>;
  towelPattern?: Maybe<Scalars['String']>;
  towelPatternImage?: Maybe<Scalars['String']>;
  towelPrimaryColor?: Maybe<Scalars['String']>;
  towelPrimaryColorValue?: Maybe<Scalars['String']>;
  towelPrintFileUrl?: Maybe<Scalars['String']>;
  towelSecondaryColor?: Maybe<Scalars['String']>;
  towelSecondaryColorValue?: Maybe<Scalars['String']>;
  towelStrokeColor?: Maybe<Scalars['String']>;
  towelStrokeColorValue?: Maybe<Scalars['String']>;
  towelStrokeWeight?: Maybe<Scalars['String']>;
  towelTextLogoState?: Maybe<Scalars['String']>;
  towelThumbnailImage?: Maybe<Scalars['String']>;
};

export type GiftCardConfig = {
  __typename?: 'GiftCardConfig';
  giftCardsEnabled?: Maybe<Scalars['Boolean']>;
};

export type GiftConfig = {
  __typename?: 'GiftConfig';
  giftEmailConfig?: Maybe<GiftEmailConfig>;
  giftingEnabled?: Maybe<Scalars['Boolean']>;
};

export type GiftEmailConfig = {
  __typename?: 'GiftEmailConfig';
  centralImageUrl?: Maybe<Scalars['String']>;
  footerCopy?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
};

export type GtmConfig = {
  __typename?: 'GtmConfig';
  auth?: Maybe<Scalars['String']>;
  containerId?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
};

export type GuestCartContainsSubscriptionLocalizations = {
  __typename?: 'GuestCartContainsSubscriptionLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InsufficientLoyaltyBalanceLocalizations = {
  __typename?: 'InsufficientLoyaltyBalanceLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InvalidGiftCardLocalizations = {
  __typename?: 'InvalidGiftCardLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InvalidLoyaltyRewardLocalizations = {
  __typename?: 'InvalidLoyaltyRewardLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type InvoicedAddress = {
  __typename?: 'InvoicedAddress';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  lastName?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type Invoicing = {
  __typename?: 'Invoicing';
  addresses: Array<InvoicedAddress>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type IsGiftInput = {
  id: Scalars['UUID4'];
  isGift: Scalars['Boolean'];
};

export type Item = {
  __typename?: 'Item';
  appId: Scalars['UUID4'];
  brandName?: Maybe<Scalars['String']>;
  bundleOnly?: Maybe<Scalars['Boolean']>;
  caloriesPerPack?: Maybe<Scalars['Decimal']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  color?: Maybe<Scalars['String']>;
  compareAtPrice: Scalars['Int'];
  containerType?: Maybe<Scalars['String']>;
  countryCity?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designerBio?: Maybe<Scalars['String']>;
  dimensionUnits?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  discounts?: Maybe<Array<Maybe<Discount>>>;
  dynamicBundles?: Maybe<Array<DynamicBundle>>;
  fluidOzPerPack?: Maybe<Scalars['Decimal']>;
  gasExchangeInfo?: Maybe<ItemGasExchangeInfo>;
  gtin: Scalars['String'];
  height?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  imgUrl?: Maybe<Scalars['String']>;
  imgVariantUrls?: Maybe<Array<Maybe<ProductImageVariant>>>;
  inventoryQty?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isDairyFree?: Maybe<Scalars['Boolean']>;
  isFairTrade?: Maybe<Scalars['Boolean']>;
  isGlutenFree?: Maybe<Scalars['Boolean']>;
  isGmoFree?: Maybe<Scalars['Boolean']>;
  isKosher?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['String']>;
  isOutOfStock?: Maybe<Scalars['Boolean']>;
  isPending: Scalars['Boolean'];
  isVegan?: Maybe<Scalars['Boolean']>;
  isWheatFree?: Maybe<Scalars['Boolean']>;
  isYeastFree?: Maybe<Scalars['Boolean']>;
  isbn?: Maybe<Scalars['String']>;
  /** virtual field populated with exiting notification for a gtin */
  itemNotifications?: Maybe<Array<Maybe<Scalars['String']>>>;
  length?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  meltRisk?: Maybe<Scalars['Boolean']>;
  minOrderQty?: Maybe<Scalars['Int']>;
  nutritionData?: Maybe<NutritionData>;
  onMarketplace?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  primaryCategoryPriority?: Maybe<Scalars['Int']>;
  productPacks?: Maybe<Scalars['Int']>;
  productsPerPack?: Maybe<Scalars['Int']>;
  recommendedItems: Array<Item>;
  returnsPolicy?: Maybe<Scalars['String']>;
  secondaryCategoryPriority?: Maybe<Scalars['Int']>;
  shippingInfo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated Please use `slug` going forward. */
  slugHash?: Maybe<Scalars['String']>;
  stories?: Maybe<Array<Maybe<Story>>>;
  /** @deprecated This field will no longer return any sub_items */
  subItems?: Maybe<Array<Maybe<BundleItem>>>;
  subscriptionMetadata?: Maybe<ItemSubscriptionMetadata>;
  subscriptionOnly?: Maybe<Scalars['Boolean']>;
  sugarGramsPerPack?: Maybe<Scalars['Decimal']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  taxCodeId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated, use `Gtin` in place of `Upc` */
  upc?: Maybe<Scalars['String']>;
  variantOptions?: Maybe<Array<Maybe<ProductVariant>>>;
  vendorConfig: Tenant;
  virtual?: Maybe<Scalars['Boolean']>;
  weightOz?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type ItemGasExchangeInfo = {
  __typename?: 'ItemGasExchangeInfo';
  enabled: Scalars['Boolean'];
  missingCylinder?: Maybe<Item>;
  missingCylinderId?: Maybe<Scalars['UUID4']>;
};

export type ItemSubscriptionMetadata = {
  __typename?: 'ItemSubscriptionMetadata';
  discount?: Maybe<Discount>;
  id: Scalars['UUID4'];
  isSubscribable: Scalars['Boolean'];
  subscriptionPrice: Scalars['Int'];
};

export type ItemUnavailableLocalizations = {
  __typename?: 'ItemUnavailableLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type ItemsInput = {
  basePrice?: InputMaybe<Scalars['Int']>;
  compareAtPrice?: InputMaybe<Scalars['Int']>;
  discountAmount?: InputMaybe<Scalars['Int']>;
  discountId?: InputMaybe<Scalars['UUID4']>;
  itemId?: InputMaybe<Scalars['UUID4']>;
  quantity?: InputMaybe<Scalars['Int']>;
  taxAmount?: InputMaybe<Scalars['Int']>;
};

export type ItemsPayload = {
  __typename?: 'ItemsPayload';
  items: Array<Item>;
  pagination: PaginationData;
};

export type LatLong = {
  __typename?: 'LatLong';
  lat: Scalars['Float'];
  long: Scalars['Float'];
};

export type LegacyCustomization = {
  __typename?: 'LegacyCustomization';
  bottleCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  patternId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
};

/** Discount information as it applies to the individual line item */
export type LineItemDiscount = {
  __typename?: 'LineItemDiscount';
  amount: Scalars['Int'];
  category: LineItemDiscountCategory;
  discountId: Scalars['UUID4'];
  type: LineItemDiscountType;
};

export enum LineItemDiscountCategory {
  Basic = 'BASIC',
  BasicPromoCode = 'BASIC_PROMO_CODE',
  DynamicBundle = 'DYNAMIC_BUNDLE',
  Subscription = 'SUBSCRIPTION',
  Tiered = 'TIERED',
  TieredPromoCode = 'TIERED_PROMO_CODE'
}

export enum LineItemDiscountType {
  Flat = 'FLAT',
  Percent = 'PERCENT'
}

export type Localization = {
  __typename?: 'Localization';
  checkout?: Maybe<CheckoutLocalization>;
  components?: Maybe<ComponentsLocalization>;
  currentLocale: Scalars['String'];
  defaultLocale: Scalars['String'];
  forms?: Maybe<FormsLocalization>;
  /** @deprecated `locale` has been deprecated in favor of `defaultLocale` */
  locale: Scalars['String'];
  portal?: Maybe<PortalLocalization>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LowStockLocalizations = {
  __typename?: 'LowStockLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type LoyaltyConfig = {
  __typename?: 'LoyaltyConfig';
  loyaltyProgramActive: Scalars['Boolean'];
};

/** loyalty data aggregation at Cart and Price level. Will contain total points redeemed, total amount of dollars, and points earned */
export type LoyaltyData = {
  __typename?: 'LoyaltyData';
  totalAmount?: Maybe<Scalars['Int']>;
  totalEarnedPoints?: Maybe<Scalars['Int']>;
  totalPoints?: Maybe<Scalars['Int']>;
};

export type LoyaltyItemInput = {
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
};

export type LoyaltyPurchaseInput = {
  loyaltyItems: Array<InputMaybe<LoyaltyItemInput>>;
  rewardId: Scalars['String'];
  rewardQuantity: Scalars['Int'];
  shippingAddressId: Scalars['UUID4'];
};

/** loyalty reward the user has applied to their cart. */
export type LoyaltyReward = {
  __typename?: 'LoyaltyReward';
  code: Scalars['String'];
  quantity: Scalars['Int'];
  totalAmount: Scalars['Int'];
  totalPoints: Scalars['Int'];
};

export type LoyaltyRewardInput = {
  code: Scalars['String'];
  quantity: Scalars['Int'];
};

export type LoyaltyRewardInputByPepdirectRewardId = {
  pepdirectRewardId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type MailingAddressInput = {
  city: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  streetAddress1: Scalars['String'];
  streetAddress2?: InputMaybe<Scalars['String']>;
};

export type Merchandise = {
  __typename?: 'Merchandise';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Module = {
  __typename?: 'Module';
  body?: Maybe<Scalars['String']>;
  coverPhotoUrl?: Maybe<Scalars['String']>;
  cta1?: Maybe<Scalars['String']>;
  cta2?: Maybe<Scalars['String']>;
  cta3?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  isApproved?: Maybe<Scalars['Boolean']>;
  itemOrdering: Array<ModuleItem>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedTime?: Maybe<Scalars['String']>;
  story?: Maybe<Story>;
  storySlug: Scalars['String'];
  thumbnailItems: Array<ModuleThumbnailItem>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  title3?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  urlOverride?: Maybe<Scalars['String']>;
};

export type ModuleItem = {
  __typename?: 'ModuleItem';
  item?: Maybe<Item>;
  module?: Maybe<Module>;
  order?: Maybe<Scalars['Int']>;
};

export type ModuleThumbnailItem = {
  __typename?: 'ModuleThumbnailItem';
  id?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type Newsletter1SignupInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type Newsletter2SignupInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type Newsletter3SignupInput = {
  dateOfBirth: Scalars['Date'];
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

export type NutritionData = {
  __typename?: 'NutritionData';
  code?: Maybe<Scalars['String']>;
  ingredientsTextEn?: Maybe<Scalars['String']>;
  nutrients?: Maybe<Array<Maybe<NutritionField>>>;
};

export type NutritionField = {
  __typename?: 'NutritionField';
  derivation?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  measures?: Maybe<Array<Maybe<FieldMeasure>>>;
  name?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OrangeTheoryInquiryInput = {
  city: Scalars['String'];
  comments?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  marketingSupportType: Scalars['String'];
  state: Scalars['String'];
  streetAddressOne: Scalars['String'];
  streetAddressTwo?: InputMaybe<Scalars['String']>;
  studioName: Scalars['String'];
  zip: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  /**
   * Composite Order Ids will be in the format `customer_po-internal_order_id`. If
   * the customer PO field is null, it'll just be the `internal_order_id`
   * @deprecated The display_name field now represents the user visible order identifier/label
   * which is either explicitly set in the record or computed via the composite
   * order id logic. This obviates the need for the composite_id field.
   *
   */
  compositeId?: Maybe<Scalars['String']>;
  contactInfo: ContactInfo;
  /**
   * The display name represents the user visible order label which identifies
   * the order to an end-user. This is either explicitly set in the
   * display_name_override column on the order or is computed as a composite of
   * the purchase order id (if any) and the internal order id.
   */
  displayName?: Maybe<Scalars['String']>;
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  externalOrderId?: Maybe<Scalars['String']>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  internalOrderId: Scalars['Int'];
  /**
   * Some orders are managed or "owned" by a different system. These orders are
   * sometimes imported into this system for tracking and reporting purposes but
   * don't have active workflows or fulfillment processes hooked up. This allows
   * these orders to be displayed with special notices in the UI.
   */
  isExternalOrder?: Maybe<Scalars['Boolean']>;
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type OrderInput = {
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
};

export type OrderProcessing = {
  __typename?: 'OrderProcessing';
  headingText: Scalars['String'];
  subHeadingText: Scalars['String'];
};

export type OrderSubscription = {
  __typename?: 'OrderSubscription';
  address: Address;
  /** @deprecated Please use status/status_reason */
  cancelReason?: Maybe<Scalars['String']>;
  /** @deprecated Please use status_updated_at */
  canceledAt?: Maybe<Scalars['Date']>;
  id: Scalars['UUID4'];
  initialOrderDate?: Maybe<Scalars['DateTime']>;
  insertedAt: Scalars['DateTime'];
  intervalInDays: Scalars['Int'];
  lastOrderAttempt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Please use last_successful_order_date */
  lastSuccessfulOrder: Scalars['Date'];
  lastSuccessfulOrderDate: Scalars['Date'];
  /** @deprecated Please use next_order_creation_date */
  nextDeliveryDate: Scalars['Date'];
  nextOrderCreationDates: Array<Maybe<Scalars['Date']>>;
  orderSubscriptionItems: Array<OrderSubscriptionItem>;
  originatingOrder?: Maybe<SubmittedOrder>;
  paymentInfo: PaymentInfo;
  price: SubscriptionPrice;
  status: OrderSubscriptionStatusNames;
  statusReason?: Maybe<Scalars['String']>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
  vendorConfig: Tenant;
};

export type OrderSubscriptionItem = {
  __typename?: 'OrderSubscriptionItem';
  orderSubscription: OrderSubscription;
  priceItem: PriceItem;
  quantity?: Maybe<Scalars['Int']>;
};

export enum OrderSubscriptionRelationshipNames {
  /** Order that was a direct result of a subscription execution */
  Child = 'CHILD',
  /** Order with no relationship to any subscriptions */
  None = 'NONE',
  /** Order that resulted in subscriptions being made (priceItem had > 0 subscription_interval_in_days values) */
  Parent = 'PARENT'
}

export enum OrderSubscriptionStatusNames {
  /** Subscription is active and in valid state to fulfill */
  Active = 'ACTIVE',
  /** Subscription is canceled for reason stated in `status_reason` */
  Canceled = 'CANCELED',
  /** Subscription is paused for reason stated in `status_reason` */
  Paused = 'PAUSED'
}

export type OrderSubscriptionsPayload = {
  __typename?: 'OrderSubscriptionsPayload';
  orderSubscriptions: Array<OrderSubscription>;
};

export type OutOfStockInput = {
  email: Scalars['String'];
  emailOptIn: Scalars['Boolean'];
  gtin: Scalars['String'];
};

export type OutOfStockLocalizations = {
  __typename?: 'OutOfStockLocalizations';
  cartText: Scalars['String'];
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type Pagination = {
  __typename?: 'Pagination';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  nextPageLink?: Maybe<Scalars['String']>;
  pages?: Maybe<Scalars['Int']>;
  prevPageLink?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type PaginationData = {
  __typename?: 'PaginationData';
  count: Scalars['Int'];
  page: Scalars['Int'];
  total: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginationInput = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
};

/**
 * Takes advantage of the oneOf custom directive that
 * enforces fields based on the base key for the input
 * type.
 */
export type PartnerInquiryInput = {
  orangeTheory?: InputMaybe<OrangeTheoryInquiryInput>;
};

export type PasswordRequirement = {
  __typename?: 'PasswordRequirement';
  msg: Scalars['String'];
  satisfied: Scalars['Boolean'];
};

export type PasswordRequirementDoubleCondition = {
  __typename?: 'PasswordRequirementDoubleCondition';
  bodyText: Scalars['String'];
  boldText1: Scalars['String'];
  boldText2: Scalars['String'];
};

export type PasswordRequirementSingleCondition = {
  __typename?: 'PasswordRequirementSingleCondition';
  bodyText: Scalars['String'];
  boldText: Scalars['String'];
};

export type PaymentClientTokenPayload = {
  __typename?: 'PaymentClientTokenPayload';
  token: Scalars['String'];
};

export type PaymentConfig = {
  __typename?: 'PaymentConfig';
  availablePaymentMethods?: Maybe<Array<Scalars['String']>>;
  billingAddressConfig: AddressConfig;
  descriptor?: Maybe<Scalars['String']>;
  paymentTypes: Array<PaymentType>;
  processor?: Maybe<PaymentProcessor>;
  publicPaymentToken?: Maybe<Scalars['String']>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  cardExpirationDate?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodNames>;
  paymentType?: Maybe<Scalars['String']>;
  paypalEmail?: Maybe<Scalars['String']>;
  uniqueNumberIdentifier?: Maybe<Scalars['String']>;
};

/** object for holding a single default payment method */
export type PaymentMethod = ApplePayCard | CreditCard | PaypalAccount;

export enum PaymentMethodEnum {
  CreditCard = 'CREDIT_CARD',
  Paypal = 'PAYPAL'
}

export enum PaymentMethodNames {
  /** Apple Pay Card */
  ApplePay = 'APPLE_PAY',
  /** Credit Card */
  CreditCard = 'CREDIT_CARD',
  /** Paypal Account */
  Paypal = 'PAYPAL'
}

/** object defined to hold the different payment methods */
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  applePayCards?: Maybe<Array<ApplePayCard>>;
  creditCards?: Maybe<Array<CreditCard>>;
  default?: Maybe<PaymentMethod>;
  paypalAccounts?: Maybe<Array<PaypalAccount>>;
};

export type PaymentOptionsInput = {
  default?: InputMaybe<Scalars['Boolean']>;
  deviceData?: InputMaybe<Scalars['String']>;
  nonce?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  token?: InputMaybe<Scalars['String']>;
};

export enum PaymentProcessor {
  Braintree = 'braintree',
  Stripe = 'stripe'
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  billingAddress?: Maybe<EmbeddedAddress>;
  isBillingEqualShipping?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
};

export type PaymentRequestInput = {
  billingAddress?: InputMaybe<EmbeddedAddressInput>;
  deviceData?: InputMaybe<Scalars['String']>;
  isBillingEqualShipping?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  saveCardForLater?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  brandImgUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type PaypalAccount = {
  __typename?: 'PaypalAccount';
  billingAgreementId: Scalars['String'];
  createdAt: Scalars['String'];
  customerId: Scalars['String'];
  default: Scalars['Boolean'];
  email: Scalars['String'];
  imageUrl: Scalars['String'];
  isChannelInitated?: Maybe<Scalars['Boolean']>;
  isRemovable: Scalars['Boolean'];
  payerInfo?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  token: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PhoneNumberCountryCodesAllowed = {
  __typename?: 'PhoneNumberCountryCodesAllowed';
  code: Scalars['String'];
  country: Scalars['String'];
  length: Scalars['Int'];
};

export type PortalAccountPageLocalization = {
  __typename?: 'PortalAccountPageLocalization';
  activeAccountHeadingText: Scalars['String'];
  addressesHeadingText: Scalars['String'];
  defaultTitleText: Scalars['String'];
  emailHeadingText: Scalars['String'];
  nameHeadingText: Scalars['String'];
  nameUpdateButtonText: Scalars['String'];
  nameUpdateCancelButtonText: Scalars['String'];
  nameUpdateSubmitButtonText: Scalars['String'];
  passwordChangeButtonText: Scalars['String'];
  passwordHeadingText: Scalars['String'];
  paymentsHeadingText: Scalars['String'];
};

export type PortalAddressLocalization = {
  __typename?: 'PortalAddressLocalization';
  addHeadingText: Scalars['String'];
  addSubmitButtonText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  editHeadingText: Scalars['String'];
  makeDefaultText: Scalars['String'];
  updateSubmitButtonText: Scalars['String'];
};

export type PortalAltsLocalization = {
  __typename?: 'PortalAltsLocalization';
  accountAltText: Scalars['String'];
  shopLogoAltText: Scalars['String'];
};

export type PortalBreadcrumbsLocalization = {
  __typename?: 'PortalBreadcrumbsLocalization';
  account: Scalars['String'];
  accountDetails: Scalars['String'];
  addAddress: Scalars['String'];
  addPayment: Scalars['String'];
  changePassword: Scalars['String'];
  editAddress: Scalars['String'];
  exchange: Scalars['String'];
  exchangeDetails: Scalars['String'];
  machines: Scalars['String'];
  notFound: Scalars['String'];
  orders: Scalars['String'];
  shippingAddresses: Scalars['String'];
  subscriptions: Scalars['String'];
};

export type PortalCardLocalization = {
  __typename?: 'PortalCardLocalization';
  addAddressLabel: Scalars['String'];
  addPaymentLabel: Scalars['String'];
  allocationText: Scalars['String'];
  creditCardNumberText: Scalars['String'];
  currentLabel: Scalars['String'];
  defaultAddressLabel: Scalars['String'];
  defaultPaymentLabel: Scalars['String'];
  deleteButtonText: Scalars['String'];
  editButtonText: Scalars['String'];
  makeDefaultButtonText: Scalars['String'];
  numRemainingLabel: Scalars['String'];
  selectLabel: Scalars['String'];
  subscriptionAddressButtonText: Scalars['String'];
  viewAllButtonText: Scalars['String'];
};

export type PortalErrorsAddressVerificationLocalization = {
  __typename?: 'PortalErrorsAddressVerificationLocalization';
  checkoutSpecificConfirmSuggestedText: Scalars['String'];
  confirmSuggestedAddressText: Scalars['String'];
  confirmText: Scalars['String'];
  doYouWantToProceedText: Scalars['String'];
  editEnteredAddressText: Scalars['String'];
  editText: Scalars['String'];
  enteredAddressText: Scalars['String'];
  goBackText: Scalars['String'];
  invalidZipCodeText: Scalars['String'];
  keepEnteredAddressText: Scalars['String'];
  notAbleToVerifyShippingAddressText: Scalars['String'];
  recommendChangesText: Scalars['String'];
  shippingAddressText: Scalars['String'];
  suggestedAddressText: Scalars['String'];
  useSuggestedAddressText: Scalars['String'];
  verifyText: Scalars['String'];
};

export type PortalErrorsGeoblockLocalization = {
  __typename?: 'PortalErrorsGeoblockLocalization';
  apiError: Scalars['String'];
  zipBlocked: Scalars['String'];
};

export type PortalErrorsLocalization = {
  __typename?: 'PortalErrorsLocalization';
  addressVerification?: Maybe<PortalErrorsAddressVerificationLocalization>;
  geoBlock?: Maybe<PortalErrorsGeoblockLocalization>;
};

export type PortalExchangeDetailsPageLocalization = {
  __typename?: 'PortalExchangeDetailsPageLocalization';
  avoidDepositFeesWarningTextFractional: Scalars['String'];
  avoidDepositFeesWarningTextMany: Scalars['String'];
  avoidDepositFeesWarningTextPlural: Scalars['String'];
  avoidDepositFeesWarningTextSingular: Scalars['String'];
  daysLeftToReturnHeadingText: Scalars['String'];
  daysLeftToReturnTextPlural: Scalars['String'];
  daysLeftToReturnTextSingular: Scalars['String'];
  depositFeeAddedAlertText: Scalars['String'];
  depositFeeAddedText: Scalars['String'];
  exchangeDetailsText: Scalars['String'];
  expectedReturnDateText: Scalars['String'];
  extendReturnDeadlineText: Scalars['String'];
  missedReturnDateText: Scalars['String'];
  notFoundMsg: Scalars['String'];
  orderDetailsHeadingText: Scalars['String'];
  orderedText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  returnByText: Scalars['String'];
  returnDateExtendedText: Scalars['String'];
  returnDateText: Scalars['String'];
  returnedOnText: Scalars['String'];
  returnedOutOfTotalText: Scalars['String'];
  returnedText: Scalars['String'];
  shippingHeadingText: Scalars['String'];
  statusText: Scalars['String'];
  yourOrderText: Scalars['String'];
};

export type PortalExchangeListPageLocalization = {
  __typename?: 'PortalExchangeListPageLocalization';
  active: Scalars['String'];
  closed: Scalars['String'];
  cylinderText: Scalars['String'];
  dueInDaysTextPlural: Scalars['String'];
  dueInDaysTextSingular: Scalars['String'];
  gasExchangeListTitle: Scalars['String'];
  gasExchangePageListTitle: Scalars['String'];
  orderDate: Scalars['String'];
  returnByDate: Scalars['String'];
  returnPastDue: Scalars['String'];
  returnedDate: Scalars['String'];
  viewDetails: Scalars['String'];
};

export type PortalHeaderLocalization = {
  __typename?: 'PortalHeaderLocalization';
  signOutLinkText: Scalars['String'];
};

/**
 * Returns a map of all portal (my account) elements and their translations.
 *
 * Example:
 *     ```
 *     query {
 *       localization {
 *         portal {
 *           accountPage {
 *             nameHeadingText
 *           }
 *         }
 *       }
 *     }
 *     ```
 */
export type PortalLocalization = {
  __typename?: 'PortalLocalization';
  accountPage?: Maybe<PortalAccountPageLocalization>;
  accountVerification?: Maybe<AccountVerificationLocalization>;
  address?: Maybe<PortalAddressLocalization>;
  alts?: Maybe<PortalAltsLocalization>;
  breadcrumbs?: Maybe<PortalBreadcrumbsLocalization>;
  card?: Maybe<PortalCardLocalization>;
  errors?: Maybe<PortalErrorsLocalization>;
  exchangeDetailPage?: Maybe<PortalExchangeDetailsPageLocalization>;
  exchangeList?: Maybe<PortalExchangeListPageLocalization>;
  header?: Maybe<PortalHeaderLocalization>;
  machinesPage?: Maybe<PortalMachinesPageLocalization>;
  notAvailable?: Maybe<PortalNotAvailableLocalization>;
  orderDetailPage?: Maybe<PortalOrderDetailPageLocalization>;
  orderSummary?: Maybe<PortalOrderSummaryLocalization>;
  ordersPage?: Maybe<PortalOrdersPageLocalization>;
  pageTitlesInHead?: Maybe<PortalPageTitlesInHeadLocalization>;
  password?: Maybe<PortalPasswordLocalization>;
  payment?: Maybe<PortalPaymentLocalization>;
  subscriptionDetailPage?: Maybe<PortalSubscriptionDetailPageLocalization>;
  subscriptionsPage?: Maybe<PortalSubscriptionsPageLocalization>;
};

export type PortalMachinesPageLocalization = {
  __typename?: 'PortalMachinesPageLocalization';
  addMachinesText: Scalars['String'];
  areYouSureDeleteThisMachineText: Scalars['String'];
  cancelText: Scalars['String'];
  confirmDeletionText: Scalars['String'];
  deleteMachineText: Scalars['String'];
  getGasText: Scalars['String'];
  learnAboutSparklingWaterMakersText: Scalars['String'];
  machineText: Scalars['String'];
  machinesText: Scalars['String'];
  registerYourMachineNowText: Scalars['String'];
  troubleshootingGuideText: Scalars['String'];
  unlockWarrantyText: Scalars['String'];
  userManualText: Scalars['String'];
  warrantyExpiredText: Scalars['String'];
  warrantyExpiresText: Scalars['String'];
  yesDeleteThisMachineText: Scalars['String'];
};

export type PortalNotAvailableLocalization = {
  __typename?: 'PortalNotAvailableLocalization';
  exchanges: Scalars['String'];
  headingText: Scalars['String'];
  linkContentText: Scalars['String'];
  linkText: Scalars['String'];
  naAbbreviationText: Scalars['String'];
  orders: Scalars['String'];
  subscriptions: Scalars['String'];
};

export type PortalOrderDetailPageLocalization = {
  __typename?: 'PortalOrderDetailPageLocalization';
  dateText: Scalars['String'];
  invoiceNote: Scalars['String'];
  notFoundErrorText: Scalars['String'];
  orderIdHeadingText: Scalars['String'];
  orderSummaryHeadingText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  printButtonText: Scalars['String'];
  questionAboutOrderNumberText: Scalars['String'];
  questionAboutOrderText: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
  trackingText: Scalars['String'];
};

export type PortalOrderSummaryLocalization = {
  __typename?: 'PortalOrderSummaryLocalization';
  estimatedFeeLabel: Scalars['String'];
  estimatedTaxLabel: Scalars['String'];
  feeLabel: Scalars['String'];
  freeShipLabel: Scalars['String'];
  shippingLabel: Scalars['String'];
  subtotalLabel: Scalars['String'];
  totalLabel: Scalars['String'];
};

export type PortalOrdersPageLocalization = {
  __typename?: 'PortalOrdersPageLocalization';
  dateHeadingText: Scalars['String'];
  exchangeText: Scalars['String'];
  orderIdHeadingText: Scalars['String'];
  ordersHeadingText: Scalars['String'];
  receiptButtonText: Scalars['String'];
  reorderButtonText: Scalars['String'];
  reorderErrorNote: Scalars['String'];
  shippingAddressHeadingText: Scalars['String'];
  totalHeadingText: Scalars['String'];
};

export type PortalPageTitlesInHeadLocalization = {
  __typename?: 'PortalPageTitlesInHeadLocalization';
  verifyAccount: Scalars['String'];
};

export type PortalPasswordLocalization = {
  __typename?: 'PortalPasswordLocalization';
  backButtonText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  changePasswordCancelButtonText: Scalars['String'];
  changePasswordHeadingText: Scalars['String'];
  changePasswordSubmitButtonText: Scalars['String'];
  checkYourEmailContentText: Scalars['String'];
  checkYourEmailHeadingText: Scalars['String'];
  currentPasswordLabelText: Scalars['String'];
  forgotPasswordHeadingText: Scalars['String'];
  forgotPasswordHeadingWithTenantText: Scalars['String'];
  minCharactersText: PasswordRequirementSingleCondition;
  newPasswordLabelText: Scalars['String'];
  oneSpecialCharText: PasswordRequirementSingleCondition;
  oneUppercaseOneLowercaseAlphaText: PasswordRequirementDoubleCondition;
  passwordUpdatedBannerText: Scalars['String'];
  resetPasswordHeadingText: Scalars['String'];
  resetPasswordHeadingWithTenantText: Scalars['String'];
  twoNumericDigitsText: PasswordRequirementSingleCondition;
  updatePasswordHeadingText: Scalars['String'];
};

export type PortalPaymentLocalization = {
  __typename?: 'PortalPaymentLocalization';
  addHeadingText: Scalars['String'];
  billingSameAsShippingText: Scalars['String'];
  cancelButtonText: Scalars['String'];
  creditCardSelectorText: Scalars['String'];
  makeDefaultText: Scalars['String'];
  paypalSelectorText: Scalars['String'];
  submitButtonText: Scalars['String'];
};

export type PortalSubscriptionDetailPageLocalization = {
  __typename?: 'PortalSubscriptionDetailPageLocalization';
  addressHeadingText: Scalars['String'];
  backButtonText: Scalars['String'];
  cancelHeadingSubText: Scalars['String'];
  cancelHeadingText: Scalars['String'];
  cancelLabel: Scalars['String'];
  cancelSubscriptionButtonText: Scalars['String'];
  canceledText: Scalars['String'];
  closeButtonText: Scalars['String'];
  editAddressButtonText: Scalars['String'];
  editPaymentButtonText: Scalars['String'];
  intervalHeadingText: Scalars['String'];
  intervalText: Scalars['String'];
  manageSubscriptionLabel: Scalars['String'];
  needToStartNewLabel: Scalars['String'];
  nextDeliveryDateHeadingText: Scalars['String'];
  nextShipmentDateText: Scalars['String'];
  noLongerNeedLabel: Scalars['String'];
  orderedAtHeadingText: Scalars['String'];
  otherLabel: Scalars['String'];
  pausedBannerText: Scalars['String'];
  pausedText: Scalars['String'];
  paymentHeadingText: Scalars['String'];
  paymentUpdateButtonText: Scalars['String'];
  paymentUpdateNeededText: Scalars['String'];
  priceNoteText: Scalars['String'];
  reasonForCancelingLabel: Scalars['String'];
  reasonForCancelingPlaceholder: Scalars['String'];
  renameLabel: Scalars['String'];
  resumeLabel: Scalars['String'];
  resumedBannerText: Scalars['String'];
  shippingIssueLabel: Scalars['String'];
  skipHeadingText: Scalars['String'];
  skipLabel: Scalars['String'];
  skipNextShipmentButtonText: Scalars['String'];
  skippedBannerText: Scalars['String'];
  skippedShipmentDateText: Scalars['String'];
  subscriptionNotFoundText: Scalars['String'];
  subscriptionText: Scalars['String'];
};

export type PortalSubscriptionsPageLocalization = {
  __typename?: 'PortalSubscriptionsPageLocalization';
  actionRequiredLabel: Scalars['String'];
  canceledLabel: Scalars['String'];
  headingText: Scalars['String'];
  intervalText: Scalars['String'];
  nextDeliveryDateText: Scalars['String'];
  noSubscriptionsFoundText: Scalars['String'];
  pausedLabel: Scalars['String'];
};

export type PotentialPoints = {
  __typename?: 'PotentialPoints';
  totalPointsAwarded: Scalars['Int'];
};

export type PotentialPointsInput = {
  items: Array<InputMaybe<PotentialPointsItemInput>>;
};

export type PotentialPointsItemInput = {
  price: Scalars['Int'];
  quantity: Scalars['Int'];
  upc: Scalars['String'];
};

export type Price = {
  __typename?: 'Price';
  discount?: Maybe<Scalars['Int']>;
  discounts: Array<Discount>;
  dynamicBundles?: Maybe<Scalars['Json']>;
  giftCards?: Maybe<Array<Maybe<EmbeddedGiftCard>>>;
  id?: Maybe<Scalars['UUID4']>;
  items: Array<PriceItem>;
  priceDiscounts: Array<PriceDiscount>;
  shipping?: Maybe<Scalars['Int']>;
  subtotal?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
  total?: Maybe<Scalars['Int']>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  discount?: Maybe<Discount>;
  price?: Maybe<Price>;
};

export type PriceInput = {
  discount?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Array<InputMaybe<DiscountsInput>>>;
  items?: InputMaybe<Array<InputMaybe<ItemsInput>>>;
  shipping?: InputMaybe<Scalars['Int']>;
  subtotal?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
};

export type PriceItem = {
  __typename?: 'PriceItem';
  basePrice?: Maybe<Scalars['Int']>;
  compareAtPrice?: Maybe<Scalars['Int']>;
  /** Item in it's current state (may differ from embedded item) */
  currentItem?: Maybe<Item>;
  customizations?: Maybe<Scalars['Json']>;
  discountAmount?: Maybe<Scalars['Int']>;
  id: Scalars['UUID4'];
  /** Item as it was when purchased */
  item?: Maybe<EmbeddedItem>;
  itemId?: Maybe<Scalars['UUID4']>;
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Int']>;
  /** @deprecated This field should not be used nor relied upon */
  shippingAmount?: Maybe<Scalars['Int']>;
  subscriptionIntervalInDays?: Maybe<Scalars['Int']>;
  taxAmount?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type PriceLocalization = {
  __typename?: 'PriceLocalization';
  eachPriceText: Scalars['String'];
  regularPriceText: Scalars['String'];
};

export type ProductImageVariant = {
  __typename?: 'ProductImageVariant';
  item?: Maybe<Item>;
  pos?: Maybe<Scalars['Int']>;
  src?: Maybe<Scalars['String']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  item?: Maybe<Item>;
  variant?: Maybe<Item>;
  variantOptions?: Maybe<Array<Maybe<ProductVariantOption>>>;
};

export type ProductVariantOption = {
  __typename?: 'ProductVariantOption';
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  productVariant?: Maybe<ProductVariant>;
  value?: Maybe<Scalars['String']>;
};

export type PurchaseQtyLimitLocalizations = {
  __typename?: 'PurchaseQtyLimitLocalizations';
  cartText: Scalars['String'];
};

export type Question = {
  __typename?: 'Question';
  allowOther?: Maybe<Scalars['Boolean']>;
  answerOptions?: Maybe<Scalars['Json']>;
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  questionType?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type QuestionResponse = {
  __typename?: 'QuestionResponse';
  other?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  selectedAnswers?: Maybe<Array<Maybe<Scalars['Int']>>>;
  textAnswer?: Maybe<Scalars['String']>;
};

export type ReceiptInfo = {
  __typename?: 'ReceiptInfo';
  dateSubmitted?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  scanResult?: Maybe<Scalars['String']>;
  scanResultText?: Maybe<Scalars['String']>;
};

export type ReceiptInfoHistory = {
  __typename?: 'ReceiptInfoHistory';
  pagination?: Maybe<Pagination>;
  receipts?: Maybe<Array<Maybe<ReceiptInfo>>>;
};

export type RedeemRewardByPepdirectRewardIdInput = {
  pepdirectRewardId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type RedeemRewardInput = {
  quantity: Scalars['Int'];
  rewardId: Scalars['String'];
};

export type Redemption = {
  __typename?: 'Redemption';
  categoryId?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endingBalance: Scalars['String'];
  extraData?: Maybe<Scalars['Json']>;
  groupId?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  rewardId: Scalars['String'];
  rewardTitle?: Maybe<Scalars['String']>;
  totalPointsRedeemed: Scalars['Int'];
};

export type RedemptionInfoHistory = {
  __typename?: 'RedemptionInfoHistory';
  pagination?: Maybe<Pagination>;
  redemptions?: Maybe<Array<Maybe<Redemption>>>;
};

export type RegistrationRecord = {
  __typename?: 'RegistrationRecord';
  customData?: Maybe<Scalars['Json']>;
  emailOptIn?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  item: Item;
  itemId: Scalars['UUID4'];
  newUser: Scalars['Boolean'];
  order?: Maybe<SubmittedOrder>;
  orderId?: Maybe<Scalars['UUID4']>;
  purchaseDate?: Maybe<Scalars['Date']>;
  purchaseLocation: Scalars['String'];
  registeredAt: Scalars['DateTime'];
  source: Scalars['String'];
  status: StatusType;
  tenant: Tenant;
  tenantId: Scalars['UUID4'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['UUID4'];
  utmData?: Maybe<UtmData>;
  warrantyExpirationDate?: Maybe<Scalars['Date']>;
};

/**
 * Inputs for requesting Password Reset for a User.
 *
 * The `state` field is used to pass information back to the browser when
 * as User clicks on the password reset link in their email. The state is
 * included as a query string appended to the URL. The value of `state` can
 * be any string, as long as it is URL safe.
 *
 * The API does not inspect or manipulate the `state`, it is simply passed
 * to the password reset link.
 */
export type RequestPasswordResetForUserInput = {
  email: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type RequestPasswordResetForUserPayload = {
  __typename?: 'RequestPasswordResetForUserPayload';
  email: Scalars['String'];
};

export type ResetUserPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type RestrictedItemsByZipCodePayload = {
  __typename?: 'RestrictedItemsByZipCodePayload';
  restrictedItems: Array<Item>;
};

export type RetrievedAddress = {
  __typename?: 'RetrievedAddress';
  adminAreaCode?: Maybe<Scalars['String']>;
  adminAreaName?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  buildingName?: Maybe<Scalars['String']>;
  buildingNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  dataLevel?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  domesticId?: Maybe<Scalars['String']>;
  field1?: Maybe<Scalars['String']>;
  field2?: Maybe<Scalars['String']>;
  field3?: Maybe<Scalars['String']>;
  field4?: Maybe<Scalars['String']>;
  field5?: Maybe<Scalars['String']>;
  field6?: Maybe<Scalars['String']>;
  field7?: Maybe<Scalars['String']>;
  field8?: Maybe<Scalars['String']>;
  field9?: Maybe<Scalars['String']>;
  field10?: Maybe<Scalars['String']>;
  field11?: Maybe<Scalars['String']>;
  field12?: Maybe<Scalars['String']>;
  field13?: Maybe<Scalars['String']>;
  field14?: Maybe<Scalars['String']>;
  field15?: Maybe<Scalars['String']>;
  field16?: Maybe<Scalars['String']>;
  field17?: Maybe<Scalars['String']>;
  field18?: Maybe<Scalars['String']>;
  field19?: Maybe<Scalars['String']>;
  field20?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  languageAlternatives?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  line3?: Maybe<Scalars['String']>;
  line4?: Maybe<Scalars['String']>;
  line5?: Maybe<Scalars['String']>;
  neighbourhood?: Maybe<Scalars['String']>;
  poBoxNumber?: Maybe<Scalars['String']>;
  secondaryStreet?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  subBuilding?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type RetrievedItems = {
  __typename?: 'RetrievedItems';
  items?: Maybe<Array<RetrievedAddress>>;
};

export type Reward = {
  __typename?: 'Reward';
  categoryId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  dateEnd?: Maybe<Scalars['DateTime']>;
  dateStart?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  extraData?: Maybe<Scalars['Json']>;
  freqCap?: Maybe<Scalars['Int']>;
  freqPeriodId?: Maybe<Scalars['Int']>;
  freqPeriodName?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Int']>;
  maxPerUser?: Maybe<Scalars['Int']>;
  numPoints: Scalars['Int'];
  quantity?: Maybe<Scalars['Int']>;
  referenceId?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type RewardRedeemed = {
  __typename?: 'RewardRedeemed';
  balance: Scalars['Int'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  acceptTermsAndConditions?: Maybe<User>;
  /**
   * Adds an item to a cart. Will create a new cart
   * if no `id` is included and cart is not already
   * associated with the requesting user. If a cart
   * already exists for the user or session we will
   * grab that cart and add the requested item.
   *
   * Cookie for cart is `decovo-shoppingcart`.
   *
   * Example:
   *   ```
   *   mutation AddCartItem($input: CartItemInput!) {
   *     addCartItem(input: $input) {
   *       id
   *       items {
   *         id
   *         quantity
   *         customizations
   *       }
   *     }
   *   }
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     input: {
   *       "item_id": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *       "quantity": 1
   *     }
   *   }
   *   ```
   */
  addCartItem?: Maybe<Cart>;
  /**
   * Add a dynamic bundle of cart items to a cart.
   *
   * This will run a check to verify that all the items
   * submitted are qualified in the bundle, then updates
   * the cart with the proper meta data in the cart items to
   * qualify them for a discount.
   *
   * Please ensure the items are sorted correctly per component.
   * For example: If you send items for component A but belong to
   * component B then those items will not qualify for the bundle.
   *
   * Example:
   * ```
   *   mutation AddDynamicBundle ($input: CartDynamicBundleInput!) {
   *     addDynamicBundle(input: $input) {
   *       id
   *       dynamic_bundles
   *       items {
   *         item {
   *           id
   *         }
   *         quantity
   *         dynamic_bundle
   *         customizations
   *       }
   *     }
   *   }
   * ```
   * Variables:
   * ```
   * {
   *   "input": {
   *     "id": "456a9e8a-c9ba-4ccb-91bf-420549c32566",
   *     "bundle_id": "1c231c97-ac47-43ce-87b6-6adb24067dd0",
   *     "components": [
   *       {
   *         "component_id": "e76c5b69-8517-445b-9fad-650f52f816af",
   *         "items": [
   *           {
   *             "item_id": "3c45a09d-e34f-4be5-8a67-18b93ad25b38",
   *             "customizations": "[{"description": "Concave_White", "pattern_code":"286"}]"
   *             "quantity": 5
   *           },
   *           {
   *             "item_id": "85853232-dc23-4d90-ae11-df5337b9bf11",
   *             "customizations": "[{"description": "Concave_White", "pattern_code":"286"}]"
   *             "quantity": 5
   *           }
   *         ]
   *       },
   *       {
   *         "component_id": "a283faf0-59a2-488e-ac65-7b61daa6cea4",
   *         "items": [
   *         {
   *           "item_id": "704d74bc-2ae4-4d30-9046-02d2acd8225f",
   *           "quantity": 8
   *         },
   *         {
   *           "item_id": "9111915b-12a5-4818-b020-a9d2eddc6490",
   *           "quantity": 2
   *         }
   *       ]
   *     }
   *   }
   * ```
   */
  addDynamicBundle?: Maybe<Cart>;
  /**
   * Add an exact dynamic bundle of cart items to a cart.
   *
   * NOTE: This does not support customizations or subscriptions
   *
   * Example:
   * ```
   *   mutation AddExactDynamicBundle ($input: CartExactDynamicBundleInput!) {
   *     addExactDynamicBundle(input: $input) {
   *       id
   *       dynamic_bundles
   *       items {
   *         item {
   *           id
   *         }
   *         dynamic_bundle
   *       }
   *     }
   *   }
   * ```
   * Variables:
   * ```
   * {
   *   "input": {
   *     "id": "456a9e8a-c9ba-4ccb-91bf-420549c32566",
   *     "bundle_id": "1c231c97-ac47-43ce-87b6-6adb24067dd0"
   *   }
   * ```
   *
   * or via a bundle tag:
   *
   * ```
   * {
   *   "input": {
   *     "id": "456a9e8a-c9ba-4ccb-91bf-420549c32566",
   *     "bundle_tag": "art-bialy-flavorpack"
   *   }
   * ```
   */
  addExactDynamicBundle?: Maybe<Cart>;
  /**
   * Add an item with unique customizations to a Cart.
   * If there are no customizations please use: AddCartItem
   *
   * mutation AddItemWithUniqueCustomizations ($input: AddItemWithUniqueCustomizationsInput!) {
   *   addItemWithUniqueCustomizations(input: $input) {
   *     id
   *     user {
   *       id
   *     }
   *     items {
   *       id
   *       item {
   *         id
   *       }
   *       quantity
   *       subscriptionIntervalInDays
   *       customizations
   *       analytics_details
   *     }
   *     total
   *   }
   * }
   * ```
   * Variables:
   * ```
   * {
   *   input: {
   *     "cart_item_id": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *     "quantity": 1,
   *     "customizations": "[{"description": "Concave_White", "pattern_code":"286"}]",
   *     "subscriptionIntervalInDays": 15
   *   }
   * }
   * ```
   */
  addItemWithUniqueCustomizations?: Maybe<Cart>;
  /**
   * Update the cart with loyalty reward applied
   *
   * If the given code is already present in the cart's loyalty_data field, its quantity and totals will be updated.
   *
   * Use a quantity of 0 (zero) to remove a reward from the cart.
   *
   * Example:
   *   ```
   *   mutation applyLoyaltyRewardToCart($input: LoyaltyRewardInput!) {
   *     applyLoyaltyRewardToCart(input: $input) {
   *       id
   *       loyaltyData {
   *         totalAmount
   *         totalPoints
   *       }
   *       loyaltyRewards {
   *         code
   *         quantity
   *         totalAmount
   *         totalPoints
   *       }
   *     }
   *   }
   *   ```
   *
   *   Variables:
   *   ```
   *   {
   *     "input": {
   *       "code": "1234567",
   *       "quantity": 3
   *     }
   *   }
   *   ```
   * @deprecated Use applyLoyaltyRewardToCartByPepdirectRewardId instead
   */
  applyLoyaltyRewardToCart?: Maybe<Cart>;
  /**
   * Update the cart with loyalty reward applied
   *
   * If the given pepdirect_reward_id is already present in the cart's loyalty_data field, its quantity and totals will be updated.
   *
   * Use a quantity of 0 (zero) to remove a reward from the cart.
   *
   * Example:
   *   ```
   *   mutation applyLoyaltyRewardToCartByPepdirectRewardId($input: LoyaltyRewardInputByPepdirectRewardId!) {
   *     applyLoyaltyRewardToCartByPepdirectRewardId(input: $input) {
   *       id
   *       loyaltyData {
   *         totalAmount
   *         totalPoints
   *       }
   *       loyaltyRewards {
   *         code
   *         quantity
   *         totalAmount
   *         totalPoints
   *       }
   *     }
   *   }
   *   ```
   *
   *   Variables:
   *   ```
   *   {
   *     "input": {
   *       "pepdirect_reward_id": "fiveDollarOffReward",
   *       "quantity": 3
   *     }
   *   }
   *   ```
   */
  applyLoyaltyRewardToCartByPepdirectRewardId?: Maybe<Cart>;
  /**
   * Update the cart with potential points from items in the cart
   *
   * Example:
   *   ```
   *   mutation applyPotentialPointsToCart {
   *     applyPotentialPointsToCart {
   *       id
   *       loyaltyData {
   *         totalEarnedPoints
   *       }
   *     }
   *   }
   *   ```
   *
   *   Variables: none
   */
  applyPotentialPointsToCart?: Maybe<Cart>;
  archiveRegistrationRecord?: Maybe<RegistrationRecord>;
  /**
   * associates an anonymous Cart (a Cart without a `user_id`) to the current
   * authenticated User.
   */
  associateCartToUser?: Maybe<Cart>;
  /** Returns the order with the discounts applied. (Does not update order in DB) */
  calculateOrderDiscounts?: Maybe<CalculateOrderDiscountsPayload>;
  calculateOrderTaxes?: Maybe<CalculateOrderPayload>;
  /** @deprecated Please use update_order_subscription_status and set status to CANCELED and include a status_reason */
  cancelOrderSubscription?: Maybe<OrderSubscription>;
  changeUserPassword?: Maybe<User>;
  createAccountAndRegistrationRecord?: Maybe<User>;
  /**
   * Creates an order.
   *
   * Mutation
   * ```
   * mutation CreateOrder($cartId: String!, $input: OrderInput) {
   *   createOrder(cartId: $cartId, input: $input) {
   *     app_id
   *     cart{
   *         id
   *     }
   *     id
   *     status
   *     location {
   *       lat
   *       long
   *     }
   *     user {
   *       id
   *       first_name
   *       last_name
   *     }
   *     contact_info {
   *         email
   *         shipping_address{
   *             line1
   *         }
   *     }
   *     payment_request{
   *         billing_address{
   *             line1
   *         }
   *     }
   *     price{
   *         total
   *     }
   *     requested_delivery_date
   *     submission_uid
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "cartId": "bcde7722-bf35-4a41-bc56-b200ec3155ae",
   *   "input": {}
   * }
   * ```
   */
  createOrder?: Maybe<CreatedOrder>;
  createPaymentClientToken: PaymentClientTokenPayload;
  createPaymentMethod: PaymentMethod;
  createRegistrationRecord?: Maybe<RegistrationRecord>;
  createSetupIntent: SetupIntent;
  /** create a cart using a submitted user order */
  createTemporaryCartFromOrder?: Maybe<Cart>;
  createUserAddress: Address;
  deleteCreditCard: Scalars['String'];
  deletePaymentMethod: Scalars['String'];
  deleteUserAddress: Address;
  /** @deprecated Please use `engagement_signup` going forward. */
  emailNewsletterSignup?: Maybe<Scalars['String']>;
  /**
   * Noting here that some tenants use the same parameters but the identifiers will have different
   * source id's. these are used to know the location of where the user initiated the signup ie. footer
   * Example:
   * ```
   * mutation engagementSignup($input: EngagementSignupInput!) {
   *   engagementSignup(input: $input)
   * }
   *
   * #  Newsletter1
   * {
   *   "input":  {"identifier1": {"email": "karen.schaper@pepsico.com", "firstName": "bob","lastName": "Smith"}}
   * }
   *
   * OR
   *
   * #  Out of Stock Email
   * {
   *   "input":  {"identifier2": {"email": "karen.schaper@pepsico.com", "gtin": "00052000000481","emailOptIn": true}}
   * }
   *
   * OR
   *
   * #  Newsletter2
   * {
   *   "input":  {"identifier3": {"email": "karen.schaper@pepsico.com", "firstName": "bob","lastName": "Smith"}}
   * }
   *
   * OR
   *
   * #  Newsletter3
   * {
   *   "input":  {"identifier4": {"email": "karen.schaper@pepsico.com", "firstName": "bob","lastName": "Smith", birthDate: "2020-01-02"}}
   * }
   * ```
   */
  engagementSignup?: Maybe<Scalars['String']>;
  /** @deprecated Please use`loginUser` going forward. */
  login?: Maybe<User>;
  loginUser?: Maybe<User>;
  logoutUser?: Maybe<User>;
  /**
   * Allows the purchase of specific items configured for points purchase.
   * Example:
   * ```
   * mutation loyaltyPurchaseByPepdirectRewardId($input: loyaltyPurchaseInput!) {
   *   loyaltyPurchaseByPepdirectRewardId(input: $input) {
   *     appId
   *     id
   *     status
   *     user {
   *       id
   *     }
   *   }
   * }
   * ```
   * Variables:
   * ```
   * {
   *     "input": {
   *       "loyaltyItems" {
   *         "itemId": "01ef0285-04e2-19d0-9cc9-bc274e0cb4a7"
   *         "quantity": 2
   *       }
   *       "shippingAddressId": "17e20913-5d02-5e05-7122-5093252e99af",
   *       "rewardId": "freeItem",
   *       "rewardQuantity": 1
   *     }
   *   }
   * ```
   */
  loyaltyPurchaseByPepdirectRewardId?: Maybe<SubmittedOrder>;
  /**
   * Update the user profile in the loyalty program
   * Example:
   *   ```
   *   mutation loyaltyUpdateProfile($input: userProfileInput!) {
   *     loyaltyUpdateProfile(input: $input) {
   *       firstName
   *       lastName
   *       totalPoints
   *       redeemablePoints
   *       customData
   *     }
   *   }
   *   ```
   *
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     "input": {
   *       "sweepstakes_optin": false,
   *       "mailing_address": {
   *             "state": "MA",
   *             "city": "West Roxbury",
   *             "street_address_1": "Valley View Drive",
   *             "street_address_2": "4106",
   *             "postal_code": "02132",
   *             "phone_number": "5555555555"
   *       }
   *     }
   *   }
   *   ```
   */
  loyaltyUpdateProfile?: Maybe<UserProfile>;
  /** merge two carts */
  mergeCarts?: Maybe<Cart>;
  /**
   * Allows for multiple potential inputs using the base
   * key in the input type to determine what they are
   * inquiring about. Follows the same pattern as the
   * engagement_signup mutation.
   */
  partnerInquiry?: Maybe<Scalars['String']>;
  /** creates a cart from a temporary cart */
  persistTemporaryCart?: Maybe<Cart>;
  /**
   * Redeems a reward for a user.
   * Example:
   *   ```
   *   mutation RedeemReward($input: RedeemRewardInput!) {
   *     redeemReward(input: $input) {
   *       balance
   *     }
   *   }
   *   ```
   *   ```
   *   Variables:
   *   ```
   *   {
   *     "input": {
   *       "reward_id": "410241571",
   *       "quantity": 1
   *     }
   *   }
   *   ```
   * @deprecated Use redeemRewardByPepdirectRewardId instead
   */
  redeemReward?: Maybe<RewardRedeemed>;
  /**
   * Redeems a reward for a user using the pepdirect_reward_id.
   * Example:
   *   ```
   *   mutation RedeemRewardByPepdirectRewardId($input: RedeemRewardByPepdirectRewardIdInput!) {
   *     redeemRewardByPepdirectRewardId(input: $input) {
   *       balance
   *     }
   *   }
   *   ```
   *   ```
   *   Variables:
   *   ```
   *   {
   *     "input": {
   *       "pepdirect_reward_id": "fiveDollarOffReward",
   *       "quantity": 1
   *     }
   *   }
   */
  redeemRewardByPepdirectRewardId?: Maybe<RewardRedeemed>;
  registerAiDesign?: Maybe<AiDesign>;
  /**
   * Example:
   * ```
   *   mutation RemoveDynamicBundle ($input: CartRemoveDynamicBundleInput!) {
   *     removeDynamicBundle(input: $input) {
   *       id
   *       dynamic_bundles
   *       items {
   *         item {
   *           id
   *         }
   *         quantity
   *         dynamic_bundle
   *       }
   *     }
   *   }
   * ```
   * Variables:
   * ```
   * {
   *   "input": {
   *     "id": "456a9e8a-c9ba-4ccb-91bf-420549c32566",
   *     "cart_bundle_reference": 22222
   *   }
   * }
   * ```
   */
  removeDynamicBundle?: Maybe<Cart>;
  /**
   * Requests a Password Reset for a User with the email provided.
   *
   * Mutation
   * ```
   * mutation RequestPasswordResetForUser($input: RequestPasswordResetForUserInput!) {
   *   requestPasswordResetForUser(input: $input) {
   *     email
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "email": "user@example.com"
   *   }
   * }
   * ```
   */
  requestPasswordResetForUser?: Maybe<RequestPasswordResetForUserPayload>;
  /**
   * This Mutation has been deprecated, please use `requestPasswordResetForUser`
   * @deprecated This Mutation has been deprecated, please use `requestPasswordResetForUser`
   *
   */
  requestUserPasswordReset?: Maybe<UserPasswordResetRequestPayload>;
  resetUserPassword?: Maybe<User>;
  /**
   * Example:
   *   ```
   *   mutation SendSspEmail($input: EmailSspInput!) {
   *     sendSspEmail(input: $input) {
   *       status
   *     }
   *   }
   *
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     "input":{
   *       "firstName":"First name",
   *       "lastName":"Last name",
   *       "email":"email@pepsico.com",
   *       "businessName":"Pepsico",
   *       "businessAddress":"Business address",
   *       "businessType":"Business Type",
   *       "numberOfUsers":10,
   *       "existingCustomer": true,
   *       "manageAndOrder": "Manage and order",
   *       "city": "Benito Juarez",
   *       "state": "CDMX",
   *       "zip": "03023",
   *       "phone_number": "5512259112"
   *     }
   *   }
   *   ```
   */
  sendSspEmail?: Maybe<EmailSspResponse>;
  signupUser?: Maybe<User>;
  skipOrderSubscription?: Maybe<OrderSubscription>;
  /**
   * Submits an order, returning the created submittedOrder.
   *
   * Mutation
   * ```
   * mutation SubmitOrder($orderId: UUID4!, $input: SubmitOrderInput!) {
   *   submitOrder(orderId: $orderId, input: $input) {
   *     app_id
   *     cart_id
   *     giftee_email
   *     giftee_message
   *     giftor_name
   *     is_gift
   *     price {
   *       discount
   *     }
   *     user {
   *       email
   *       first_name
   *       last_name
   *     }
   *     status
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   input: {
   *     contactInfo: {
   *       email: "tyrell1971@hoppe.name",
   *       phone: "5555555555",
   *       shippingAddress: {
   *         city: "city",
   *         company: "companyName",
   *         countryCode: "country",
   *         firstName: "firstName",
   *         lastName: "lastName",
   *         line1: "streetAddress",
   *         line2: "addressDetails",
   *         state: "AL",
   *         zip: "zipCode"
   *       }
   *     },
   *     paymentRequest: {
   *       billingAddress: {
   *         city: "city",
   *         company: "companyName",
   *         countryCode: "US",
   *         firstName: "firstName",
   *         lastName: "lastName",
   *         line1: "streetAddress",
   *         line2: "addressDetails",
   *         state: "AL",
   *         zip: "zipCode"
   *       },
   *       isBillingEqual_shipping: false,
   *       paymentMethod: "CREDIT_CARD",
   *       paymentToken: "token"
   *     },
   *     price: {discounts: []},
   *     requestedDeliveryDate: ~D[2021-10-05]
   *   },
   *   orderId: "e1215198-69be-4eb3-8e95-8ad441ebfe0a"
   * }
   * ```
   */
  submitOrder?: Maybe<SubmittedOrder>;
  /**
   * submit a users survey answers
   *
   * Example:
   *   ```
   * mutation submitSurvey($input: SurveyResponseInput!) {
   *   submitSurvey(input: $input) {
   *     message
   *     pointsAwarded
   *     totalResponses
   *   }
   * }
   *   ```
   *   Variables:
   *   ```
   *   {
   *     "input": {
   *       "pepdirectActivityId": "ncaaSweepsOptIn",
   *       "surveyResponse": [
   *         {
   *             "questionId": 1,
   *             "selectedAnswers": [2],
   *             "textAnswer": "some answer",
   *             "other": "some answer"
   *         }
   *       ]
   *     }
   *   }
   *   ```
   */
  submitSurvey?: Maybe<SurveySubmissionResponse>;
  /**
   * Add an item with unique customizations to a Cart.
   * If there are no customizations please use: AddCartItem
   *
   * mutation UniqueAddCartItem ($input: CartItemInput!) {
   *   uniqueAddCartItem(input: $input) {
   *     id
   *     user {
   *       id
   *     }
   *     items {
   *       id
   *       item {
   *         id
   *       }
   *       quantity
   *       subscriptionIntervalInDays
   *       customizations
   *       analytics_details
   *     }
   *     total
   *   }
   * }
   * ```
   * Variables:
   * ```
   * {
   *   input: {
   *     "item_id": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *     "quantity": 1,
   *     "subscriptionIntervalInDays": 15
   *     "customizations": "[{"description": "Concave_White", "pattern_code":"286"}]"
   *   }
   * }
   * ```
   * @deprecated This is being deprecated instead please use: AddItemWithUniqueCustomizations
   */
  uniqueAddCartItem?: Maybe<Cart>;
  /**
   * Add an item with unique customizations to a Cart.
   * If there are no customizations please use: AddCartItem
   *
   * mutation UniqueUpdateCartItem ($input: UniqueCartItemInput!) {
   *   uniqueUpdateCartItem(input: $input) {
   *     id
   *     user {
   *       id
   *     }
   *     items {
   *       id
   *       item {
   *         id
   *       }
   *       quantity
   *       customizations
   *       analytics_details
   *     }
   *     total
   *   }
   * }
   * ```
   * Variables:
   * ```
   * {
   *   input: {
   *     "id": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *     "cart_item_id": "8e918d59-6a8c-4d25-9b16-5bb64722e5f0",
   *     "quantity": 1,
   *     "subscriptionIntervalInDays": 15
   *     "customizations": "[{"description": "Concave_White", "pattern_code":"286"}]"
   *   }
   * }
   * ```
   * @deprecated This is being deprecated instead please use: UpdateItemWithUniqueCustomizations
   */
  uniqueUpdateCartItem?: Maybe<Cart>;
  updateCartGift?: Maybe<Cart>;
  updateCartItem?: Maybe<Cart>;
  updateCreditCardDefault: CreditCard;
  /**
   * Add an item with unique customizations to a Cart.
   * If there are no customizations please use: AddCartItem
   *
   * mutation UpdateItemWithUniqueCustomizations ($input: UpdateItemWithUniqueCustomizationsInput!) {
   *   updateItemWithUniqueCustomizations(input: $input) {
   *     id
   *     user {
   *       id
   *     }
   *     items {
   *       id
   *       item {
   *         id
   *       }
   *       quantity
   *       subscriptionIntervalInDays
   *       customizations
   *       analytics_details
   *     }
   *     total
   *   }
   * }
   * ```
   * Variables:
   * ```
   * {
   *   input: {
   *     "item_id": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *     "quantity": 1,
   *     "subscriptionIntervalInDays": 15
   *     "customizations": "[{"description": "Concave_White", "pattern_code":"286"}]"
   *   }
   * }
   * ```
   */
  updateItemWithUniqueCustomizations?: Maybe<Cart>;
  /**
   * Updates an order.
   *
   * Mutation
   * ```
   * mutation UpdateOrder($orderId: UUID4!, $input: UpdateOrderInput!) {
   *   updateOrder(orderId: $orderId, input: $input) {
   *     id
   *     appId
   *     requestedDeliveryDate
   *     contactInfo {
   *       email
   *       phone
   *       shippingAddress {
   *         city
   *         zip
   *       }
   *     }
   *     paymentRequest {
   *       paymentMethod
   *       isBillingEqualShipping
   *       billingAddress {
   *         city
   *         zip
   *       }
   *     }
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "order_id": "3965354a-260c-4fdd-a0d5-75f6efee4207",
   *   "input": {}
   * }
   * ```
   * @deprecated   Order updates should be submitted through the SubmitOrder mutation
   *
   */
  updateOrder?: Maybe<CreatedOrder>;
  updateOrderSubscription?: Maybe<OrderSubscription>;
  updateOrderSubscriptionAddress?: Maybe<OrderSubscription>;
  updateOrderSubscriptionPayment?: Maybe<OrderSubscription>;
  updateOrderSubscriptionQuantity?: Maybe<OrderSubscription>;
  updateOrderSubscriptionStatus?: Maybe<OrderSubscription>;
  updatePaymentMethodDefault: PaymentMethod;
  updateUserAddress: Address;
  updateUserAddressIsDefault: Address;
  /**
   * Updates user's first name and last name.
   *
   * Mutation
   * ```
   * mutation UpdateUserFirstLastName($input: UpdateUserFirstLastNameInput!) {
   *   updateUserFirstLastName(input: $input) {
   *     id
   *     first_name
   *     last_name
   *   }
   * }
   * ```
   *
   * Variables
   * ```
   * {
   *   "input": {
   *     "id": "UUID4",
   *     "first_name": "New"
   *     "last_name": "Updated"
   *   }
   * }
   * ```
   */
  updateUserFirstLastName?: Maybe<User>;
  /**
   * Credits an activity to a user
   * Example:
   *   ```
   *   mutation UserActivityCredit($input: ActivityCreditInput!) {
   *     userActivityCredit(input: $input) {
   *       awarded
   *     }
   *   }
   *   ```
   *
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     "input": {
   *       "activity_id": "410241571",
   *       "activity_date": "2024-03-02T01:56:08Z",
   *       "extra_data": "{"some_key": "some_value"}"
   *     }
   *   }
   *   ```
   * @deprecated Use userActivityCreditByPepdirectActivityId instead
   */
  userActivityCredit?: Maybe<ActivityAwarded>;
  /**
   * Credits an activity to a user by the pepdirect activity id
   * Example:
   *   ```
   *   mutation UserActivityCreditByPepdirectActivityId($input: ActivityCreditByPepdirectActivityIdInput!) {
   *     userActivityCreditByPepdirectActivityId(input: $input) {
   *       awarded
   *       numPoints
   *     }
   *   }
   *   ```
   *
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     "input": {
   *       "pepdirect_activity_id": "CompletedWorkout",
   *       "activity_date": "2024-03-02T01:56:08Z",
   *       "num_points": 500,
   *       "extra_data": "{"some_key": "some_value"}"
   *     }
   *   }
   *   ```
   */
  userActivityCreditByPepdirectActivityId?: Maybe<ActivityAwarded>;
  /**
   * mutation UserAddressVerification {
   *     userAddressVerification(
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  userAddressVerification?: Maybe<VerifyAddressPayload>;
  /**
   * Submits code to be redeemed for a user
   * Example:
   *   ```
   *   mutation UserCodeSubmit($input: UserCodeSubmitInput!) {
   *     userCodeSubmit(input: $input) {
   *       num_points
   *     }
   *   }
   *   ```
   *
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     "input": {
   *       "code_value": "abc123",
   *       "campaign_id": "6546743"
   *     }
   *   }
   *   ```
   */
  userCodeSubmit?: Maybe<CodeSubmitted>;
  /**
   * mutation AddressVerification {
   *     verifyAddressForOrder(
   *       orderId: "",
   *       input: {
   *         first_name: "",
   *         last_name: "",
   *         company: "",
   *         country_code: "",
   *         city: "",
   *         state: "",
   *         zip: "",
   *         special_instructions: "",
   *         line1: "",
   *         line2: ""
   *       }
   *     )
   *     {
   *       first_name,
   *       last_name,
   *       company,
   *       country_code,
   *       city,
   *       state,
   *       zip,
   *       line1,
   *       line2,
   *       special_instructions,
   *       success,
   *       errors{
   *         code,
   *         field,
   *         message,
   *         suggestion
   *       }
   *     }
   *   }
   */
  verifyAddressForOrder?: Maybe<VerifyAddressPayload>;
};


export type RootMutationTypeAddCartItemArgs = {
  input: CartItemInput;
};


export type RootMutationTypeAddDynamicBundleArgs = {
  input: CartDynamicBundleInput;
};


export type RootMutationTypeAddExactDynamicBundleArgs = {
  input: CartExactDynamicBundleInput;
};


export type RootMutationTypeAddItemWithUniqueCustomizationsArgs = {
  input: AddItemWithUniqueCustomizationsInput;
};


export type RootMutationTypeApplyLoyaltyRewardToCartArgs = {
  input: LoyaltyRewardInput;
};


export type RootMutationTypeApplyLoyaltyRewardToCartByPepdirectRewardIdArgs = {
  input: LoyaltyRewardInputByPepdirectRewardId;
};


export type RootMutationTypeArchiveRegistrationRecordArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeAssociateCartToUserArgs = {
  cartId: Scalars['UUID4'];
};


export type RootMutationTypeCalculateOrderDiscountsArgs = {
  input: CalculateOrderDiscountsInput;
};


export type RootMutationTypeCalculateOrderTaxesArgs = {
  cartId?: InputMaybe<Scalars['UUID4']>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  invoiceAddressId?: InputMaybe<Scalars['UUID4']>;
  orderId?: InputMaybe<Scalars['UUID4']>;
  paymentRequest?: InputMaybe<PaymentRequestInput>;
  price?: InputMaybe<PriceInput>;
};


export type RootMutationTypeCancelOrderSubscriptionArgs = {
  input?: InputMaybe<CancelOrderSubscriptionInput>;
};


export type RootMutationTypeChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type RootMutationTypeCreateAccountAndRegistrationRecordArgs = {
  registrationRecordInput: CreateRegistrationRecordInput;
  userInput: SignupUserInput;
};


export type RootMutationTypeCreateOrderArgs = {
  cartId: Scalars['String'];
  input?: InputMaybe<OrderInput>;
};


export type RootMutationTypeCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput;
};


export type RootMutationTypeCreateRegistrationRecordArgs = {
  input: CreateRegistrationRecordInput;
};


export type RootMutationTypeCreateTemporaryCartFromOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootMutationTypeCreateUserAddressArgs = {
  input: UserAddressInput;
};


export type RootMutationTypeDeleteCreditCardArgs = {
  input: DeleteCreditCardInput;
};


export type RootMutationTypeDeletePaymentMethodArgs = {
  input: DeletePaymentMethodInput;
};


export type RootMutationTypeDeleteUserAddressArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeEmailNewsletterSignupArgs = {
  input: EmailNewsletterSignupInput;
};


export type RootMutationTypeEngagementSignupArgs = {
  input: EngagementSignupInput;
};


export type RootMutationTypeLoginArgs = {
  input: LoginInput;
};


export type RootMutationTypeLoginUserArgs = {
  input: LoginUserInput;
};


export type RootMutationTypeLoyaltyPurchaseByPepdirectRewardIdArgs = {
  input: LoyaltyPurchaseInput;
};


export type RootMutationTypeLoyaltyUpdateProfileArgs = {
  input: UserProfileInput;
};


export type RootMutationTypeMergeCartsArgs = {
  destCartId: Scalars['UUID4'];
  srcCartId: Scalars['UUID4'];
};


export type RootMutationTypePartnerInquiryArgs = {
  input: PartnerInquiryInput;
};


export type RootMutationTypePersistTemporaryCartArgs = {
  srcCartId: Scalars['UUID4'];
};


export type RootMutationTypeRedeemRewardArgs = {
  input: RedeemRewardInput;
};


export type RootMutationTypeRedeemRewardByPepdirectRewardIdArgs = {
  input: RedeemRewardByPepdirectRewardIdInput;
};


export type RootMutationTypeRegisterAiDesignArgs = {
  colors?: InputMaybe<Array<AiDesignColorInput>>;
  featuredWeight?: InputMaybe<Scalars['Int']>;
  generatedByTenant?: InputMaybe<Scalars['Boolean']>;
  imageUrls: Scalars['Json'];
  itemId: Scalars['UUID4'];
  prompAiEnhanced?: InputMaybe<Scalars['String']>;
  promptUser?: InputMaybe<Scalars['String']>;
  traits?: InputMaybe<Array<AiDesignTraitInput>>;
};


export type RootMutationTypeRemoveDynamicBundleArgs = {
  input: CartRemoveDynamicBundleInput;
};


export type RootMutationTypeRequestPasswordResetForUserArgs = {
  input: RequestPasswordResetForUserInput;
};


export type RootMutationTypeRequestUserPasswordResetArgs = {
  email: Scalars['String'];
};


export type RootMutationTypeResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type RootMutationTypeSendSspEmailArgs = {
  input: EmailSspInput;
};


export type RootMutationTypeSignupUserArgs = {
  input: SignupUserInput;
};


export type RootMutationTypeSkipOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootMutationTypeSubmitOrderArgs = {
  input?: InputMaybe<SubmitOrderInput>;
  orderId: Scalars['String'];
};


export type RootMutationTypeSubmitSurveyArgs = {
  input: SurveyResponseInput;
};


export type RootMutationTypeUniqueAddCartItemArgs = {
  input: CartItemInput;
};


export type RootMutationTypeUniqueUpdateCartItemArgs = {
  input: UniqueCartItemInput;
};


export type RootMutationTypeUpdateCartGiftArgs = {
  input: IsGiftInput;
};


export type RootMutationTypeUpdateCartItemArgs = {
  input: CartItemInput;
};


export type RootMutationTypeUpdateCreditCardDefaultArgs = {
  input: UpdateCreditCardDefaultInput;
};


export type RootMutationTypeUpdateItemWithUniqueCustomizationsArgs = {
  input: UpdateItemWithUniqueCustomizationsInput;
};


export type RootMutationTypeUpdateOrderArgs = {
  input: UpdateOrderInput;
  orderId: Scalars['UUID4'];
};


export type RootMutationTypeUpdateOrderSubscriptionArgs = {
  input: UpdateOrderSubscriptionInput;
};


export type RootMutationTypeUpdateOrderSubscriptionAddressArgs = {
  input: UpdateOrderSubscriptionAddressInput;
};


export type RootMutationTypeUpdateOrderSubscriptionPaymentArgs = {
  input: UpdateOrderSubscriptionPaymentInput;
};


export type RootMutationTypeUpdateOrderSubscriptionQuantityArgs = {
  input: UpdateOrderSubscriptionQuantityInput;
};


export type RootMutationTypeUpdateOrderSubscriptionStatusArgs = {
  input: UpdateOrderSubscriptionStatusInput;
};


export type RootMutationTypeUpdatePaymentMethodDefaultArgs = {
  input: UpdatePaymentMethodDefaultInput;
};


export type RootMutationTypeUpdateUserAddressArgs = {
  id: Scalars['UUID4'];
  input: UserAddressInput;
};


export type RootMutationTypeUpdateUserAddressIsDefaultArgs = {
  id: Scalars['UUID4'];
  input: UserAddressIsDefaultInput;
};


export type RootMutationTypeUpdateUserFirstLastNameArgs = {
  input: UpdateUserFirstLastNameInput;
};


export type RootMutationTypeUserActivityCreditArgs = {
  input: ActivityCreditInput;
};


export type RootMutationTypeUserActivityCreditByPepdirectActivityIdArgs = {
  input: ActivityCreditByPepdirectActivityIdInput;
};


export type RootMutationTypeUserAddressVerificationArgs = {
  input: VerifyAddressInput;
};


export type RootMutationTypeUserCodeSubmitArgs = {
  input: UserCodeSubmitInput;
};


export type RootMutationTypeVerifyAddressForOrderArgs = {
  input: VerifyAddressInput;
  orderId: Scalars['String'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /**
   * Gets the currently active account
   * Example:
   *   ```
   *   query {
   *     activeAccount {
   *       type
   *       credits {
   *         status
   *         type
   *         availableAmount
   *         spentAmount
   *         activeFrom
   *         activeUntil
   *       }
   *     }
   *   }
   *   ```
   */
  activeAccount?: Maybe<Account>;
  aiDesigns?: Maybe<AiDesignResult>;
  /** Retrieves a cart given an id */
  cart?: Maybe<Cart>;
  /** Retrieves a cart given a hashed email for Salesforce */
  cartRecovery?: Maybe<Cart>;
  /**
   * Gets the currently logged in user
   * Example:
   *   ```
   *   query {
   *     currentUser {
   *       email
   *       firstName
   *       lastName
   *       creditCards {
   *         cardholderName
   *         billingAddress{
   *           firstName
   *           lastName
   *         }
   *       }
   *       addresses{
   *         line1
   *         line2
   *       }
   *     }
   *   }
   *   ```
   */
  currentUser?: Maybe<User>;
  /**
   * Retrieve a Dynamic Bundle, its Components, and all Items associated.
   * Example:
   * ```
   * query DynamicBundle($id: UUID4!) {
   *   dynamicBundle(id: $id) {
   *     id
   *     name
   *     tag
   *     min_retail_price
   *     components {
   *       id
   *       name
   *       qty_type
   *       required_qty
   *       discount {
   *         amount
   *         type
   *       }
   *       items {
   *         id
   *         gtin
   *         is_dairy_free
   *         is_gluten_free
   *       }
   *     }
   *   }
   * }
   *
   * {"id": "bundle_id"}
   * ```
   */
  dynamicBundle?: Maybe<DynamicBundle>;
  /**
   * Retrieve a Dynamic Bundle, its Components, and all Items associated.
   * Example:
   * ```
   * query DynamicBundleByTag($tag: String!) {
   *   dynamicBundle(tag: $tag) {
   *     id
   *     name
   *     tag
   *     min_retail_price
   *     components {
   *       id
   *       name
   *       required_qty
   *       items {
   *         id
   *         gtin
   *         is_dairy_free
   *         is_gluten_free
   *       }
   *     }
   *   }
   * }
   *
   * {"id": "bundle_id"}
   * ```
   */
  dynamicBundleByTag?: Maybe<DynamicBundle>;
  /**
   * Retrieve all Dynamic Bundles and their Components.
   * Example:
   * ```
   * query DynamicBundles {
   *   dynamicBundles {
   *     id
   *     name
   *     tag
   *     components {
   *       id
   *       name
   *       required_qty
   *     }
   *   }
   * }
   * ```
   */
  dynamicBundles?: Maybe<Array<Maybe<DynamicBundle>>>;
  /**
   * Retrieve all Dynamic Bundles that contain a given gtin.
   * Example:
   * ```
   * query DynamicBundlesWithGtin($gtin: String!) {
   *   dynamicBundlesWithGtin(gtin: $gtin) {
   *     id
   *     name
   *     tag
   *     components {
   *       id
   *       name
   *       required_qty
   *     }
   *   }
   * }
   *
   * query DynamicBundlesWithGtin($gtin: String!, primary: boolean) {
   *   dynamicBundlesWithGtin(gtin: $gtin, primary: true) {
   *     id
   *     name
   *     tag
   *     components {
   *       id
   *       name
   *       required_qty
   *     }
   *   }
   * }
   * ```
   */
  dynamicBundlesWithGtin?: Maybe<Array<Maybe<DynamicBundle>>>;
  /** Lookup all Feature Flags. If a `User` is logged in, the Feature Flags will reflect `User` specific Feature Flags. */
  featureFlags: Array<FeatureFlag>;
  /**
   * Get address suggestions for easy user input
   * Example
   * ```
   * query FindAddress($input: FindAddressInput!) {
   *   findAddress(input: $input) {
   *     items {
   *       id
   *       value
   *       description
   *       type
   *       highlight
   *     }
   *   }
   * }
   *
   * {"input": {"text": "3110 Pepsi road", "limit": "10"}}
   * ```
   */
  findAddress?: Maybe<FoundItems>;
  /**
   * Uses internal machine learning endpoint to suggest product
   *   recommendations based on the items in the cart
   *
   *   Example:
   *   ```
   *   query findRecommendations($cartId: UUID4!, $numberRequested: Int!) {
   *     findRecommendations(cartId: $cartId, numberRequested: $numberRequested) {
   *       id
   *       gtin
   *       title
   *       imgUrl
   *     }
   *   }
   *   ```
   *   Variables:
   *
   *   ```
   *   {"cartId": "63a4ef4e-1cac-409d-b40c-38db5f064cd3",
   *   "numberRequested": 3}
   *   ```
   */
  findRecommendations?: Maybe<Array<Maybe<Item>>>;
  /**
   * Gets details about an activity
   * Example:
   *   ```
   *   query GetActivity($activityId: String!) {
   *     getActivity(activity_id: $activityId) {
   *       activityId
   *       extraData
   *       internalName
   *       displayName
   *       numPoints
   *       imgUrl
   *       freqCap
   *       freqPeriodId
   *       freqPeriodName
   *     }
   *   }
   *   ```
   */
  getActivity?: Maybe<UserActivity>;
  /**
   * Gets activities available for the current tenant from the loyalty program. Most useful when the user is not logged in.
   * Example:
   * ```
   *   query {
   *     getAvailableActivitiesForTenant {
   *       activityId
   *       internalName
   *       displayName
   *       description
   *       numPoints
   *       imgUrl
   *       dateStart
   *       dateEnd
   *       extraData
   *       freqCap
   *       freqPeriodId
   *       freqPeriodName
   *     }
   *   }
   * ```
   */
  getAvailableActivitiesForTenant?: Maybe<Array<Maybe<Activity>>>;
  /**
   * Gets activities available for the given user from the loyalty program
   * Example:
   * ```
   *   query {
   *     getAvailableActivitiesForUser {
   *       activityId
   *       internalName
   *       displayName
   *       description
   *       numPoints
   *       imgUrl
   *       dateStart
   *       dateEnd
   *       extraData
   *       freqCap
   *       freqPeriodId
   *       freqPeriodName
   *     }
   *   }
   * ```
   */
  getAvailableActivitiesForUser?: Maybe<Array<Maybe<Activity>>>;
  /**
   * Return a list of items, paginated
   * Example:
   *   ```
   *   query getItems {
   *     getItems(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       items {
   *         id
   *       }
   *     }
   *   }
   *   ```
   * @deprecated Please use `items` going forward.
   */
  getItems?: Maybe<ItemsPayload>;
  /**
   * Gets user profile from the loyalty program
   * Example:
   *   ```
   *   query {
   *     getLoyaltyProfile {
   *       firstName
   *       lastName
   *       totalPoints
   *       redeemablePoints
   *     }
   *   }
   *   ```
   */
  getLoyaltyProfile?: Maybe<UserProfile>;
  /**
   * Gets list of rewards for the loyalty program
   * Example:
   *   ```
   *   query {
   *     getLoyaltyRewards {
   *       categoryId
   *       color
   *       dateEnd
   *       dateStart
   *       description
   *       extraData
   *       freqCap
   *       freqPeriodId
   *       freqPeriodName
   *       groupId
   *       id
   *       image
   *       isEnabled
   *       maxPerUser
   *       numPoints
   *       quantity
   *       referenceId
   *       size
   *       title
   *     }
   *   }
   *   ```
   */
  getLoyaltyRewards?: Maybe<Array<Maybe<Reward>>>;
  /**
   * Gets potential points for a given items list.
   * Prices are in cents, have quantity included and discounts applied.
   * For example, for calculating points of 2 of an item that costs $25 (after applying discounts),
   * the price is 5000 and the quantity is 2.
   * Example:
   *   ```
   *   query GetPotentialPoints($input: PotentialPointsInput!) {
   *     getPotentialPoints(input: $input) {
   *       totalPointsAwarded
   *     }
   *   }
   *   ```
   *
   *   ```
   *   Variables:
   *
   *   ```
   *   {
   *     "input": {
   *       "items": [
   *         {
   *           "upc": "123456789",
   *           "quantity": 1,
   *           "price": 100
   *         }
   *       ]
   *     }
   *   }
   *   ```
   */
  getPotentialPoints?: Maybe<PotentialPoints>;
  /**
   * Gets details about an activity available for the given user from the loyalty program
   * Example:
   *   ```
   *   query GetUserActivity($activityId: String!) {
   *     getUserActivity(activity_id: $activityId) {
   *       activityId
   *       extraData
   *       internalName
   *       displayName
   *       numPoints
   *       imgUrl
   *       freqCap
   *       freqPeriodId
   *       freqPeriodName
   *       userNumCompletions
   *     }
   *   }
   *   ```
   */
  getUserActivity?: Maybe<UserActivity>;
  /**
   * Gets user's activity history from the loyalty program
   * Example:
   *   ```
   *   query {
   *     getUserActivityHistory {
   *       activities {
   *         activity_id
   *         extra_data
   *         internal_name
   *         display_name
   *         num_points
   *         img_url
   *         date
   *         freq_cap
   *         freq_period_id
   *         freq_period_name
   *       }
   *       redemptions {
   *         activity_id
   *         extra_data
   *         internal_name
   *         display_name
   *         num_points
   *         img_url
   *         date
   *         freq_cap
   *         freq_period_id
   *         freq_period_name
   *       }
   *     }
   *   }
   *   ```
   */
  getUserActivityHistory?: Maybe<UserActivityHistory>;
  /**
   * Gets list of rewards for a specific user in the loyalty program.
   *
   * For pagination input, the maximum limit of items per page is 10.
   *
   * Example:
   *   ```
   *   query {
   *     getUserLoyaltyRewards {
   *       categoryId
   *       color
   *       dateEnd
   *       dateStart
   *       description
   *       extraData
   *       freqCap
   *       freqPeriodId
   *       freqPeriodName
   *       groupId
   *       id
   *       image
   *       isEnabled
   *       maxPerUser
   *       numPoints
   *       quantity
   *       referenceId
   *       size
   *       title
   *     }
   *   }
   *   ```
   */
  getUserLoyaltyRewards?: Maybe<Array<Maybe<Reward>>>;
  /**
   * Gets user's receipt history from the loyalty program
   * Example:
   *   ```
   *   query {
   *     getUserReceiptHistory (pagination: {page: 1, limit: 2}) {
   *       pagination
   *       {
   *         total
   *         pages
   *         next_page_link
   *         prev_page_link
   *         has_next_page
   *         has_prev_page
   *       }
   *       receipts
   *       {
   *         dateSubmitted
   *         fileId
   *         fileName
   *         fileUrl
   *         id
   *         scanResult
   *         scanResultText
   *       }
   *     }
   *   }
   *   ```
   */
  getUserReceiptHistory?: Maybe<ReceiptInfoHistory>;
  /**
   * Gets a list of historical rewards the the loyalty member has redeemed.
   *
   * Example:
   *   ```
   *   query {
   *     getUserRedemptionHistory (pagination: {page: 1, limit: 2}) {
   *       pagination
   *       {
   *         total
   *         pages
   *         next_page_link
   *         prev_page_link
   *         has_next_page
   *         has_prev_page
   *       },
   *       redemptions
   *       {
   *         categoryId
   *         dateCreated
   *         description
   *         endingBalance
   *         extraData
   *         groupId
   *         image
   *         rewardId
   *         rewardTitle
   *         totalPointsRedeemed
   *       }
   *     }
   *   }
   *   ```
   */
  getUserRedemptionHistory?: Maybe<RedemptionInfoHistory>;
  /**
   * Returns an `Item` for the given `GTIN`.
   *
   * Example
   * ```
   * query ItemByGtin($gtin: String!) {
   *   itemByGtin(gtin: $gtin) {
   *     id
   *     description
   *     title
   *   }
   * }
   *
   * {"gtin": "000111222333444555}
   * ```
   */
  itemByGtin?: Maybe<Item>;
  /**
   * Return the item by its id
   * Example:
   *   ```
   *   query itemById($id: String!) {
   *     itemById(id: $id) {
   *       id
   *       description
   *     }
   *   }
   *  {"id": "id"}
   *   ```
   */
  itemById?: Maybe<Item>;
  /**
   * Return the item by its slug
   * Example:
   *   ```
   *   query itemBySlug($slug: String!) {
   *     itemBySlug(slug: $slug) {
   *       id
   *       description
   *     }
   *   }
   *  {"slug": "slug"}
   *   ```
   */
  itemBySlug?: Maybe<Item>;
  /**
   * Return a list of items, paginated
   * Example:
   *   ```
   *   query getItems {
   *     getItems(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       items {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  items?: Maybe<ItemsPayload>;
  /**
   * Return a list of items, paginated
   * Example:
   *   ```
   *   query getItems {
   *     getItems(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       items {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  itemsSearch?: Maybe<ItemsPayload>;
  localization?: Maybe<Localization>;
  modules: Array<Module>;
  /**
   * Return a single order filtered by id
   * Example:
   *   ```
   *   query OrderQueries {
   *     order(order_id: order_uuid) {
   *       id
   *     }
   *   }
   *   ```
   */
  order?: Maybe<Order>;
  /**
   * query getOrderSubscriptionForUser($id: UUID4!) {
   *   orderSubscription(id: $id) {
   *     id
   *     title
   *     intervalInDays
   *     orderSubscriptionItems {
   *       priceItem {
   *         basePrice
   *         id
   *       }
   *     }
   *   }
   * }
   */
  orderSubscription?: Maybe<OrderSubscription>;
  /**
   * query getAllOrderSubscriptionsForUser {
   *   orderSubscriptions {
   *     orderSubscriptions {
   *       id
   *       title
   *       intervalInDays
   *       orderSubscriptionItems {
   *         priceItem {
   *           basePrice
   *           id
   *         }
   *       }
   *     }
   *   }
   * }
   */
  orderSubscriptions?: Maybe<OrderSubscriptionsPayload>;
  /**
   * Returns a list of items forbidden from being sold in the given zip code.
   * If a list of upcs is given, it will check only those items, otherwise will check all items in the store.
   * Example:
   *   ```
   *   query RestrictedItemsByZipCode {
   *     restrictedItemsByZipCode(
   *       zip: "94545",
   *       upcs: ["2141212", "2142145432"]) {
   *       restrictedItems {
   *         id
   *       }
   *     }
   *   }
   *   ```
   */
  restrictedItemsByZipCode?: Maybe<RestrictedItemsByZipCodePayload>;
  /**
   * Retrieve an address with an id.
   *
   * Example
   * ```
   * query RetrieveAddress($id: String!) {
   *   retrieveAddress(id: $id) {
   *     items {
   *       id
   *       line1
   *       line2
   *       city
   *       state
   *       zip
   *       country
   *     }
   *   }
   * }
   *
   * {"id": "id_12345678"}
   * ```
   */
  retrieveAddress?: Maybe<RetrievedItems>;
  /**
   * Searchs and displays an application's list of
   * discounts which meet certain requirements.
   *
   * typeDependentValue can be one of the following values:
   * - vendor_id
   * - item_id
   * - app_id
   *
   * type can be one of the following values:
   * - BRAND
   * - PRODUCT
   * - VENDOR
   * - ITEM_SET
   *
   * itemSet is a list of item ids to match against if the campaign is an itemSet campaign.
   *
   * behaviour can be one of the following
   * - BASIC
   * - TIERED
   * - BOGO
   *
   * Query
   *
   *   ```
   *   query SearchDiscounts($input: SearchDiscountsInput!) {
   *     searchDiscounts(input: $input) {
   *       discounts{
   *         id
   *         activeFrom
   *         activeUntil
   *         amount
   *         appId
   *         isPercent
   *         isPromoCodeRequired
   *         limit
   *         promoCode
   *         type
   *         typeDependentValue
   *         usage
   *       }
   *     }
   *   }
   *   ```
   *
   *   Input Examples
   *
   *   Finding a basic item specific discount with a promo code
   *   ```
   *   {
   *     input: {
   *       "type": "ITEM",
   *       "typeDependentValue": "a2e22ba6-b113-268b-e14e-ad501cb19e18",
   *       "promoCode": "PROMOCODE",
   *       "behaviour": "BASIC"
   *     }
   *   }
   *   ```
   *   Finding a tiered discount that includes a specific item in its itemSet
   *   ```
   *   {
   *     input: {
   *       "type": "ITEM_SET",
   *       "behaviour": "TIERED",
   *       "itemSet": [""a2e22ba6-b113-268b-e14e-ad501cb19e18""]
   *     }
   *   }
   *   ```
   */
  searchDiscounts?: Maybe<Discounts>;
  /**
   * Returns a `Story` with the given `id`.
   *
   * Example:
   * ```
   * query StoryById($id: UUID4!) {
   *   story: storyById(id: $id) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   */
  story?: Maybe<Story>;
  /**
   * Returns a `Story` with the given `id`.
   *
   * Example:
   * ```
   * query StoryById($id: UUID4!) {
   *   story: storyById(id: $id) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   * @deprecated Use "story" query with ID parameter in favor of "storyById"
   */
  storyById?: Maybe<Story>;
  /**
   * Returns a `Story` with the given `slug`.
   *
   * Example:
   * ```
   * query StoryBySlug($slug: String!) {
   *   story: storyBySlug(slug: $slug) {
   *     app_id
   *     body
   *     cta1
   *     cta2
   *     cta3
   *     id
   *     insertedAt
   *     moduleType
   *     slug
   *     slugHash
   *     tags
   *     title1
   *     title2
   *     title3
   *     updatedAt
   *   }
   * }
   * ```
   * @deprecated Use "story" query with ID parameter in favor of "storyBySlug"
   */
  storyBySlug?: Maybe<Story>;
  /**
   * Return a single submitted order filtered by id
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     submitted_order(order_id: order_uuid) {
   *       id
   *     }
   *   }
   *   ```
   */
  submittedOrder?: Maybe<SubmittedOrder>;
  /**
   * Return a list of orders, paginated, for the current user
   * Example:
   *   ```
   *   query SubmittedOrderQueries {
   *     submitted_orders(
   *       pagination: {
   *         page: 1
   *         limit: 10
   *       }) {
   *       orders_count
   *       submitted_orders {
   *       id
   *       }
   *     }
   *   }
   *   ```
   */
  submittedOrders: SubmittedOrderPayload;
  /**
   * Gets details about a Survey for an authenticated user from the loyalty program by the survey pepdirect_activity_id
   * Example:
   *   ```
   *   query SurveyDetails($pepdirectActivityId: String!) {
   *     surveyDetails(pepdirect_activity_id: $pepdirectActivityId) {
   *       activityId
   *       activityTags
   *       dateEnd
   *       dateStart
   *       description
   *       displayPoints
   *       extraData
   *       imageUrl
   *       isEnabled
   *       numPoints
   *       otherLabel
   *       questions {
   *         allowOther
   *         answerOptions
   *         displayOrder
   *         id
   *         questionType
   *         required
   *         value
   *       }
   *       singleSubmit
   *       title
   *     }
   *   }
   *   ```
   */
  surveyDetails?: Maybe<Survey>;
  /**
   * Gets the responses from a survey for an authenticated user from the loyalty program by the survey pepdirect_activity_id
   * Example:
   *   ```
   *   query SurveyResults($pepdirectActivityId: String!) {
   *     surveyResults(pepdirect_activity_id: $pepdirectActivityId) {
   *       surveyResponse {
   *         other
   *         questionId
   *         selectedAnswers
   *         textAnswer
   *       }
   *     }
   *   }
   *   ```
   */
  surveyResults?: Maybe<SurveyResponse>;
  /**
   * Return the `Tenant` associated with the domain of the site making the request
   * Example:
   *   ```
   *   query {
   *     tenant {
   *       appId
   *       domain
   *       fallbackUrl
   *     }
   *   }
   *   ```
   */
  tenant?: Maybe<Tenant>;
  /**
   * Validates if the given password meets the minimum complexity requirements.
   *
   * Example:
   *   ```
   *   query validatePassword($password: String!) {
   *     validatePassword(password: $password)
   *   }
   *   ```
   *   Variables:
   *
   *   ```
   *   {"password": "$123ASDsarasa"}
   *   ```
   */
  validatePassword: Array<PasswordRequirement>;
  /**
   * Returns a list of items forbidden from being sold in the given zip code.
   * If a list of upcs is given, it will check only those items, otherwise will check all items in the store.
   * Example:
   *   ```
   *   query validateZipcode {
   *     validateZipcode(
   *       zip: "94545",
   *       upcs: ["2141212", "2142145432"]) {
   *       restrictedItems {
   *         id
   *       }
   *     }
   *   }
   *   ```
   * @deprecated Please use `restrictedItemsByZipCode` going forward.
   */
  validateZipcode?: Maybe<ValidateZipcodePayload>;
  /**
   * Deprecated in favor or `tenant`.
   *
   * Return the VendorConfig associated with the domain of the site making the request
   * Example:
   *   ```
   *   query {
   *     vendorConfig {
   *       appId
   *       domain
   *       fallbackUrl
   *     }
   *   }
   *   ```
   * @deprecated This Query has been deprecated in favor of `tenant`.
   *
   *
   */
  vendorConfig?: Maybe<Tenant>;
};


export type RootQueryTypeAiDesignsArgs = {
  filters?: InputMaybe<AiDesignFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<AiDesignSortingInput>;
};


export type RootQueryTypeCartArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeCartRecoveryArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeDynamicBundleArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeDynamicBundleByTagArgs = {
  tag: Scalars['String'];
};


export type RootQueryTypeDynamicBundlesWithGtinArgs = {
  gtin: Scalars['String'];
  primary?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeFindAddressArgs = {
  input: FindAddressInput;
};


export type RootQueryTypeFindRecommendationsArgs = {
  cartId: Scalars['UUID4'];
  numberRequested: Scalars['Int'];
};


export type RootQueryTypeGetActivityArgs = {
  activityId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetItemsArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  storyId?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeGetPotentialPointsArgs = {
  input: PotentialPointsInput;
};


export type RootQueryTypeGetUserActivityArgs = {
  activityId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetUserActivityHistoryArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeGetUserLoyaltyRewardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeGetUserReceiptHistoryArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeGetUserRedemptionHistoryArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeItemByGtinArgs = {
  gtin: Scalars['String'];
  isArchived?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeItemByIdArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeItemBySlugArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  storyId?: InputMaybe<Scalars['String']>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeItemsArgs = {
  brands?: InputMaybe<Array<Scalars['String']>>;
  gtins?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isOutOfStock?: InputMaybe<Scalars['Boolean']>;
  onMarketplace?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  pending?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  storyId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeItemsSearchArgs = {
  pagination?: InputMaybe<PaginationInput>;
  term?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootQueryTypeOrderSubscriptionArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeRestrictedItemsByZipCodeArgs = {
  upcs?: InputMaybe<Array<Scalars['String']>>;
  zip: Scalars['String'];
};


export type RootQueryTypeRetrieveAddressArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeSearchDiscountsArgs = {
  input: SearchDiscountsInput;
};


export type RootQueryTypeStoryArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeStoryByIdArgs = {
  id: Scalars['UUID4'];
};


export type RootQueryTypeStoryBySlugArgs = {
  slug: Scalars['String'];
};


export type RootQueryTypeSubmittedOrderArgs = {
  orderId: Scalars['UUID4'];
};


export type RootQueryTypeSubmittedOrdersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeSurveyDetailsArgs = {
  pepdirectActivityId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeSurveyResultsArgs = {
  pepdirectActivityId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeValidatePasswordArgs = {
  password: Scalars['String'];
};


export type RootQueryTypeValidateZipcodeArgs = {
  upcs?: InputMaybe<Array<Scalars['String']>>;
  zip: Scalars['String'];
};

export type SapLink = {
  __typename?: 'SapLink';
  activeCustomerIds?: Maybe<Array<Scalars['String']>>;
  customerIds?: Maybe<Array<Scalars['String']>>;
  primaryCustomerId?: Maybe<Scalars['String']>;
  propertyId?: Maybe<Scalars['String']>;
};

export type SearchDiscountsInput = {
  behaviour?: InputMaybe<BehaviourEnum>;
  itemSet?: InputMaybe<Array<Scalars['String']>>;
  promoCode?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DiscountType>;
  typeDependentValue?: InputMaybe<Scalars['UUID4']>;
};

export type SetupIntent = {
  __typename?: 'SetupIntent';
  clientSecret: Scalars['String'];
};

export type ShippingConfig = {
  __typename?: 'ShippingConfig';
  fixedFeeShipping?: Maybe<Scalars['Int']>;
  freeShippingThreshold?: Maybe<Scalars['Int']>;
  maxDeliveryWindowInDays?: Maybe<Scalars['Int']>;
};

export type ShoppingBagConfig = {
  __typename?: 'ShoppingBagConfig';
  availableSubscriptionIntervalsInDays: Array<Scalars['Int']>;
  editSubscriptionsEnabled: Scalars['Boolean'];
  maxAmountForSelect: Scalars['Int'];
  minimumPurchaseAmount: Scalars['Int'];
  minimumPurchaseQty: Scalars['Int'];
  orderSubscriptionsEnabled: Scalars['Boolean'];
  subscriptionIntervalsInDays: Array<Scalars['Int']>;
};

export enum SignupChannelType {
  /** Android device */
  Android = 'ANDROID',
  /** iOS device */
  Ios = 'IOS',
  NotSet = 'NOT_SET',
  /** Web platform */
  Web = 'WEB'
}

export type SignupUserInput = {
  activationCode?: InputMaybe<Scalars['String']>;
  activationCodeRequired?: InputMaybe<Scalars['Boolean']>;
  botProtectionToken?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<SignupChannelType>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  /** this field will contain fields specific for engagement implementations */
  engagementCustomData?: InputMaybe<Scalars['Json']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  loyaltyReferralCode?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type SmsInput = {
  emailHash: Scalars['String'];
  phoneNumber: Scalars['String'];
  sourceId: Scalars['String'];
};

export type SmsInputLoggedUser = {
  phoneNumber: Scalars['String'];
  sourceId: Scalars['String'];
};

export enum SortableFields {
  FeaturedWeight = 'FEATURED_WEIGHT',
  Gtin = 'GTIN',
  InsertedAt = 'INSERTED_AT'
}

export enum SortableMethods {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** identifies the front end source of incoming data */
export enum SourceType {
  Default = 'DEFAULT',
  Footer = 'FOOTER'
}

export enum SourceTypes {
  /** All designs regardless of source */
  All = 'ALL',
  /** Designs created by users other than yourself, but not by the tenant */
  Others = 'OTHERS',
  /** Designs created by the requesting user */
  Self = 'SELF',
  /** Designs created by the tenant and marked and 'generatedByTenant' */
  Tenant = 'TENANT'
}

export type StatesConfig = {
  __typename?: 'StatesConfig';
  countryId: Scalars['String'];
  statesAllowed: Array<AllowedState>;
};

export enum StatusLabels {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Complete */
  Complete = 'COMPLETE',
  /** NoChange */
  NoChange = 'NO_CHANGE',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export enum StatusType {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type StockNotificationInput = {
  email: Scalars['String'];
  gtin: Scalars['String'];
  sourceId: Scalars['String'];
};

export type Story = {
  __typename?: 'Story';
  appId?: Maybe<Scalars['ID']>;
  body?: Maybe<Scalars['String']>;
  cta1?: Maybe<Scalars['String']>;
  cta2?: Maybe<Scalars['String']>;
  cta3?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID4']>;
  insertedAt?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Array<Maybe<Item>>>;
  module?: Maybe<Module>;
  moduleType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugHash?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  title3?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubmitOrderInput = {
  contactInfo: ContactInfoInput;
  /** Field size should not exceed 25 characters */
  customerPo?: InputMaybe<Scalars['String']>;
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  invoiceAddressId?: InputMaybe<Scalars['UUID4']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
  paymentRequest: PaymentRequestInput;
  price: PriceInput;
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

export type SubmittedOrder = {
  __typename?: 'SubmittedOrder';
  appId?: Maybe<Scalars['UUID4']>;
  cart?: Maybe<Cart>;
  cartId?: Maybe<Scalars['UUID4']>;
  /**
   * Composite Order Ids will be in the format `customer_po-internal_order_id`. If
   * the customer PO field is null, it'll just be the `internal_order_id`
   * @deprecated The display_name field now represents the user visible order identifier/label
   * which is either explicitly set in the record or computed via the composite
   * order id logic. This obviates the need for the composite_id field.
   *
   */
  compositeId?: Maybe<Scalars['String']>;
  contactInfo: ContactInfo;
  createdOrderSubscriptions: Array<OrderSubscription>;
  currencyCode?: Maybe<Scalars['String']>;
  /** User's own internal id for the order */
  customerPo?: Maybe<Scalars['String']>;
  /**
   * The display name represents the user visible order label which identifies
   * the order to an end-user. This is either explicitly set in the
   * display_name_override column on the order or is computed as a composite of
   * the purchase order id (if any) and the internal order id.
   */
  displayName?: Maybe<Scalars['String']>;
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  externalOrderId?: Maybe<Scalars['String']>;
  fulfillmentSystemOrderId?: Maybe<Scalars['String']>;
  fulfillmentSystemStatus?: Maybe<Scalars['String']>;
  fulfillments?: Maybe<Array<Fulfillment>>;
  gifteeEmail?: Maybe<Scalars['String']>;
  gifteeMessage?: Maybe<Scalars['String']>;
  giftorName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  /**
   * @deprecated The concept of internal/external order ids is
   * being removed and this will be replaced by a
   * single field.
   *
   */
  internalOrderId: Scalars['Int'];
  /**
   * Some orders are managed or "owned" by a different system. These orders are
   * sometimes imported into this system for tracking and reporting purposes but
   * don't have active workflows or fulfillment processes hooked up. This allows
   * these orders to be displayed with special notices in the UI.
   */
  isExternalOrder?: Maybe<Scalars['Boolean']>;
  isGift?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LatLong>;
  orderSubscription?: Maybe<OrderSubscription>;
  orderSubscriptionRelationship: OrderSubscriptionRelationshipNames;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentRequest?: Maybe<PaymentRequest>;
  price: Price;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type SubmittedOrderPayload = {
  __typename?: 'SubmittedOrderPayload';
  pagination: PaginationData;
  submittedOrders: Array<SubmittedOrder>;
};

export enum SubscriptionOption {
  Allowed = 'ALLOWED',
  None = 'NONE',
  Only = 'ONLY'
}

/** Contains information about the price of a subscription. */
export type SubscriptionPrice = {
  __typename?: 'SubscriptionPrice';
  /** Shipping cost of the subscription. */
  shipping: Scalars['Int'];
  /** SubTotal of the subscription. */
  subtotal: Scalars['Int'];
  /** Total amount of tax applied to the subscription. */
  tax: Scalars['Int'];
  /** Total of the subscription. */
  total: Scalars['Int'];
};

export type Survey = {
  __typename?: 'Survey';
  activityId: Scalars['String'];
  activityTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  dateEnd?: Maybe<Scalars['String']>;
  dateStart?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayPoints?: Maybe<Scalars['Int']>;
  extraData?: Maybe<Scalars['Json']>;
  imageUrl?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  numPoints?: Maybe<Scalars['Int']>;
  otherLabel?: Maybe<Scalars['String']>;
  questions: Array<Maybe<Question>>;
  singleSubmit?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type SurveyAnswer = {
  other?: InputMaybe<Scalars['String']>;
  questionId: Scalars['Int'];
  selectedAnswers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  textAnswer?: InputMaybe<Scalars['String']>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  surveyResponse: Array<Maybe<QuestionResponse>>;
};

export type SurveyResponseInput = {
  pepdirectActivityId: Scalars['String'];
  surveyResponse: Array<InputMaybe<SurveyAnswer>>;
};

export type SurveySubmissionResponse = {
  __typename?: 'SurveySubmissionResponse';
  message?: Maybe<Scalars['String']>;
  pointsAwarded?: Maybe<Scalars['Int']>;
  totalResponses?: Maybe<Scalars['Int']>;
};

export type TaxItem = {
  __typename?: 'TaxItem';
  amount?: Maybe<Scalars['Int']>;
  calculatedTax?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  exempt?: Maybe<Scalars['Int']>;
  impositionTypeId?: Maybe<Scalars['Int']>;
  impositionValue?: Maybe<Scalars['String']>;
  jurisdiction?: Maybe<Scalars['String']>;
  jurisdictionType?: Maybe<Scalars['String']>;
  taxRuleId?: Maybe<Scalars['String']>;
  unclaimedTaxes?: Maybe<Scalars['Int']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  analyticsConfig: AnalyticsConfig;
  /** @deprecated Deprecated in favor of `id`. */
  appId: Scalars['UUID4'];
  botProtection: BotProtection;
  brandConfig: BrandConfig;
  capabilities: Capabilities;
  checkout?: Maybe<Checkout>;
  contactConfig: ContactConfig;
  countryCode: Scalars['String'];
  domain: Scalars['String'];
  /** @deprecated Deprecated in favor of `store_url`. */
  fallbackUrl: Scalars['String'];
  giftCardConfig: GiftCardConfig;
  giftConfig: GiftConfig;
  id: Scalars['UUID4'];
  loyaltyConfig: LoyaltyConfig;
  paymentConfig: PaymentConfig;
  shippingConfig: ShippingConfig;
  shoppingBagConfig: ShoppingBagConfig;
  storeUrl: Scalars['String'];
  userExperience: UserExperience;
};

export type TenantPaymentOptions = {
  __typename?: 'TenantPaymentOptions';
  defaultCurrencyCode: Scalars['String'];
  merchantAccountId?: Maybe<Scalars['String']>;
};

export type TenantShippingOptions = {
  __typename?: 'TenantShippingOptions';
  shippingMethodsEnabled?: Maybe<Scalars['Boolean']>;
};

export type Tier = {
  __typename?: 'Tier';
  amount: Scalars['Int'];
  minQty: Scalars['Int'];
  type: TierType;
};

export enum TierType {
  /** The tier discounts a flat amount */
  Flat = 'FLAT',
  /** the tier dicounts a percentage amount */
  Percent = 'PERCENT'
}

export type TieredAttributes = {
  __typename?: 'TieredAttributes';
  tiers: Array<Tier>;
};

export type TieredBehaviour = {
  __typename?: 'TieredBehaviour';
  attributes: TieredAttributes;
  name: BehaviourEnum;
};

export type TrackingNumber = {
  __typename?: 'TrackingNumber';
  carrierName?: Maybe<Scalars['String']>;
  status?: Maybe<TrackingStatusLabels>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingServiceUpdatedAt?: Maybe<Scalars['NaiveDateTime']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export enum TrackingStatusLabels {
  /** AVAILABLE_FOR_PICKUP */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** DELIVERED */
  Delivered = 'DELIVERED',
  /** FAILURE */
  Failure = 'FAILURE',
  /** IN_TRANSIT */
  InTransit = 'IN_TRANSIT',
  /** OUT_FOR_DELIVERY */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** PRE_TRANSIT */
  PreTransit = 'PRE_TRANSIT',
  /** RETURNED */
  Returned = 'RETURNED',
  /** RETURN_TO_SENDER */
  ReturnToSender = 'RETURN_TO_SENDER',
  /** TRANSIT */
  Transit = 'TRANSIT',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

export type UniqueCartItemInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  cartItemId: Scalars['UUID4'];
  customizations?: InputMaybe<Scalars['Json']>;
  id?: InputMaybe<Scalars['UUID4']>;
  merchandiseId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
};

export type UpdateCreditCardDefaultInput = {
  default: Scalars['Boolean'];
  token: Scalars['String'];
};

export type UpdateItemWithUniqueCustomizationsInput = {
  analyticsDetails?: InputMaybe<Scalars['Json']>;
  cartItemId: Scalars['UUID4'];
  customizations?: InputMaybe<Scalars['Json']>;
  id: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrderInput = {
  contactInfo?: InputMaybe<ContactInfoInput>;
  /** Field size should not exceed 25 characters */
  customerPo?: InputMaybe<Scalars['String']>;
  gifteeEmail?: InputMaybe<Scalars['String']>;
  gifteeMessage?: InputMaybe<Scalars['String']>;
  giftorName?: InputMaybe<Scalars['String']>;
  isGift?: InputMaybe<Scalars['Boolean']>;
  paymentRequest?: InputMaybe<PaymentRequestInput>;
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateOrderSubscriptionAddressInput = {
  addressId: Scalars['UUID4'];
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
};

export type UpdateOrderSubscriptionInput = {
  id: Scalars['UUID4'];
  intervalInDays?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrderSubscriptionPaymentInput = {
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
  paymentOptions?: InputMaybe<PaymentOptionsInput>;
};

export type UpdateOrderSubscriptionQuantityInput = {
  orderSubscriptionItemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
};

export type UpdateOrderSubscriptionStatusInput = {
  /** ID of Order Subscription */
  id: Scalars['UUID4'];
  status: OrderSubscriptionStatusNames;
  /** This field is required if status is PAUSED or CANCELED */
  statusReason?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentMethodDefaultInput = {
  default: Scalars['Boolean'];
  token: Scalars['String'];
};

/** Inputs for updating user's first and last name. */
export type UpdateUserFirstLastNameInput = {
  firstName: Scalars['String'];
  id: Scalars['UUID4'];
  lastName: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  acceptedTermsAt?: Maybe<Scalars['DateTime']>;
  addresses: Array<Address>;
  /** @deprecated Legacy admin has been disabled, this field is now always false. */
  admin: Scalars['Boolean'];
  appId: Scalars['UUID4'];
  cart?: Maybe<Cart>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hashedEmail: Scalars['String'];
  hfName?: Maybe<Scalars['String']>;
  hlName?: Maybe<Scalars['String']>;
  id: Scalars['UUID4'];
  insertedAt: Scalars['DateTime'];
  lastLoggedIn?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<PaymentMethods>;
  registrationRecords: Array<RegistrationRecord>;
  userString?: Maybe<Scalars['String']>;
  vendorConfig: Tenant;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  activityId?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  extraData?: Maybe<Scalars['Json']>;
  freqCap?: Maybe<Scalars['Int']>;
  freqPeriodId?: Maybe<Scalars['Int']>;
  freqPeriodName?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  numPoints?: Maybe<Scalars['Int']>;
  userNumCompletions?: Maybe<Scalars['Int']>;
};

export type UserActivityHistory = {
  __typename?: 'UserActivityHistory';
  activities?: Maybe<Array<Maybe<UserActivity>>>;
  redemptions?: Maybe<Array<Maybe<UserActivity>>>;
};

export type UserAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isRemovable?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  validated?: InputMaybe<Scalars['Boolean']>;
  zip: Scalars['String'];
};

export type UserAddressIsDefaultInput = {
  isDefault: Scalars['Boolean'];
};

export type UserCodeSubmitInput = {
  campaignId: Scalars['String'];
  codeValue: Scalars['String'];
};

export type UserExperience = {
  __typename?: 'UserExperience';
  hasRequestedDeliveryDate: Scalars['Boolean'];
};

export type UserPasswordResetRequestPayload = {
  __typename?: 'UserPasswordResetRequestPayload';
  email: Scalars['String'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  customData?: Maybe<Scalars['Json']>;
  firstName?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  redeemablePoints?: Maybe<Scalars['Int']>;
  referralCode?: Maybe<Scalars['String']>;
  totalPoints?: Maybe<Scalars['Int']>;
};

export type UserProfileInput = {
  mailingAddress?: InputMaybe<MailingAddressInput>;
  nflMarketingOptIn?: InputMaybe<Scalars['Boolean']>;
  nflSweepsOptIn?: InputMaybe<Scalars['Boolean']>;
  nflTeam?: InputMaybe<Scalars['String']>;
  sweepstakesAddress?: InputMaybe<MailingAddressInput>;
  sweepstakesOptin: Scalars['Boolean'];
};

export type UtmData = {
  __typename?: 'UtmData';
  campaign?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
};

export type UtmDataInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

export type ValidateZipcodePayload = {
  __typename?: 'ValidateZipcodePayload';
  restrictedItems: Array<Item>;
};

export enum ValidationRequirement {
  Always = 'ALWAYS',
  Never = 'NEVER',
  Optional = 'OPTIONAL'
}

export type VerifyAddressError = {
  __typename?: 'VerifyAddressError';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  suggestion?: Maybe<Scalars['String']>;
};

export type VerifyAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type VerifyAddressPayload = {
  __typename?: 'VerifyAddressPayload';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  errors?: Maybe<Array<VerifyAddressError>>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  zip: Scalars['String'];
};

export type ZipCodeRestrictionLocalizations = {
  __typename?: 'ZipCodeRestrictionLocalizations';
  itemHeadingText: Scalars['String'];
  itemNoteText: Scalars['String'];
};

export type ActiveAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAccountQuery = { __typename?: 'RootQueryType', activeAccount?: { __typename?: 'Account', type: string, name?: string | null | undefined, tags?: Array<string> | null | undefined, credits: Array<{ __typename?: 'Credit', status: string, type: string, availableAmount: number, spentAmount: number, activeFrom: any, activeUntil?: any | null | undefined, frozen: boolean }>, invoicing?: { __typename?: 'Invoicing', enabled?: boolean | null | undefined, addresses: Array<{ __typename?: 'InvoicedAddress', city: string, company?: string | null | undefined, countryCode: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, state?: string | null | undefined, zip: string, phoneNumber: string }> } | null | undefined } | null | undefined };

export type AddressFragment = { __typename?: 'Address', city: string, company?: string | null | undefined, countryCode: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, phoneNumber?: string | null | undefined, state?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, zip: string, isDefault?: boolean | null | undefined, isRemovable?: boolean | null | undefined };

export type AllocationFragment = { __typename?: 'Credit', status: string, type: string, availableAmount: number, spentAmount: number, activeFrom: any, activeUntil?: any | null | undefined, frozen: boolean };

export type ApplePayCardFragment = { __typename?: 'ApplePayCard', customerId: string, createdAt: string, default: boolean, token: string, cardType: string, cardholderName: string, last4: string, billingAddress?: { __typename?: 'BraintreeAddress', company?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, streetAddress?: string | null | undefined, extendedAddress?: string | null | undefined, locality?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCodeAlpha2?: string | null | undefined } | null | undefined };

export type CalculateOrderDiscountsMutationVariables = Exact<{
  input: CalculateOrderDiscountsInput;
}>;


export type CalculateOrderDiscountsMutation = { __typename?: 'RootMutationType', calculateOrderDiscounts?: { __typename?: 'CalculateOrderDiscountsPayload', order?: { __typename?: 'Order', price: { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, upc?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined }> } } | null | undefined } | null | undefined };

export type CalculateOrderTaxesCartItemFragment = { __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', id: any, price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', subscriptionPrice: number } | null | undefined } };

export type CalculateOrderTaxesPriceItemFragment = { __typename?: 'PriceItem', subscriptionIntervalInDays?: number | null | undefined, quantity?: number | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, taxAmount?: number | null | undefined, discountAmount?: number | null | undefined, itemId?: any | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, upc?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', subscriptionPrice?: number | null | undefined, isSubscribable: boolean } | null | undefined } | null | undefined };

export type CalculateOrderTaxesMutationVariables = Exact<{
  cartId: Scalars['UUID4'];
  contactInfo: ContactInfoInput;
  orderId: Scalars['UUID4'];
  paymentRequest: PaymentRequestInput;
  price: PriceInput;
  invoiceAddressId?: InputMaybe<Scalars['UUID4']>;
}>;


export type CalculateOrderTaxesMutation = { __typename?: 'RootMutationType', calculateOrderTaxes?: { __typename?: 'CalculateOrderPayload', order?: { __typename?: 'Order', appId?: any | null | undefined, id: any, status?: string | null | undefined, internalOrderId: number, externalOrderId?: string | null | undefined, cart?: { __typename?: 'Cart', id: any, items: Array<{ __typename?: 'CartItem', id: any, quantity: number, subscriptionIntervalInDays?: number | null | undefined, item: { __typename?: 'Item', id: any, price?: number | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', subscriptionPrice: number } | null | undefined } }> } | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', firstName?: string | null | undefined, lastName?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', firstName?: string | null | undefined, lastName?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined } | null | undefined } | null | undefined, price: { __typename?: 'Price', id?: any | null | undefined, shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, calculatedTax?: number | null | undefined, description?: string | null | undefined, taxRuleId?: string | null | undefined, exempt?: number | null | undefined, impositionTypeId?: number | null | undefined, impositionValue?: string | null | undefined, jurisdiction?: string | null | undefined, jurisdictionType?: string | null | undefined }>, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', subscriptionIntervalInDays?: number | null | undefined, quantity?: number | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, taxAmount?: number | null | undefined, discountAmount?: number | null | undefined, itemId?: any | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, upc?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', subscriptionPrice?: number | null | undefined, isSubscribable: boolean } | null | undefined } | null | undefined }> } } | null | undefined } | null | undefined };

export type CartFragment = { __typename?: 'Cart', id: any, appId: any, shipping: number, subtotal: number, total: number, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', analyticsDetails?: any | null | undefined, customizations?: any | null | undefined, id: any, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> };

export type CartRecoveryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CartRecoveryQuery = { __typename?: 'RootQueryType', cartRecovery?: { __typename?: 'Cart', id: any, user?: { __typename?: 'User', id: any } | null | undefined } | null | undefined };

export type CreateOrderMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type CreateOrderMutation = { __typename?: 'RootMutationType', createOrder?: { __typename?: 'CreatedOrder', id: any, status?: string | null | undefined, requestedDeliveryDate?: any | null | undefined, submissionUid?: string | null | undefined, cart?: { __typename?: 'Cart', id: any, appId: any, shipping: number, subtotal: number, total: number, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', analyticsDetails?: any | null | undefined, customizations?: any | null | undefined, id: any, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, price: { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, upc?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined }> } } | null | undefined };

export type CreatePaymentClientTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreatePaymentClientTokenMutation = { __typename?: 'RootMutationType', createPaymentClientToken: { __typename?: 'PaymentClientTokenPayload', token: string } };

export type CreatePaymentMethodMutationVariables = Exact<{
  input: CreatePaymentMethodInput;
}>;


export type CreatePaymentMethodMutation = { __typename?: 'RootMutationType', createPaymentMethod: { __typename: 'ApplePayCard' } | { __typename: 'CreditCard' } | { __typename: 'PaypalAccount' } };

export type CreateUserAddressMutationVariables = Exact<{
  input: UserAddressInput;
}>;


export type CreateUserAddressMutation = { __typename?: 'RootMutationType', createUserAddress: { __typename?: 'Address', id: any } };

export type CreditCardFragment = { __typename?: 'CreditCard', cardType: string, cardholderName?: string | null | undefined, expirationMonth: string, expirationYear: string, default: boolean, isRemovable?: boolean | null | undefined, last4: string, token: string, uniqueNumberIdentifier: string, billingAddress?: { __typename?: 'BraintreeAddress', company?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, streetAddress?: string | null | undefined, extendedAddress?: string | null | undefined, locality?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCodeAlpha2?: string | null | undefined } | null | undefined };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any, insertedAt: any, email: string, firstName?: string | null | undefined, lastName?: string | null | undefined, userString?: string | null | undefined, addresses: Array<{ __typename?: 'Address', city: string, company?: string | null | undefined, countryCode: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, phoneNumber?: string | null | undefined, state?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, zip: string, isDefault?: boolean | null | undefined, isRemovable?: boolean | null | undefined }>, paymentMethods?: { __typename?: 'PaymentMethods', creditCards?: Array<{ __typename?: 'CreditCard', cardType: string, cardholderName?: string | null | undefined, expirationMonth: string, expirationYear: string, default: boolean, isRemovable?: boolean | null | undefined, last4: string, token: string, uniqueNumberIdentifier: string, billingAddress?: { __typename?: 'BraintreeAddress', company?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, streetAddress?: string | null | undefined, extendedAddress?: string | null | undefined, locality?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCodeAlpha2?: string | null | undefined } | null | undefined }> | null | undefined, paypalAccounts?: Array<{ __typename?: 'PaypalAccount', billingAgreementId: string, createdAt: string, customerId: string, default: boolean, email: string, imageUrl: string, isRemovable: boolean, token: string }> | null | undefined, applePayCards?: Array<{ __typename?: 'ApplePayCard', customerId: string, createdAt: string, default: boolean, token: string, cardType: string, cardholderName: string, last4: string, billingAddress?: { __typename?: 'BraintreeAddress', company?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, streetAddress?: string | null | undefined, extendedAddress?: string | null | undefined, locality?: string | null | undefined, region?: string | null | undefined, postalCode?: string | null | undefined, countryCodeAlpha2?: string | null | undefined } | null | undefined }> | null | undefined } | null | undefined } | null | undefined };

export type CurrentUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any } | null | undefined };

export type CurrentUserPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPaymentMethodsQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: any, paymentMethods?: { __typename?: 'PaymentMethods', creditCards?: Array<{ __typename?: 'CreditCard', default: boolean }> | null | undefined, paypalAccounts?: Array<{ __typename?: 'PaypalAccount', default: boolean }> | null | undefined, applePayCards?: Array<{ __typename?: 'ApplePayCard', default: boolean }> | null | undefined } | null | undefined } | null | undefined };

export type DeleteCreditCardMutationVariables = Exact<{
  input: DeleteCreditCardInput;
}>;


export type DeleteCreditCardMutation = { __typename?: 'RootMutationType', deleteCreditCard: string };

export type DeletePaymentMethodMutationVariables = Exact<{
  input: DeletePaymentMethodInput;
}>;


export type DeletePaymentMethodMutation = { __typename?: 'RootMutationType', deletePaymentMethod: string };

export type DeleteUserAddressMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type DeleteUserAddressMutation = { __typename?: 'RootMutationType', deleteUserAddress: { __typename?: 'Address', id: any } };

export type DiscountFragment = { __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined };

export type EmbeddedAddressFragment = { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined };

export type FindAddressQueryVariables = Exact<{
  input: FindAddressInput;
}>;


export type FindAddressQuery = { __typename?: 'RootQueryType', findAddress?: { __typename?: 'FoundItems', items?: Array<{ __typename?: 'FoundAddress', id?: string | null | undefined, value?: string | null | undefined, description?: string | null | undefined, type?: string | null | undefined }> | null | undefined } | null | undefined };

export type InvoicedAddressFragment = { __typename?: 'InvoicedAddress', city: string, company?: string | null | undefined, countryCode: string, firstName?: string | null | undefined, id: any, lastName?: string | null | undefined, line1: string, line2?: string | null | undefined, state?: string | null | undefined, zip: string, phoneNumber: string };

export type LocalizationQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalizationQuery = { __typename?: 'RootQueryType', localization?: { __typename?: 'Localization', currentLocale: string, defaultLocale: string, checkout?: { __typename?: 'CheckoutLocalization', pageTitlesInHead?: { __typename?: 'CheckoutPageTitlesLocalization', checkout: string, status: string } | null | undefined, reviewStep?: { __typename?: 'CheckoutReviewStepLocalizations', editButtonText: string, emailNote: string, giftEmailNote: string, giftMessageNote: string, giftShippingHeadingText: string, headingText: string, paymentHeadingText: string, shippingHeadingText: string, submitOrderButtonText: string, agreeToTermsText: string } | null | undefined, breadcrumbs?: { __typename?: 'CheckoutBreadcrumbsLocalization', address: string, payment: string, review: string, shipping: string } | null | undefined, shippingStep?: { __typename?: 'CheckoutShippingStepLocalizations', addAddressButtonText: string, addAddressHeadingText: string, additionalPhoneNumberLabel: string, addressHeadingText: string, contactNoteText: string, continueToPaymentButtonText: string, continueToShippingMethodButtonText: string, savedAddressHeadingText: string, shipAlertText: string, shippingHeadingText: string } | null | undefined, shippingMethodStep?: { __typename?: 'CheckoutShippingMethodStepLocalizations', headingText: string, selectShippingMethodText: string, freeText: string } | null | undefined, paymentStep?: { __typename?: 'CheckoutPaymentStepLocalizations', addCardHeadingText: string, addPaymentButtonText: string, addPaymentHeadingText: string, billingAddressHeadingText: string, billingSameAsShippingText: string, continueToReviewButtonText: string, headingText: string, sectionHeadingText: string, shippingAddressHeadingText: string, giftCardCoversFullAmountTitle: string, giftCardCoversFullAmountDescription: string } | null | undefined, orderStatusPage?: { __typename?: 'CheckoutOrderStatusPageLocalizations', continueShoppingButtonText: string, headingText: string, notFoundMsg: string, orderConfirmationShipmentText: string, orderDateText: string, orderDetailsHeadingText: string, orderDetailsNote: string, orderDetailsText: string, paymentHeadingText: string, printButtonText: string, shippingHeadingText: string } | null | undefined, orderDetails?: { __typename?: 'CheckoutOrderDetailsLocalizations', billingSameAsShippingText: string, cardholderNameText: string, expiresText: string, invoiceTermsText: string, invoiceText: string, poNumberText: string, shippingMethodText: string } | null | undefined, orderSummary?: { __typename?: 'CheckoutOrderSummaryLocalizations', bulkDiscountText: string, bundleDiscountText: string, bundleItemDefaultText: string, cartHeadingText: string, yourOrderText: string, freeShipLabel: string, itemPlural: string, itemSingular: string, regulatoryTaxLabel: string, salesTaxLabel: string, shippingLabel: string, subtotalLabel: string, totalLabel: string, whatsIncludedText: string } | null | undefined, couponCode?: { __typename?: 'CheckoutCouponCodeLocalizations', addCouponButtonText: string, applyCouponButtonText: string, couponLabel: string, couponCodeLabel: string, couponPlaceholderText: string, removeCouponButtonText: string, cancelCouponButtonText: string, editCouponButtonText: string } | null | undefined, giftCard?: { __typename?: 'CheckoutGiftCardLocalizations', addCouponGiftButtonText: string, addGiftButtonText: string, giftNumberPlaceholderText: string, giftNumberLabel: string, giftPinPlaceholderText: string, giftPinLabel: string, giftCardEndingIn: string } | null | undefined, rdd?: { __typename?: 'CheckoutRddLocalizations', changeDateText: string, headingText: string, needOrderSoonerText: string, noteText: string, selectDateText: string, yourRequestedDateText: string } | null | undefined, giftForm?: { __typename?: 'CheckoutGiftFormLocalizations', emailFieldLabel: string, gifteeFieldLabel: string, infoText: string, messageFieldLabel: string, sendAsGiftText: string, shippingAddressHeadingText: string } | null | undefined, errors?: { __typename?: 'CheckoutErrorsLocalizations', genericErrorMsg: string, minimumPurchaseAmount: string, minimumPurchaseQuantity: string, unverifiedEmail: string, paymentNotAccepted: string, unableToUsePoBox: string, paymentFailureErrorText: string, guestCartContainsSubscription?: { __typename?: 'GuestCartContainsSubscriptionLocalizations', cartText: string, itemHeadingText: string, itemNoteText: string } | null | undefined, lowStock?: { __typename?: 'LowStockLocalizations', cartText: string, itemHeadingText: string, itemNoteText: string } | null | undefined, purchaseQtyLimit?: { __typename?: 'PurchaseQtyLimitLocalizations', cartText: string } | null | undefined, outOfStock?: { __typename?: 'OutOfStockLocalizations', cartText: string, itemHeadingText: string, itemNoteText: string } | null | undefined, itemUnavailable?: { __typename?: 'ItemUnavailableLocalizations', cartText: string, itemHeadingText: string, itemNoteText: string } | null | undefined, insufficientLoyaltyBalance?: { __typename?: 'InsufficientLoyaltyBalanceLocalizations', itemHeadingText: string, itemNoteText: string } | null | undefined, invalidLoyaltyReward?: { __typename?: 'InvalidLoyaltyRewardLocalizations', itemHeadingText: string, itemNoteText: string } | null | undefined, invalidGiftCard?: { __typename?: 'InvalidGiftCardLocalizations', itemHeadingText: string, itemNoteText: string } | null | undefined, zipCodeRestriction?: { __typename?: 'ZipCodeRestrictionLocalizations', itemHeadingText: string, itemNoteText: string } | null | undefined, discount?: { __typename?: 'DiscountLocalizations', discountCannotApplyToSubscription: string, discountExceedsSubtotal: string, discountHeadingText: string, discountNoteText: string, discountNotFound: string, discountPromoCodeRequiresEmail: string, discountPromoCodeRequiresEmailOrLogin: string, discountTooLarge: string } | null | undefined } | null | undefined } | null | undefined, forms?: { __typename?: 'FormsLocalization', account?: { __typename?: 'FormsAccountLocalization', firstNameLabel: string, lastNameLabel: string } | null | undefined, address?: { __typename?: 'FormsAddressLocalization', cardholderNameLabel: string, cityLabel: string, companyLabel: string, countryLabel: string, emailLabel: string, firstNameLabel: string, isDefaultLabel: string, lastNameLabel: string, line1Label: string, line2Label: string, manuallyEnterAddressText: string, nicknameLabel: string, phoneLabel: string, phoneNumberLabel: string, requiredFieldsText: string, regionText: string, requiredText: string, specialInstructionsLabel: string, stateLabel: string, taxIdLabel: string, zipLabel: string, autocompletePlaceholderText: string } | null | undefined, creditCard?: { __typename?: 'FormsCreditCardLocalization', cardholderNameLabel: string, cardNumberLabel: string, cardSavedForGasExchangeNote: string, cardSavedForSubsNote: string, cvvLabel: string, expirationDateLabel: string, saveCardForLaterText: string, securityNote: string, cvvTooltip?: { __typename?: 'CreditCardTooltipLocalization', cardsWith3DigitsNote: string, cardsWith3DigitsText: string, cardsWith4DigitsNote: string, cardsWith4DigitsText: string, cvv3DigitAlt: string, cvv4DigitAlt: string, headingText: string } | null | undefined } | null | undefined, forgotPassword?: { __typename?: 'FormsForgotPasswordLocalization', backToLoginText: string, contactLinkContentText: string, contactLinkText: string, emailLabelText: string, formDescriptionText: string, headingText: string, submitButtonText: string, submittedText: string } | null | undefined, resetPassword?: { __typename?: 'FormsResetPasswordLocalization', contactLinkContentText: string, contactLinkText: string, headingText: string, passwordInputLabelText: string, requestNewLinkContentText: string, requestNewLinkText: string, resetTokenDefaultErrorText: string, resetTokenExpiredErrorText: string, resetTokenIdErrorText: string, resetTokenMismatchErrorText: string, resetTokenNotFoundErrorText: string, resetTokenUnableToDecodeErrorText: string, submitText: string } | null | undefined, signIn?: { __typename?: 'FormsSignInLocalization', accountLockedErrorText: string, emailInputPlaceholderText: string, forgotPasswordButtonText: string, genericErrorText: string, headingDefaultText: string, headingText: string, loginButtonText: string, passwordInputPlaceholderText: string, signUpButtonText: string, signUpDefaultHeadingText: string, signUpHeadingText: string } | null | undefined, signup?: { __typename?: 'FormsSignupLocalization', accountLogoAltText: string, ageRequirementErrorText: string, birthdayLabelText: string, createAccountPageHeadingText: string, dayLabelText: string, emailLabelText: string, emailPlaceholderText: string, errorResetPasswordLinkText: string, errorText: string, firstNameLabelText: string, firstNamePlaceholderText: string, headingText: string, lastNameLabelText: string, lastNamePlaceholderText: string, monthLabelText: string, passwordLabelText: string, passwordPlaceholderText: string, submitText: string, yearLabelText: string, emailOptIn?: { __typename?: 'EmailOptInLocalization', body: string, defaultLabelText: string, privacyPolicyLinkText: string, termsOfUseLinkText: string } | null | undefined } | null | undefined, tos?: { __typename?: 'FormsTosLocalization', body: string, errorText: string, tosLinkText: string } | null | undefined, validation?: { __typename?: 'FormsValidationLocalization', dayRequiredErrorText: string, emailRequiredErrorText: string, fieldRequiredErrorText: string, invalidDateErrorText: string, invalidPasswordErrorText: string, invalidPhoneErrorText: string, invalidTaxIdErrorText: string, invalidTaxIdLengthErrorText: string, monthRequiredErrorText: string, newPasswordRequiredErrorText: string, passwordRequiredErrorText: string, requiredErrorText: string, signupPasswordRequiredErrorText: string, wrongEmailErrorText: string, yearRequiredErrorText: string, companyRequiredWithTaxIdErrorText: string, taxIdRequiredWithCompanyErrorText: string } | null | undefined } | null | undefined, portal?: { __typename?: 'PortalLocalization', exchangeDetailPage?: { __typename?: 'PortalExchangeDetailsPageLocalization', avoidDepositFeesWarningTextFractional: string, avoidDepositFeesWarningTextMany: string, avoidDepositFeesWarningTextPlural: string, avoidDepositFeesWarningTextSingular: string, daysLeftToReturnHeadingText: string, daysLeftToReturnTextPlural: string, daysLeftToReturnTextSingular: string, depositFeeAddedAlertText: string, depositFeeAddedText: string, exchangeDetailsText: string, expectedReturnDateText: string, extendReturnDeadlineText: string, missedReturnDateText: string, notFoundMsg: string, orderDetailsHeadingText: string, orderedText: string, paymentHeadingText: string, returnByText: string, returnDateExtendedText: string, returnDateText: string, returnedOnText: string, returnedOutOfTotalText: string, returnedText: string, shippingHeadingText: string, statusText: string, yourOrderText: string } | null | undefined, header?: { __typename?: 'PortalHeaderLocalization', signOutLinkText: string } | null | undefined, accountVerification?: { __typename?: 'AccountVerificationLocalization', heading: string, body: string, buttonText: string, contactSupportText: string, emailSentText: string, tokenExpiredText: string, invalidLinkText: string, verifySuccessText: string } | null | undefined, accountPage?: { __typename?: 'PortalAccountPageLocalization', activeAccountHeadingText: string, addressesHeadingText: string, defaultTitleText: string, emailHeadingText: string, nameHeadingText: string, nameUpdateButtonText: string, nameUpdateCancelButtonText: string, nameUpdateSubmitButtonText: string, passwordChangeButtonText: string, passwordHeadingText: string, paymentsHeadingText: string } | null | undefined, address?: { __typename?: 'PortalAddressLocalization', addHeadingText: string, addSubmitButtonText: string, cancelButtonText: string, editHeadingText: string, makeDefaultText: string, updateSubmitButtonText: string } | null | undefined, breadcrumbs?: { __typename?: 'PortalBreadcrumbsLocalization', account: string, accountDetails: string, addAddress: string, addPayment: string, editAddress: string, exchange: string, exchangeDetails: string, machines: string, notFound: string, orders: string, shippingAddresses: string, subscriptions: string, changePassword: string } | null | undefined, card?: { __typename?: 'PortalCardLocalization', addAddressLabel: string, addPaymentLabel: string, allocationText: string, creditCardNumberText: string, currentLabel: string, defaultAddressLabel: string, defaultPaymentLabel: string, deleteButtonText: string, editButtonText: string, makeDefaultButtonText: string, numRemainingLabel: string, selectLabel: string, subscriptionAddressButtonText: string, viewAllButtonText: string } | null | undefined, password?: { __typename?: 'PortalPasswordLocalization', backButtonText: string, cancelButtonText: string, changePasswordCancelButtonText: string, changePasswordHeadingText: string, changePasswordSubmitButtonText: string, checkYourEmailContentText: string, checkYourEmailHeadingText: string, currentPasswordLabelText: string, forgotPasswordHeadingText: string, forgotPasswordHeadingWithTenantText: string, newPasswordLabelText: string, passwordUpdatedBannerText: string, resetPasswordHeadingText: string, resetPasswordHeadingWithTenantText: string, updatePasswordHeadingText: string, minCharactersText: { __typename?: 'PasswordRequirementSingleCondition', boldText: string, bodyText: string }, oneUppercaseOneLowercaseAlphaText: { __typename?: 'PasswordRequirementDoubleCondition', bodyText: string, boldText1: string, boldText2: string }, twoNumericDigitsText: { __typename?: 'PasswordRequirementSingleCondition', boldText: string, bodyText: string }, oneSpecialCharText: { __typename?: 'PasswordRequirementSingleCondition', bodyText: string, boldText: string } } | null | undefined, errors?: { __typename?: 'PortalErrorsLocalization', geoBlock?: { __typename?: 'PortalErrorsGeoblockLocalization', apiError: string, zipBlocked: string } | null | undefined, addressVerification?: { __typename?: 'PortalErrorsAddressVerificationLocalization', checkoutSpecificConfirmSuggestedText: string, confirmSuggestedAddressText: string, confirmText: string, doYouWantToProceedText: string, editEnteredAddressText: string, editText: string, enteredAddressText: string, goBackText: string, invalidZipCodeText: string, keepEnteredAddressText: string, notAbleToVerifyShippingAddressText: string, recommendChangesText: string, shippingAddressText: string, suggestedAddressText: string, useSuggestedAddressText: string, verifyText: string } | null | undefined } | null | undefined, machinesPage?: { __typename?: 'PortalMachinesPageLocalization', addMachinesText: string, areYouSureDeleteThisMachineText: string, cancelText: string, confirmDeletionText: string, deleteMachineText: string, getGasText: string, learnAboutSparklingWaterMakersText: string, machinesText: string, machineText: string, registerYourMachineNowText: string, troubleshootingGuideText: string, unlockWarrantyText: string, userManualText: string, warrantyExpiredText: string, warrantyExpiresText: string, yesDeleteThisMachineText: string } | null | undefined, exchangeList?: { __typename?: 'PortalExchangeListPageLocalization', active: string, closed: string, cylinderText: string, dueInDaysTextPlural: string, dueInDaysTextSingular: string, gasExchangeListTitle: string, gasExchangePageListTitle: string, orderDate: string, returnByDate: string, returnedDate: string, returnPastDue: string, viewDetails: string } | null | undefined, orderDetailPage?: { __typename?: 'PortalOrderDetailPageLocalization', dateText: string, invoiceNote: string, notFoundErrorText: string, orderIdHeadingText: string, orderSummaryHeadingText: string, paymentHeadingText: string, printButtonText: string, shippingAddressHeadingText: string, trackingText: string, questionAboutOrderText: string, questionAboutOrderNumberText: string } | null | undefined, orderSummary?: { __typename?: 'PortalOrderSummaryLocalization', estimatedFeeLabel: string, estimatedTaxLabel: string, feeLabel: string, freeShipLabel: string, shippingLabel: string, subtotalLabel: string, totalLabel: string } | null | undefined, ordersPage?: { __typename?: 'PortalOrdersPageLocalization', dateHeadingText: string, exchangeText: string, orderIdHeadingText: string, ordersHeadingText: string, receiptButtonText: string, reorderButtonText: string, reorderErrorNote: string, shippingAddressHeadingText: string, totalHeadingText: string } | null | undefined, subscriptionDetailPage?: { __typename?: 'PortalSubscriptionDetailPageLocalization', addressHeadingText: string, backButtonText: string, canceledText: string, cancelHeadingSubText: string, cancelHeadingText: string, cancelLabel: string, cancelSubscriptionButtonText: string, closeButtonText: string, editAddressButtonText: string, editPaymentButtonText: string, intervalHeadingText: string, intervalText: string, manageSubscriptionLabel: string, needToStartNewLabel: string, nextDeliveryDateHeadingText: string, nextShipmentDateText: string, noLongerNeedLabel: string, orderedAtHeadingText: string, otherLabel: string, pausedBannerText: string, pausedText: string, paymentHeadingText: string, paymentUpdateButtonText: string, paymentUpdateNeededText: string, priceNoteText: string, reasonForCancelingLabel: string, reasonForCancelingPlaceholder: string, renameLabel: string, resumedBannerText: string, resumeLabel: string, shippingIssueLabel: string, skipHeadingText: string, skipLabel: string, skipNextShipmentButtonText: string, skippedBannerText: string, skippedShipmentDateText: string, subscriptionNotFoundText: string, subscriptionText: string } | null | undefined, subscriptionsPage?: { __typename?: 'PortalSubscriptionsPageLocalization', actionRequiredLabel: string, canceledLabel: string, headingText: string, intervalText: string, nextDeliveryDateText: string, noSubscriptionsFoundText: string, pausedLabel: string } | null | undefined, payment?: { __typename?: 'PortalPaymentLocalization', addHeadingText: string, billingSameAsShippingText: string, cancelButtonText: string, creditCardSelectorText: string, makeDefaultText: string, paypalSelectorText: string, submitButtonText: string } | null | undefined, notAvailable?: { __typename?: 'PortalNotAvailableLocalization', headingText: string, naAbbreviationText: string, linkContentText: string, linkText: string, orders: string, subscriptions: string, exchanges: string } | null | undefined, alts?: { __typename?: 'PortalAltsLocalization', accountAltText: string, shopLogoAltText: string } | null | undefined, pageTitlesInHead?: { __typename?: 'PortalPageTitlesInHeadLocalization', verifyAccount: string } | null | undefined } | null | undefined, components?: { __typename?: 'ComponentsLocalization', addressVerification?: { __typename?: 'AddressVerificationLocalization', addressErrorBoldText: string, addressErrorText: string, editManuallyText: string, editOnlyText: string, editOrSuggestionText: string, enteredAddressText: string, invalidZipCodeText: string, keepEnteredButtonText: string, reviewAddressText: string, suggestedAddressText: string, titleText: string, useSuggestedButtonText: string, zipErrorBoldText: string, zipErrorText: string } | null | undefined, customNotFound?: { __typename?: 'CustomNotFoundLocalization', cartButtonText: string, headingText: string, homeButtonText: string, subHeadingText: string } | null | undefined, errorModal?: { __typename?: 'ErrorModalLocalization', errorHeadingText: string, okText: string, visitOurLinkForAssistanceText: string } | null | undefined, orderProcessing?: { __typename?: 'OrderProcessing', headingText: string, subHeadingText: string } | null | undefined, exchangeReturnByDate?: { __typename?: 'ExchangeReturnByDateLocalization', exchangeText: string, returnByText: string } | null | undefined, footer?: { __typename?: 'FooterLocalization', allRightsReserved: string } | null | undefined, price?: { __typename?: 'PriceLocalization', eachPriceText: string, regularPriceText: string } | null | undefined } | null | undefined } | null | undefined };

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginUserMutation = { __typename?: 'RootMutationType', loginUser?: { __typename?: 'User', id: any } | null | undefined };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'RootMutationType', logoutUser?: { __typename?: 'User', id: any } | null | undefined };

export type PaypalAccountFragment = { __typename?: 'PaypalAccount', billingAgreementId: string, createdAt: string, customerId: string, default: boolean, email: string, imageUrl: string, isRemovable: boolean, token: string };

export type PriceItemFragment = { __typename?: 'PriceItem', itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, upc?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type PriceSubmittedOrderFragment = { __typename?: 'Price', discount?: number | null | undefined, shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', basePrice?: number | null | undefined, customizations?: any | null | undefined, discountAmount?: number | null | undefined, id: any, quantity?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, taxAmount?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', compareAtPrice?: number | null | undefined, id?: any | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, title?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined, impositionValue?: string | null | undefined }> };

export type PriceV2Fragment = { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, upc?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined }> };

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetUserPasswordInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'RootMutationType', resetUserPassword?: { __typename?: 'User', id: any } | null | undefined };

export type RestrictedItemsByZipCodeQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type RestrictedItemsByZipCodeQuery = { __typename?: 'RootQueryType', restrictedItemsByZipCode?: { __typename?: 'RestrictedItemsByZipCodePayload', restrictedItems: Array<{ __typename?: 'Item', id: any }> } | null | undefined };

export type RetrieveAddressQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type RetrieveAddressQuery = { __typename?: 'RootQueryType', retrieveAddress?: { __typename?: 'RetrievedItems', items?: Array<{ __typename?: 'RetrievedAddress', line1?: string | null | undefined, line2?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined, country?: string | null | undefined }> | null | undefined } | null | undefined };

export type SearchDiscountsQueryVariables = Exact<{
  input: SearchDiscountsInput;
}>;


export type SearchDiscountsQuery = { __typename?: 'RootQueryType', searchDiscounts?: { __typename?: 'Discounts', discounts?: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }> | null | undefined } | null | undefined };

export type CreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename?: 'RootMutationType', createSetupIntent: { __typename?: 'SetupIntent', clientSecret: string } };

export type SkipOrderSubscriptionMutationVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SkipOrderSubscriptionMutation = { __typename?: 'RootMutationType', skipOrderSubscription?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type SubmitOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
  input: SubmitOrderInput;
}>;


export type SubmitOrderMutation = { __typename?: 'RootMutationType', submitOrder?: { __typename?: 'SubmittedOrder', id: any, appId?: any | null | undefined, customerPo?: string | null | undefined, requestedDeliveryDate?: any | null | undefined, submissionUid?: string | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, userString?: string | null | undefined, phone?: string | null | undefined, username?: string | null | undefined, bazaarvoice?: { __typename?: 'Bazaarvoice', encryptedEmail?: string | null | undefined, encryptionKeyId?: string | null | undefined } | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, price: { __typename?: 'Price', shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, items: Array<{ __typename?: 'PriceItem', id: any, itemId?: any | null | undefined, basePrice?: number | null | undefined, compareAtPrice?: number | null | undefined, quantity?: number | null | undefined, discountAmount?: number | null | undefined, taxAmount?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', price?: number | null | undefined, upc?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined, discount?: { __typename?: 'EmbeddedDiscount', amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }>, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined }> } } | null | undefined };

export type SubmittedOrderQueryVariables = Exact<{
  orderId: Scalars['UUID4'];
}>;


export type SubmittedOrderQuery = { __typename?: 'RootQueryType', submittedOrder?: { __typename?: 'SubmittedOrder', displayName?: string | null | undefined, isExternalOrder?: boolean | null | undefined, submittedAt?: any | null | undefined, requestedDeliveryDate?: any | null | undefined, contactInfo: { __typename?: 'ContactInfo', shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, paymentInfo?: { __typename?: 'PaymentInfo', cardExpirationDate?: string | null | undefined, cardholderName?: string | null | undefined, email?: string | null | undefined, externalId?: string | null | undefined, last4?: string | null | undefined, paymentMethod?: PaymentMethodNames | null | undefined, paymentType?: string | null | undefined, paypalEmail?: string | null | undefined, uniqueNumberIdentifier?: string | null | undefined } | null | undefined, price: { __typename?: 'Price', discount?: number | null | undefined, shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', basePrice?: number | null | undefined, customizations?: any | null | undefined, discountAmount?: number | null | undefined, id: any, quantity?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, taxAmount?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', compareAtPrice?: number | null | undefined, id?: any | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, title?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined, impositionValue?: string | null | undefined }> }, fulfillments?: Array<{ __typename?: 'Fulfillment', status?: StatusLabels | null | undefined, tracking?: { __typename?: 'TrackingNumber', carrierName?: string | null | undefined, status?: TrackingStatusLabels | null | undefined, trackingNumber?: string | null | undefined, trackingUrl?: string | null | undefined } | null | undefined, items: Array<{ __typename?: 'FulfillmentItem', quantity?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, item?: { __typename?: 'Item', id: any, title?: string | null | undefined, price?: number | null | undefined, imgUrl?: string | null | undefined, productsPerPack?: number | null | undefined, fluidOzPerPack?: any | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number } | null | undefined } | null | undefined }> }> | null | undefined } | null | undefined };

export type SubmittedOrderForOrderConfirmationQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SubmittedOrderForOrderConfirmationQuery = { __typename?: 'RootQueryType', submittedOrder?: { __typename?: 'SubmittedOrder', customerPo?: string | null | undefined, id: any, displayName?: string | null | undefined, submittedAt?: any | null | undefined, giftorName?: string | null | undefined, price: { __typename?: 'Price', discount?: number | null | undefined, shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, total?: number | null | undefined, discounts: Array<{ __typename?: 'Discount', id: any, activeFrom: any, activeUntil?: any | null | undefined, amount?: number | null | undefined, appId?: any | null | undefined, isPercent?: boolean | null | undefined, isPromoCodeRequired?: boolean | null | undefined, limit?: number | null | undefined, promoCode?: string | null | undefined, type?: DiscountType | null | undefined, typeDependentValue?: string | null | undefined, usage?: number | null | undefined }>, items: Array<{ __typename?: 'PriceItem', basePrice?: number | null | undefined, customizations?: any | null | undefined, discountAmount?: number | null | undefined, id: any, quantity?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, taxAmount?: number | null | undefined, item?: { __typename?: 'EmbeddedItem', compareAtPrice?: number | null | undefined, id?: any | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, title?: string | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice?: number | null | undefined } | null | undefined } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined, impositionValue?: string | null | undefined }> }, fulfillments?: Array<{ __typename?: 'Fulfillment', id: any, insertedAt?: any | null | undefined, status?: StatusLabels | null | undefined, tracking?: { __typename?: 'TrackingNumber', carrierName?: string | null | undefined, status?: TrackingStatusLabels | null | undefined, trackingNumber?: string | null | undefined, trackingUrl?: string | null | undefined } | null | undefined, items: Array<{ __typename?: 'FulfillmentItem', quantity?: number | null | undefined, item?: { __typename?: 'Item', id: any, title?: string | null | undefined, imgUrl?: string | null | undefined } | null | undefined }> }> | null | undefined, paymentInfo?: { __typename?: 'PaymentInfo', last4?: string | null | undefined, paymentType?: string | null | undefined, cardExpirationDate?: string | null | undefined } | null | undefined, contactInfo: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, paymentRequest?: { __typename?: 'PaymentRequest', paymentMethod?: string | null | undefined, isBillingEqualShipping?: boolean | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type SubmittedOrdersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type SubmittedOrdersQuery = { __typename?: 'RootQueryType', submittedOrders: { __typename?: 'SubmittedOrderPayload', pagination: { __typename?: 'PaginationData', totalPages: number }, submittedOrders: Array<{ __typename?: 'SubmittedOrder', id: any, isExternalOrder?: boolean | null | undefined, orderSubscriptionRelationship: OrderSubscriptionRelationshipNames, displayName?: string | null | undefined, submittedAt?: any | null | undefined, requestedDeliveryDate?: any | null | undefined, price: { __typename?: 'Price', total?: number | null | undefined, items: Array<{ __typename?: 'PriceItem', item?: { __typename?: 'EmbeddedItem', gasExchangeInfo?: { __typename?: 'EmbeddedItemGasExchangeInfo', enabled: boolean } | null | undefined } | null | undefined }> }, contactInfo: { __typename?: 'ContactInfo', shippingAddress?: { __typename?: 'EmbeddedAddress', nickname?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, city?: string | null | undefined, state?: string | null | undefined, zip?: string | null | undefined } | null | undefined }, fulfillments?: Array<{ __typename?: 'Fulfillment', id: any }> | null | undefined }> } };

export type SubscriptionQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SubscriptionQuery = { __typename?: 'RootQueryType', orderSubscription?: { __typename?: 'OrderSubscription', id: any, canceledAt?: any | null | undefined, title: string, insertedAt: any, nextDeliveryDate: any, nextOrderCreationDates: Array<any | null | undefined>, status: OrderSubscriptionStatusNames, statusReason?: string | null | undefined, intervalInDays: number, price: { __typename?: 'SubscriptionPrice', subtotal: number, tax: number, total: number, shipping: number }, address: { __typename?: 'Address', city: string, firstName: string, id: any, lastName: string, line1: string, line2?: string | null | undefined, state?: string | null | undefined, zip: string }, user: { __typename?: 'User', paymentMethods?: { __typename?: 'PaymentMethods', creditCards?: Array<{ __typename?: 'CreditCard', last4: string, expirationMonth: string, expirationYear: string, cardholderName?: string | null | undefined, cardType: string }> | null | undefined, paypalAccounts?: Array<{ __typename?: 'PaypalAccount', email: string }> | null | undefined, applePayCards?: Array<{ __typename?: 'ApplePayCard', last4: string, expirationMonth: string, expirationYear: string, cardholderName: string, cardType: string }> | null | undefined } | null | undefined }, paymentInfo: { __typename?: 'PaymentInfo', uniqueNumberIdentifier?: string | null | undefined, paymentMethod?: PaymentMethodNames | null | undefined, email?: string | null | undefined, last4?: string | null | undefined }, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', priceItem: { __typename?: 'PriceItem', subscriptionIntervalInDays?: number | null | undefined, basePrice?: number | null | undefined, quantity?: number | null | undefined, price?: { __typename?: 'Price', total?: number | null | undefined, discount?: number | null | undefined, shipping?: number | null | undefined, subtotal?: number | null | undefined, tax?: number | null | undefined, taxItems: Array<{ __typename?: 'TaxItem', amount?: number | null | undefined, impositionTypeId?: number | null | undefined, impositionValue?: string | null | undefined }> } | null | undefined, item?: { __typename?: 'EmbeddedItem', id?: any | null | undefined, imgUrl?: string | null | undefined, title?: string | null | undefined, fluidOzPerPack?: any | null | undefined, productsPerPack?: number | null | undefined, subscriptionMetadata?: { __typename?: 'EmbeddedItemSubscriptionMetadata', subscriptionPrice?: number | null | undefined, isSubscribable: boolean } | null | undefined } | null | undefined } }>, originatingOrder?: { __typename?: 'SubmittedOrder', price: { __typename?: 'Price', shipping?: number | null | undefined } } | null | undefined } | null | undefined };

export type SubscriptionAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionAddressesQuery = { __typename?: 'RootQueryType', orderSubscriptions?: { __typename?: 'OrderSubscriptionsPayload', orderSubscriptions: Array<{ __typename?: 'OrderSubscription', address: { __typename?: 'Address', id: any } }> } | null | undefined };

export type SubscriptionForAddressUpdateQueryVariables = Exact<{
  id: Scalars['UUID4'];
}>;


export type SubscriptionForAddressUpdateQuery = { __typename?: 'RootQueryType', orderSubscription?: { __typename?: 'OrderSubscription', id: any, title: string, address: { __typename?: 'Address', id: any }, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', priceItem: { __typename?: 'PriceItem', currentItem?: { __typename?: 'Item', id: any } | null | undefined } }> } | null | undefined };

export type SubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionsQuery = { __typename?: 'RootQueryType', orderSubscriptions?: { __typename?: 'OrderSubscriptionsPayload', orderSubscriptions: Array<{ __typename?: 'OrderSubscription', id: any, title: string, intervalInDays: number, insertedAt: any, nextDeliveryDate: any, status: OrderSubscriptionStatusNames, statusReason?: string | null | undefined, orderSubscriptionItems: Array<{ __typename?: 'OrderSubscriptionItem', priceItem: { __typename?: 'PriceItem', currentItem?: { __typename?: 'Item', imgUrl?: string | null | undefined } | null | undefined } }> }> } | null | undefined };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'RootQueryType', tenant?: { __typename?: 'Tenant', domain: string, fallbackUrl: string, id: any, analyticsConfig: { __typename?: 'AnalyticsConfig', projectId?: string | null | undefined, writeKey?: string | null | undefined, gtm?: { __typename?: 'GtmConfig', containerId?: string | null | undefined } | null | undefined }, botProtection: { __typename?: 'BotProtection', active: boolean, provider?: BotProtectionProvider | null | undefined, siteKey?: { __typename?: 'BotProtectionSiteKey', web: string } | null | undefined }, giftCardConfig: { __typename?: 'GiftCardConfig', giftCardsEnabled?: boolean | null | undefined }, brandConfig: { __typename?: 'BrandConfig', customCss?: string | null | undefined, audience: string, copyright: string, optInTextLocalized: string, contactUrl?: string | null | undefined, supportEmail?: string | null | undefined, email?: string | null | undefined, logoUrl: string, title: string, yearsAgeGate?: number | null | undefined, customizations: { __typename?: 'BrandConfigCustomizations', account?: { __typename?: 'BrandConfigCustomizationsAccount', signinPageTitle?: string | null | undefined, signupPageTitle?: string | null | undefined, profilePageTitle?: string | null | undefined, valueprops: Array<{ __typename?: 'BrandConfigCustomizationsAccountValueprops', imgUrl?: string | null | undefined, text?: string | null | undefined }> } | null | undefined, contacts: Array<{ __typename?: 'BrandConfigCustomizationsContact', city?: string | null | undefined, countryCode?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, phoneNumber?: string | null | undefined, showCountry?: boolean | null | undefined, state?: string | null | undefined, type: string, zip?: string | null | undefined }>, fonts: Array<{ __typename?: 'BrandConfigCustomizationsFont', name: string, style?: string | null | undefined, weight?: string | null | undefined, urls: Array<{ __typename?: 'BrandConfigCustomizationsFontSources', format?: string | null | undefined, local?: string | null | undefined, url?: string | null | undefined }>, meta?: Array<{ __typename?: 'BrandConfigCustomizationsFontMeta', key: string, value: string }> | null | undefined }>, images: Array<{ __typename?: 'BrandConfigCustomizationsImage', name: string, src: string, alt?: string | null | undefined }>, links: Array<{ __typename?: 'BrandConfigCustomizationsLink', location: string, position: number, title: string, url: string, newTab: boolean }> }, trackingFonts?: Array<{ __typename?: 'BrandConfigTrackingFonts', isTrackingRequired: boolean, resource: string } | null | undefined> | null | undefined, customTexts: Array<{ __typename?: 'CustomText', body: Array<string>, location: string, position?: number | null | undefined, type: string, links: Array<{ __typename?: 'CustomTextLink', type: string, key: string, linkValue: string, displayValue: string }> }> }, capabilities: { __typename?: 'Capabilities', signUp: { __typename?: 'CapabilitiesSignUp', enabled: boolean } }, checkout?: { __typename?: 'Checkout', vatInclusivePricing?: boolean | null | undefined, version?: string | null | undefined, paymentOptions?: { __typename?: 'TenantPaymentOptions', defaultCurrencyCode: string } | null | undefined, shippingOptions?: { __typename?: 'TenantShippingOptions', shippingMethodsEnabled?: boolean | null | undefined } | null | undefined } | null | undefined, giftConfig: { __typename?: 'GiftConfig', giftingEnabled?: boolean | null | undefined }, contactConfig: { __typename?: 'ContactConfig', shippingAddressConfig: { __typename?: 'AddressConfig', addressNickname?: boolean | null | undefined, addressSpecialInstructions?: boolean | null | undefined, companyName?: boolean | null | undefined, isStateRequired?: boolean | null | undefined, note?: string | null | undefined, requireValidation: ValidationRequirement, taxId?: boolean | null | undefined, countriesAllowed: Array<{ __typename?: 'CountriesAllowed', id: string, name: string }>, phoneNumberCountryCodesAllowed?: Array<{ __typename?: 'PhoneNumberCountryCodesAllowed', code: string, country: string } | null | undefined> | null | undefined, statesConfig: Array<{ __typename?: 'StatesConfig', countryId: string, statesAllowed: Array<{ __typename?: 'AllowedState', id: string, name: string }> }> } }, paymentConfig: { __typename?: 'PaymentConfig', processor?: PaymentProcessor | null | undefined, publicPaymentToken?: string | null | undefined, billingAddressConfig: { __typename?: 'AddressConfig', requireValidation: ValidationRequirement, note?: string | null | undefined, countriesAllowed: Array<{ __typename?: 'CountriesAllowed', id: string, name: string }>, statesConfig: Array<{ __typename?: 'StatesConfig', countryId: string, statesAllowed: Array<{ __typename?: 'AllowedState', id: string, name: string }> }> }, paymentTypes: Array<{ __typename?: 'PaymentType', brandImgUrl: string, id: number, name: string }> }, shippingConfig: { __typename?: 'ShippingConfig', maxDeliveryWindowInDays?: number | null | undefined }, shoppingBagConfig: { __typename?: 'ShoppingBagConfig', maxAmountForSelect: number, minimumPurchaseAmount: number, minimumPurchaseQty: number, availableSubscriptionIntervalsInDays: Array<number>, orderSubscriptionsEnabled: boolean, subscriptionIntervalsInDays: Array<number> }, userExperience: { __typename?: 'UserExperience', hasRequestedDeliveryDate: boolean } } | null | undefined };

export type UpdateCartItemMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID4']>;
  itemId: Scalars['UUID4'];
  quantity: Scalars['Int'];
  subscriptionIntervalInDays?: InputMaybe<Scalars['Int']>;
  customizations?: InputMaybe<Scalars['Json']>;
}>;


export type UpdateCartItemMutation = { __typename?: 'RootMutationType', updateCartItem?: { __typename?: 'Cart', id: any, appId: any, shipping: number, subtotal: number, total: number, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', analyticsDetails?: any | null | undefined, customizations?: any | null | undefined, id: any, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> } | null | undefined };

export type UpdateCreditCardDefaultMutationVariables = Exact<{
  input: UpdateCreditCardDefaultInput;
}>;


export type UpdateCreditCardDefaultMutation = { __typename?: 'RootMutationType', updateCreditCardDefault: { __typename?: 'CreditCard', default: boolean } };

export type UpdateUserFirstLastNameMutationVariables = Exact<{
  input: UpdateUserFirstLastNameInput;
}>;


export type UpdateUserFirstLastNameMutation = { __typename?: 'RootMutationType', updateUserFirstLastName?: { __typename?: 'User', id: any } | null | undefined };

export type UpdateOrderMutationVariables = Exact<{
  orderId: Scalars['UUID4'];
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'RootMutationType', updateOrder?: { __typename?: 'CreatedOrder', id: any, status?: string | null | undefined, requestedDeliveryDate?: any | null | undefined, submissionUid?: string | null | undefined, cart?: { __typename?: 'Cart', id: any, appId: any, shipping: number, subtotal: number, total: number, user?: { __typename?: 'User', id: any } | null | undefined, items: Array<{ __typename?: 'CartItem', analyticsDetails?: any | null | undefined, customizations?: any | null | undefined, id: any, perUnitPrice: number, quantity: number, strikethroughUnitPrice?: number | null | undefined, subscriptionIntervalInDays?: number | null | undefined, subtotal: number, product: { __typename?: 'Item', id: any, gtin: string, title?: string | null | undefined, brandName?: string | null | undefined, imgUrl?: string | null | undefined, price?: number | null | undefined, isOutOfStock?: boolean | null | undefined, minOrderQty?: number | null | undefined, inventoryQty?: number | null | undefined, compareAtPrice: number, itemSlug?: string | null | undefined, subscriptionMetadata?: { __typename?: 'ItemSubscriptionMetadata', isSubscribable: boolean, subscriptionPrice: number, discount?: { __typename?: 'Discount', id: any, activeFrom: any, amount?: number | null | undefined, isPercent?: boolean | null | undefined } | null | undefined } | null | undefined } }> } | null | undefined, contactInfo?: { __typename?: 'ContactInfo', email?: string | null | undefined, phone?: string | null | undefined, shippingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined, paymentRequest?: { __typename?: 'PaymentRequest', isBillingEqualShipping?: boolean | null | undefined, paymentMethod?: string | null | undefined, billingAddress?: { __typename?: 'EmbeddedAddress', city?: string | null | undefined, company?: string | null | undefined, countryCode?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, line1?: string | null | undefined, line2?: string | null | undefined, nickname?: string | null | undefined, specialInstructions?: string | null | undefined, state?: string | null | undefined, validated?: string | null | undefined, zip?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateOrderSubscriptionAddressMutationVariables = Exact<{
  input: UpdateOrderSubscriptionAddressInput;
}>;


export type UpdateOrderSubscriptionAddressMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionAddress?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateOrderSubscriptionPaymentMutationVariables = Exact<{
  input: UpdateOrderSubscriptionPaymentInput;
}>;


export type UpdateOrderSubscriptionPaymentMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionPayment?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateOrderSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'RootMutationType', updateOrderSubscription?: { __typename?: 'OrderSubscription', id: any, title: string } | null | undefined };

export type UpdateSubscriptionStatusMutationVariables = Exact<{
  input: UpdateOrderSubscriptionStatusInput;
}>;


export type UpdateSubscriptionStatusMutation = { __typename?: 'RootMutationType', updateOrderSubscriptionStatus?: { __typename?: 'OrderSubscription', id: any } | null | undefined };

export type UpdateUserAddressMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UserAddressInput;
}>;


export type UpdateUserAddressMutation = { __typename?: 'RootMutationType', updateUserAddress: { __typename?: 'Address', id: any } };

export type UpdateUserAddressDefaultMutationVariables = Exact<{
  id: Scalars['UUID4'];
  input: UserAddressIsDefaultInput;
}>;


export type UpdateUserAddressDefaultMutation = { __typename?: 'RootMutationType', updateUserAddressIsDefault: { __typename?: 'Address', id: any } };

export type UserAddressVerificationMutationVariables = Exact<{
  input: VerifyAddressInput;
}>;


export type UserAddressVerificationMutation = { __typename?: 'RootMutationType', userAddressVerification?: { __typename?: 'VerifyAddressPayload', firstName: string, lastName: string, company?: string | null | undefined, countryCode: string, city: string, state?: string | null | undefined, zip: string, line1: string, line2?: string | null | undefined, success?: boolean | null | undefined, errors?: Array<{ __typename?: 'VerifyAddressError', code?: string | null | undefined, field?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type ValidatePasswordQueryVariables = Exact<{
  password: Scalars['String'];
}>;


export type ValidatePasswordQuery = { __typename?: 'RootQueryType', validatePassword: Array<{ __typename?: 'PasswordRequirement', msg: string, satisfied: boolean }> };

export type VerifiedAddressFragment = { __typename?: 'VerifyAddressPayload', firstName: string, lastName: string, company?: string | null | undefined, countryCode: string, city: string, state?: string | null | undefined, zip: string, line1: string, line2?: string | null | undefined, success?: boolean | null | undefined, errors?: Array<{ __typename?: 'VerifyAddressError', code?: string | null | undefined, field?: string | null | undefined, message?: string | null | undefined }> | null | undefined };

export type VerifyAddressForOrderMutationVariables = Exact<{
  input: VerifyAddressInput;
  orderId: Scalars['String'];
}>;


export type VerifyAddressForOrderMutation = { __typename?: 'RootMutationType', verifyAddressForOrder?: { __typename?: 'VerifyAddressPayload', firstName: string, lastName: string, company?: string | null | undefined, countryCode: string, city: string, state?: string | null | undefined, zip: string, line1: string, line2?: string | null | undefined, success?: boolean | null | undefined, errors?: Array<{ __typename?: 'VerifyAddressError', code?: string | null | undefined, field?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export const AddressFragmentDoc = gql`
    fragment Address on Address {
  city
  company
  countryCode
  firstName
  id
  lastName
  line1
  line2
  phoneNumber
  state
  nickname
  specialInstructions
  zip
  isDefault
  isRemovable
}
    `;
export const AllocationFragmentDoc = gql`
    fragment Allocation on Credit {
  status
  type
  availableAmount
  spentAmount
  activeFrom
  activeUntil
  frozen
}
    `;
export const ApplePayCardFragmentDoc = gql`
    fragment ApplePayCard on ApplePayCard {
  billingAddress {
    company
    firstName
    lastName
    streetAddress
    extendedAddress
    locality
    region
    postalCode
    countryCodeAlpha2
  }
  customerId
  createdAt
  default
  token
  cardType
  cardholderName
  last4
}
    `;
export const CalculateOrderTaxesCartItemFragmentDoc = gql`
    fragment CalculateOrderTaxesCartItem on CartItem {
  id
  quantity
  subscriptionIntervalInDays
  item {
    id
    price
    subscriptionMetadata {
      subscriptionPrice
    }
  }
}
    `;
export const CalculateOrderTaxesPriceItemFragmentDoc = gql`
    fragment CalculateOrderTaxesPriceItem on PriceItem {
  subscriptionIntervalInDays
  quantity
  basePrice
  compareAtPrice
  taxAmount
  discountAmount
  itemId
  item {
    price
    upc
    subscriptionMetadata {
      subscriptionPrice
      isSubscribable
    }
  }
}
    `;
export const CartFragmentDoc = gql`
    fragment Cart on Cart {
  id
  appId
  user {
    id
  }
  items {
    analyticsDetails
    customizations
    id
    perUnitPrice
    product: item {
      id
      itemSlug: slug
      gtin
      title
      brandName
      imgUrl
      price
      isOutOfStock
      minOrderQty
      inventoryQty
      compareAtPrice
      subscriptionMetadata {
        discount {
          id
          activeFrom
          amount
          isPercent
        }
        isSubscribable
        subscriptionPrice
      }
    }
    quantity
    strikethroughUnitPrice
    subscriptionIntervalInDays
    subtotal
  }
  shipping
  subtotal
  total
}
    `;
export const CreditCardFragmentDoc = gql`
    fragment CreditCard on CreditCard {
  billingAddress {
    company
    firstName
    lastName
    streetAddress
    extendedAddress
    locality
    region
    postalCode
    countryCodeAlpha2
  }
  cardType
  cardholderName
  expirationMonth
  expirationYear
  default
  isRemovable
  last4
  token
  uniqueNumberIdentifier
}
    `;
export const EmbeddedAddressFragmentDoc = gql`
    fragment EmbeddedAddress on EmbeddedAddress {
  city
  company
  countryCode
  firstName
  lastName
  line1
  line2
  nickname
  specialInstructions
  state
  validated
  zip
}
    `;
export const InvoicedAddressFragmentDoc = gql`
    fragment InvoicedAddress on InvoicedAddress {
  city
  company
  countryCode
  firstName
  id
  lastName
  line1
  line2
  state
  zip
  phoneNumber
}
    `;
export const PaypalAccountFragmentDoc = gql`
    fragment PaypalAccount on PaypalAccount {
  billingAgreementId
  createdAt
  customerId
  default
  email
  imageUrl
  isRemovable
  token
}
    `;
export const DiscountFragmentDoc = gql`
    fragment Discount on Discount {
  id
  activeFrom
  activeUntil
  amount
  appId
  isPercent
  isPromoCodeRequired
  limit
  promoCode
  type
  typeDependentValue
  usage
}
    `;
export const PriceSubmittedOrderFragmentDoc = gql`
    fragment PriceSubmittedOrder on Price {
  discount
  discounts {
    ...Discount
  }
  items {
    basePrice
    customizations
    discountAmount
    id
    item {
      compareAtPrice
      id
      imgUrl
      price
      subscriptionMetadata {
        isSubscribable
        subscriptionPrice
      }
      title
    }
    quantity
    subscriptionIntervalInDays
    taxAmount
  }
  shipping
  subtotal
  tax
  taxItems {
    amount
    impositionTypeId
    impositionValue
  }
  total
}
    ${DiscountFragmentDoc}`;
export const PriceItemFragmentDoc = gql`
    fragment PriceItem on PriceItem {
  itemId
  item {
    price
    upc
    subscriptionMetadata {
      discount {
        amount
        isPercent
      }
      isSubscribable
      subscriptionPrice
    }
  }
  basePrice
  compareAtPrice
  quantity
  discountAmount
  taxAmount
  subscriptionIntervalInDays
}
    `;
export const PriceV2FragmentDoc = gql`
    fragment PriceV2 on Price {
  discounts {
    ...Discount
  }
  items {
    ...PriceItem
  }
  shipping
  subtotal
  tax
  taxItems {
    amount
    impositionTypeId
  }
  total
}
    ${DiscountFragmentDoc}
${PriceItemFragmentDoc}`;
export const VerifiedAddressFragmentDoc = gql`
    fragment VerifiedAddress on VerifyAddressPayload {
  firstName
  lastName
  company
  countryCode
  city
  state
  zip
  line1
  line2
  success
  errors {
    code
    field
    message
  }
}
    `;
export const ActiveAccountDocument = gql`
    query ActiveAccount {
  activeAccount {
    type
    name
    tags
    credits {
      ...Allocation
    }
    invoicing {
      enabled
      addresses {
        ...InvoicedAddress
      }
    }
  }
}
    ${AllocationFragmentDoc}
${InvoicedAddressFragmentDoc}`;

/**
 * __useActiveAccountQuery__
 *
 * To run a query within a React component, call `useActiveAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveAccountQuery, ActiveAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveAccountQuery, ActiveAccountQueryVariables>(ActiveAccountDocument, options);
      }
export function useActiveAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveAccountQuery, ActiveAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveAccountQuery, ActiveAccountQueryVariables>(ActiveAccountDocument, options);
        }
export type ActiveAccountQueryHookResult = ReturnType<typeof useActiveAccountQuery>;
export type ActiveAccountLazyQueryHookResult = ReturnType<typeof useActiveAccountLazyQuery>;
export type ActiveAccountQueryResult = Apollo.QueryResult<ActiveAccountQuery, ActiveAccountQueryVariables>;
export const CalculateOrderDiscountsDocument = gql`
    mutation CalculateOrderDiscounts($input: CalculateOrderDiscountsInput!) {
  calculateOrderDiscounts(input: $input) {
    order {
      price {
        ...PriceV2
      }
    }
  }
}
    ${PriceV2FragmentDoc}`;
export type CalculateOrderDiscountsMutationFn = Apollo.MutationFunction<CalculateOrderDiscountsMutation, CalculateOrderDiscountsMutationVariables>;

/**
 * __useCalculateOrderDiscountsMutation__
 *
 * To run a mutation, you first call `useCalculateOrderDiscountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateOrderDiscountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateOrderDiscountsMutation, { data, loading, error }] = useCalculateOrderDiscountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateOrderDiscountsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalculateOrderDiscountsMutation, CalculateOrderDiscountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CalculateOrderDiscountsMutation, CalculateOrderDiscountsMutationVariables>(CalculateOrderDiscountsDocument, options);
      }
export type CalculateOrderDiscountsMutationHookResult = ReturnType<typeof useCalculateOrderDiscountsMutation>;
export type CalculateOrderDiscountsMutationResult = Apollo.MutationResult<CalculateOrderDiscountsMutation>;
export type CalculateOrderDiscountsMutationOptions = Apollo.BaseMutationOptions<CalculateOrderDiscountsMutation, CalculateOrderDiscountsMutationVariables>;
export const CalculateOrderTaxesDocument = gql`
    mutation CalculateOrderTaxes($cartId: UUID4!, $contactInfo: ContactInfoInput!, $orderId: UUID4!, $paymentRequest: PaymentRequestInput!, $price: PriceInput!, $invoiceAddressId: UUID4) {
  calculateOrderTaxes(
    cartId: $cartId
    contactInfo: $contactInfo
    orderId: $orderId
    paymentRequest: $paymentRequest
    price: $price
    invoiceAddressId: $invoiceAddressId
  ) {
    order {
      appId
      id
      status
      internalOrderId
      externalOrderId
      cart {
        id
        items {
          ...CalculateOrderTaxesCartItem
        }
      }
      contactInfo {
        email
        phone
        shippingAddress {
          firstName
          lastName
          company
          countryCode
          city
          state
          zip
          line1
          line2
        }
      }
      paymentRequest {
        isBillingEqualShipping
        paymentMethod
        billingAddress {
          firstName
          lastName
          company
          countryCode
          city
          state
          zip
          line1
          line2
        }
      }
      price {
        id
        taxItems {
          amount
          calculatedTax
          description
          taxRuleId
          exempt
          impositionTypeId
          impositionValue
          jurisdiction
          jurisdictionType
        }
        shipping
        subtotal
        tax
        total
        discounts {
          ...Discount
        }
        items {
          ...CalculateOrderTaxesPriceItem
        }
      }
    }
  }
}
    ${CalculateOrderTaxesCartItemFragmentDoc}
${DiscountFragmentDoc}
${CalculateOrderTaxesPriceItemFragmentDoc}`;
export type CalculateOrderTaxesMutationFn = Apollo.MutationFunction<CalculateOrderTaxesMutation, CalculateOrderTaxesMutationVariables>;

/**
 * __useCalculateOrderTaxesMutation__
 *
 * To run a mutation, you first call `useCalculateOrderTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateOrderTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateOrderTaxesMutation, { data, loading, error }] = useCalculateOrderTaxesMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      contactInfo: // value for 'contactInfo'
 *      orderId: // value for 'orderId'
 *      paymentRequest: // value for 'paymentRequest'
 *      price: // value for 'price'
 *      invoiceAddressId: // value for 'invoiceAddressId'
 *   },
 * });
 */
export function useCalculateOrderTaxesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalculateOrderTaxesMutation, CalculateOrderTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CalculateOrderTaxesMutation, CalculateOrderTaxesMutationVariables>(CalculateOrderTaxesDocument, options);
      }
export type CalculateOrderTaxesMutationHookResult = ReturnType<typeof useCalculateOrderTaxesMutation>;
export type CalculateOrderTaxesMutationResult = Apollo.MutationResult<CalculateOrderTaxesMutation>;
export type CalculateOrderTaxesMutationOptions = Apollo.BaseMutationOptions<CalculateOrderTaxesMutation, CalculateOrderTaxesMutationVariables>;
export const CartRecoveryDocument = gql`
    query CartRecovery($id: String!) {
  cartRecovery(id: $id) {
    id
    user {
      id
    }
  }
}
    `;

/**
 * __useCartRecoveryQuery__
 *
 * To run a query within a React component, call `useCartRecoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartRecoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartRecoveryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCartRecoveryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CartRecoveryQuery, CartRecoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CartRecoveryQuery, CartRecoveryQueryVariables>(CartRecoveryDocument, options);
      }
export function useCartRecoveryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartRecoveryQuery, CartRecoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CartRecoveryQuery, CartRecoveryQueryVariables>(CartRecoveryDocument, options);
        }
export type CartRecoveryQueryHookResult = ReturnType<typeof useCartRecoveryQuery>;
export type CartRecoveryLazyQueryHookResult = ReturnType<typeof useCartRecoveryLazyQuery>;
export type CartRecoveryQueryResult = Apollo.QueryResult<CartRecoveryQuery, CartRecoveryQueryVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($cartId: String!) {
  createOrder(cartId: $cartId) {
    id
    status
    cart {
      ...Cart
    }
    contactInfo {
      email
      phone
      shippingAddress {
        ...EmbeddedAddress
      }
    }
    paymentRequest {
      billingAddress {
        ...EmbeddedAddress
      }
      isBillingEqualShipping
      paymentMethod
    }
    price {
      ...PriceV2
    }
    requestedDeliveryDate
    submissionUid
  }
}
    ${CartFragmentDoc}
${EmbeddedAddressFragmentDoc}
${PriceV2FragmentDoc}`;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const CreatePaymentClientTokenDocument = gql`
    mutation CreatePaymentClientToken {
  createPaymentClientToken {
    token
  }
}
    `;
export type CreatePaymentClientTokenMutationFn = Apollo.MutationFunction<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>;

/**
 * __useCreatePaymentClientTokenMutation__
 *
 * To run a mutation, you first call `useCreatePaymentClientTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentClientTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentClientTokenMutation, { data, loading, error }] = useCreatePaymentClientTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreatePaymentClientTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>(CreatePaymentClientTokenDocument, options);
      }
export type CreatePaymentClientTokenMutationHookResult = ReturnType<typeof useCreatePaymentClientTokenMutation>;
export type CreatePaymentClientTokenMutationResult = Apollo.MutationResult<CreatePaymentClientTokenMutation>;
export type CreatePaymentClientTokenMutationOptions = Apollo.BaseMutationOptions<CreatePaymentClientTokenMutation, CreatePaymentClientTokenMutationVariables>;
export const CreatePaymentMethodDocument = gql`
    mutation CreatePaymentMethod($input: CreatePaymentMethodInput!) {
  createPaymentMethod(input: $input) {
    __typename
  }
}
    `;
export type CreatePaymentMethodMutationFn = Apollo.MutationFunction<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;

/**
 * __useCreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMethodMutation, { data, loading, error }] = useCreatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodDocument, options);
      }
export type CreatePaymentMethodMutationHookResult = ReturnType<typeof useCreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationResult = Apollo.MutationResult<CreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>;
export const CreateUserAddressDocument = gql`
    mutation CreateUserAddress($input: UserAddressInput!) {
  createUserAddress(input: $input) {
    id
  }
}
    `;
export type CreateUserAddressMutationFn = Apollo.MutationFunction<CreateUserAddressMutation, CreateUserAddressMutationVariables>;

/**
 * __useCreateUserAddressMutation__
 *
 * To run a mutation, you first call `useCreateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAddressMutation, { data, loading, error }] = useCreateUserAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserAddressMutation, CreateUserAddressMutationVariables>(CreateUserAddressDocument, options);
      }
export type CreateUserAddressMutationHookResult = ReturnType<typeof useCreateUserAddressMutation>;
export type CreateUserAddressMutationResult = Apollo.MutationResult<CreateUserAddressMutation>;
export type CreateUserAddressMutationOptions = Apollo.BaseMutationOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    insertedAt
    email
    firstName
    lastName
    userString
    addresses {
      ...Address
    }
    paymentMethods {
      creditCards {
        ...CreditCard
      }
      paypalAccounts {
        ...PaypalAccount
      }
      applePayCards {
        ...ApplePayCard
      }
    }
  }
}
    ${AddressFragmentDoc}
${CreditCardFragmentDoc}
${PaypalAccountFragmentDoc}
${ApplePayCardFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserIdDocument = gql`
    query CurrentUserId {
  currentUser {
    id
  }
}
    `;

/**
 * __useCurrentUserIdQuery__
 *
 * To run a query within a React component, call `useCurrentUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
      }
export function useCurrentUserIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserIdQuery, CurrentUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserIdQuery, CurrentUserIdQueryVariables>(CurrentUserIdDocument, options);
        }
export type CurrentUserIdQueryHookResult = ReturnType<typeof useCurrentUserIdQuery>;
export type CurrentUserIdLazyQueryHookResult = ReturnType<typeof useCurrentUserIdLazyQuery>;
export type CurrentUserIdQueryResult = Apollo.QueryResult<CurrentUserIdQuery, CurrentUserIdQueryVariables>;
export const CurrentUserPaymentMethodsDocument = gql`
    query CurrentUserPaymentMethods {
  currentUser {
    id
    paymentMethods {
      creditCards {
        default
      }
      paypalAccounts {
        default
      }
      applePayCards {
        default
      }
    }
  }
}
    `;

/**
 * __useCurrentUserPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useCurrentUserPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPaymentMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>(CurrentUserPaymentMethodsDocument, options);
      }
export function useCurrentUserPaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>(CurrentUserPaymentMethodsDocument, options);
        }
export type CurrentUserPaymentMethodsQueryHookResult = ReturnType<typeof useCurrentUserPaymentMethodsQuery>;
export type CurrentUserPaymentMethodsLazyQueryHookResult = ReturnType<typeof useCurrentUserPaymentMethodsLazyQuery>;
export type CurrentUserPaymentMethodsQueryResult = Apollo.QueryResult<CurrentUserPaymentMethodsQuery, CurrentUserPaymentMethodsQueryVariables>;
export const DeleteCreditCardDocument = gql`
    mutation DeleteCreditCard($input: DeleteCreditCardInput!) {
  deleteCreditCard(input: $input)
}
    `;
export type DeleteCreditCardMutationFn = Apollo.MutationFunction<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;

/**
 * __useDeleteCreditCardMutation__
 *
 * To run a mutation, you first call `useDeleteCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditCardMutation, { data, loading, error }] = useDeleteCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCreditCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>(DeleteCreditCardDocument, options);
      }
export type DeleteCreditCardMutationHookResult = ReturnType<typeof useDeleteCreditCardMutation>;
export type DeleteCreditCardMutationResult = Apollo.MutationResult<DeleteCreditCardMutation>;
export type DeleteCreditCardMutationOptions = Apollo.BaseMutationOptions<DeleteCreditCardMutation, DeleteCreditCardMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation DeletePaymentMethod($input: DeletePaymentMethodInput!) {
  deletePaymentMethod(input: $input)
}
    `;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const DeleteUserAddressDocument = gql`
    mutation DeleteUserAddress($id: UUID4!) {
  deleteUserAddress(id: $id) {
    id
  }
}
    `;
export type DeleteUserAddressMutationFn = Apollo.MutationFunction<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;

/**
 * __useDeleteUserAddressMutation__
 *
 * To run a mutation, you first call `useDeleteUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAddressMutation, { data, loading, error }] = useDeleteUserAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>(DeleteUserAddressDocument, options);
      }
export type DeleteUserAddressMutationHookResult = ReturnType<typeof useDeleteUserAddressMutation>;
export type DeleteUserAddressMutationResult = Apollo.MutationResult<DeleteUserAddressMutation>;
export type DeleteUserAddressMutationOptions = Apollo.BaseMutationOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;
export const FindAddressDocument = gql`
    query FindAddress($input: FindAddressInput!) {
  findAddress(input: $input) {
    items {
      id
      value
      description
      type
    }
  }
}
    `;

/**
 * __useFindAddressQuery__
 *
 * To run a query within a React component, call `useFindAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindAddressQuery, FindAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindAddressQuery, FindAddressQueryVariables>(FindAddressDocument, options);
      }
export function useFindAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindAddressQuery, FindAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindAddressQuery, FindAddressQueryVariables>(FindAddressDocument, options);
        }
export type FindAddressQueryHookResult = ReturnType<typeof useFindAddressQuery>;
export type FindAddressLazyQueryHookResult = ReturnType<typeof useFindAddressLazyQuery>;
export type FindAddressQueryResult = Apollo.QueryResult<FindAddressQuery, FindAddressQueryVariables>;
export const LocalizationDocument = gql`
    query Localization {
  localization {
    currentLocale
    defaultLocale
    checkout {
      pageTitlesInHead {
        checkout
        status
      }
      reviewStep {
        editButtonText
        emailNote
        giftEmailNote
        giftMessageNote
        giftShippingHeadingText
        headingText
        paymentHeadingText
        shippingHeadingText
        submitOrderButtonText
      }
      breadcrumbs {
        address
        payment
        review
        shipping
      }
      shippingStep {
        addAddressButtonText
        addAddressHeadingText
        additionalPhoneNumberLabel
        addressHeadingText
        contactNoteText
        continueToPaymentButtonText
        continueToShippingMethodButtonText
        savedAddressHeadingText
        shipAlertText
        shippingHeadingText
      }
      shippingMethodStep {
        headingText
        selectShippingMethodText
        freeText
      }
      paymentStep {
        addCardHeadingText
        addPaymentButtonText
        addPaymentHeadingText
        billingAddressHeadingText
        billingSameAsShippingText
        continueToReviewButtonText
        headingText
        sectionHeadingText
        shippingAddressHeadingText
        giftCardCoversFullAmountTitle
        giftCardCoversFullAmountDescription
      }
      reviewStep {
        editButtonText
        emailNote
        giftEmailNote
        giftMessageNote
        giftShippingHeadingText
        headingText
        paymentHeadingText
        shippingHeadingText
        submitOrderButtonText
        agreeToTermsText
      }
      orderStatusPage {
        continueShoppingButtonText
        headingText
        notFoundMsg
        orderConfirmationShipmentText
        orderDateText
        orderDetailsHeadingText
        orderDetailsNote
        orderDetailsText
        paymentHeadingText
        printButtonText
        shippingHeadingText
      }
      orderDetails {
        billingSameAsShippingText
        cardholderNameText
        expiresText
        invoiceTermsText
        invoiceText
        poNumberText
        shippingMethodText
      }
      orderSummary {
        bulkDiscountText
        bundleDiscountText
        bundleItemDefaultText
        cartHeadingText
        yourOrderText
        freeShipLabel
        itemPlural
        itemSingular
        regulatoryTaxLabel
        salesTaxLabel
        shippingLabel
        subtotalLabel
        totalLabel
        whatsIncludedText
      }
      couponCode {
        addCouponButtonText
        applyCouponButtonText
        couponLabel
        couponCodeLabel
        couponPlaceholderText
        removeCouponButtonText
        cancelCouponButtonText
        editCouponButtonText
      }
      giftCard {
        addCouponGiftButtonText
        addGiftButtonText
        giftNumberPlaceholderText
        giftNumberLabel
        giftPinPlaceholderText
        giftPinLabel
        giftCardEndingIn
      }
      rdd {
        changeDateText
        headingText
        needOrderSoonerText
        noteText
        selectDateText
        yourRequestedDateText
      }
      giftForm {
        emailFieldLabel
        gifteeFieldLabel
        infoText
        messageFieldLabel
        sendAsGiftText
        shippingAddressHeadingText
      }
      errors {
        genericErrorMsg
        guestCartContainsSubscription {
          cartText
          itemHeadingText
          itemNoteText
        }
        lowStock {
          cartText
          itemHeadingText
          itemNoteText
        }
        purchaseQtyLimit {
          cartText
        }
        outOfStock {
          cartText
          itemHeadingText
          itemNoteText
        }
        itemUnavailable {
          cartText
          itemHeadingText
          itemNoteText
        }
        insufficientLoyaltyBalance {
          itemHeadingText
          itemNoteText
        }
        invalidLoyaltyReward {
          itemHeadingText
          itemNoteText
        }
        invalidGiftCard {
          itemHeadingText
          itemNoteText
        }
        minimumPurchaseAmount
        minimumPurchaseQuantity
        zipCodeRestriction {
          itemHeadingText
          itemNoteText
        }
        unverifiedEmail
        paymentNotAccepted
        unableToUsePoBox
        discount {
          discountCannotApplyToSubscription
          discountExceedsSubtotal
          discountHeadingText
          discountNoteText
          discountNotFound
          discountPromoCodeRequiresEmail
          discountPromoCodeRequiresEmailOrLogin
          discountTooLarge
        }
        paymentFailureErrorText
      }
    }
    forms {
      account {
        firstNameLabel
        lastNameLabel
      }
      address {
        cardholderNameLabel
        cityLabel
        companyLabel
        countryLabel
        emailLabel
        firstNameLabel
        isDefaultLabel
        lastNameLabel
        line1Label
        line2Label
        manuallyEnterAddressText
        nicknameLabel
        phoneLabel
        phoneNumberLabel
        requiredFieldsText
        regionText
        requiredText
        specialInstructionsLabel
        stateLabel
        taxIdLabel
        zipLabel
        autocompletePlaceholderText
      }
      creditCard {
        cardholderNameLabel
        cardNumberLabel
        cardSavedForGasExchangeNote
        cardSavedForSubsNote
        cvvLabel
        cvvTooltip {
          cardsWith3DigitsNote
          cardsWith3DigitsText
          cardsWith4DigitsNote
          cardsWith4DigitsText
          cvv3DigitAlt
          cvv4DigitAlt
          headingText
        }
        expirationDateLabel
        saveCardForLaterText
        securityNote
      }
      forgotPassword {
        backToLoginText
        contactLinkContentText
        contactLinkText
        emailLabelText
        formDescriptionText
        headingText
        submitButtonText
        submittedText
      }
      resetPassword {
        contactLinkContentText
        contactLinkText
        headingText
        passwordInputLabelText
        requestNewLinkContentText
        requestNewLinkText
        resetTokenDefaultErrorText
        resetTokenExpiredErrorText
        resetTokenIdErrorText
        resetTokenMismatchErrorText
        resetTokenNotFoundErrorText
        resetTokenUnableToDecodeErrorText
        submitText
      }
      signIn {
        accountLockedErrorText
        emailInputPlaceholderText
        forgotPasswordButtonText
        genericErrorText
        headingDefaultText
        headingText
        loginButtonText
        passwordInputPlaceholderText
        signUpButtonText
        signUpDefaultHeadingText
        signUpHeadingText
      }
      signup {
        accountLogoAltText
        ageRequirementErrorText
        birthdayLabelText
        createAccountPageHeadingText
        dayLabelText
        emailLabelText
        emailPlaceholderText
        errorResetPasswordLinkText
        errorText
        firstNameLabelText
        firstNamePlaceholderText
        headingText
        lastNameLabelText
        lastNamePlaceholderText
        monthLabelText
        passwordLabelText
        passwordPlaceholderText
        submitText
        yearLabelText
        emailOptIn {
          body
          defaultLabelText
          privacyPolicyLinkText
          termsOfUseLinkText
        }
      }
      tos {
        body
        errorText
        tosLinkText
      }
      validation {
        dayRequiredErrorText
        emailRequiredErrorText
        fieldRequiredErrorText
        invalidDateErrorText
        invalidPasswordErrorText
        invalidPhoneErrorText
        invalidTaxIdErrorText
        invalidTaxIdLengthErrorText
        monthRequiredErrorText
        newPasswordRequiredErrorText
        passwordRequiredErrorText
        requiredErrorText
        signupPasswordRequiredErrorText
        wrongEmailErrorText
        yearRequiredErrorText
        companyRequiredWithTaxIdErrorText
        taxIdRequiredWithCompanyErrorText
      }
    }
    portal {
      exchangeDetailPage {
        avoidDepositFeesWarningTextFractional
        avoidDepositFeesWarningTextMany
        avoidDepositFeesWarningTextPlural
        avoidDepositFeesWarningTextSingular
        daysLeftToReturnHeadingText
        daysLeftToReturnTextPlural
        daysLeftToReturnTextSingular
        depositFeeAddedAlertText
        depositFeeAddedText
        exchangeDetailsText
        expectedReturnDateText
        extendReturnDeadlineText
        missedReturnDateText
        notFoundMsg
        orderDetailsHeadingText
        orderedText
        paymentHeadingText
        returnByText
        returnDateExtendedText
        returnDateText
        returnedOnText
        returnedOutOfTotalText
        returnedText
        shippingHeadingText
        statusText
        yourOrderText
      }
      header {
        signOutLinkText
      }
      accountVerification {
        heading
        body
        buttonText
        contactSupportText
        emailSentText
        tokenExpiredText
        invalidLinkText
        verifySuccessText
      }
      accountPage {
        activeAccountHeadingText
        addressesHeadingText
        defaultTitleText
        emailHeadingText
        nameHeadingText
        nameUpdateButtonText
        nameUpdateCancelButtonText
        nameUpdateSubmitButtonText
        passwordChangeButtonText
        passwordHeadingText
        paymentsHeadingText
      }
      address {
        addHeadingText
        addSubmitButtonText
        cancelButtonText
        editHeadingText
        makeDefaultText
        updateSubmitButtonText
      }
      breadcrumbs {
        account
        accountDetails
        addAddress
        addPayment
        editAddress
        exchange
        exchangeDetails
        machines
        notFound
        orders
        shippingAddresses
        subscriptions
        changePassword
      }
      card {
        addAddressLabel
        addPaymentLabel
        allocationText
        creditCardNumberText
        currentLabel
        defaultAddressLabel
        defaultPaymentLabel
        deleteButtonText
        editButtonText
        makeDefaultButtonText
        numRemainingLabel
        selectLabel
        subscriptionAddressButtonText
        viewAllButtonText
      }
      password {
        backButtonText
        cancelButtonText
        changePasswordCancelButtonText
        changePasswordHeadingText
        changePasswordSubmitButtonText
        checkYourEmailContentText
        checkYourEmailHeadingText
        currentPasswordLabelText
        forgotPasswordHeadingText
        forgotPasswordHeadingWithTenantText
        newPasswordLabelText
        passwordUpdatedBannerText
        resetPasswordHeadingText
        resetPasswordHeadingWithTenantText
        updatePasswordHeadingText
        minCharactersText {
          boldText
          bodyText
        }
        oneUppercaseOneLowercaseAlphaText {
          bodyText
          boldText1
          boldText2
        }
        twoNumericDigitsText {
          boldText
          bodyText
        }
        oneSpecialCharText {
          bodyText
          boldText
        }
      }
      errors {
        geoBlock {
          apiError
          zipBlocked
        }
        addressVerification {
          checkoutSpecificConfirmSuggestedText
          confirmSuggestedAddressText
          confirmText
          doYouWantToProceedText
          editEnteredAddressText
          editText
          enteredAddressText
          goBackText
          invalidZipCodeText
          keepEnteredAddressText
          notAbleToVerifyShippingAddressText
          recommendChangesText
          shippingAddressText
          suggestedAddressText
          useSuggestedAddressText
          verifyText
        }
      }
      machinesPage {
        addMachinesText
        areYouSureDeleteThisMachineText
        cancelText
        confirmDeletionText
        deleteMachineText
        getGasText
        learnAboutSparklingWaterMakersText
        machinesText
        machineText
        registerYourMachineNowText
        troubleshootingGuideText
        unlockWarrantyText
        userManualText
        warrantyExpiredText
        warrantyExpiresText
        yesDeleteThisMachineText
      }
      exchangeList {
        active
        closed
        cylinderText
        dueInDaysTextPlural
        dueInDaysTextSingular
        gasExchangeListTitle
        gasExchangePageListTitle
        orderDate
        returnByDate
        returnedDate
        returnPastDue
        viewDetails
      }
      orderDetailPage {
        dateText
        invoiceNote
        notFoundErrorText
        orderIdHeadingText
        orderSummaryHeadingText
        paymentHeadingText
        printButtonText
        shippingAddressHeadingText
        trackingText
        questionAboutOrderText
        questionAboutOrderNumberText
      }
      orderSummary {
        estimatedFeeLabel
        estimatedTaxLabel
        feeLabel
        freeShipLabel
        shippingLabel
        subtotalLabel
        totalLabel
      }
      ordersPage {
        dateHeadingText
        exchangeText
        orderIdHeadingText
        ordersHeadingText
        receiptButtonText
        reorderButtonText
        reorderErrorNote
        shippingAddressHeadingText
        totalHeadingText
      }
      subscriptionDetailPage {
        addressHeadingText
        backButtonText
        canceledText
        cancelHeadingSubText
        cancelHeadingText
        cancelLabel
        cancelSubscriptionButtonText
        closeButtonText
        editAddressButtonText
        editPaymentButtonText
        intervalHeadingText
        intervalText
        manageSubscriptionLabel
        needToStartNewLabel
        nextDeliveryDateHeadingText
        nextShipmentDateText
        noLongerNeedLabel
        orderedAtHeadingText
        otherLabel
        pausedBannerText
        pausedText
        paymentHeadingText
        paymentUpdateButtonText
        paymentUpdateNeededText
        priceNoteText
        reasonForCancelingLabel
        reasonForCancelingPlaceholder
        renameLabel
        resumedBannerText
        resumeLabel
        shippingIssueLabel
        skipHeadingText
        skipLabel
        skipNextShipmentButtonText
        skippedBannerText
        skippedShipmentDateText
        subscriptionNotFoundText
        subscriptionText
      }
      subscriptionsPage {
        actionRequiredLabel
        canceledLabel
        headingText
        intervalText
        nextDeliveryDateText
        noSubscriptionsFoundText
        pausedLabel
      }
      payment {
        addHeadingText
        billingSameAsShippingText
        cancelButtonText
        creditCardSelectorText
        makeDefaultText
        paypalSelectorText
        submitButtonText
      }
      notAvailable {
        headingText
        naAbbreviationText
        linkContentText
        linkText
        orders
        subscriptions
        exchanges
      }
      alts {
        accountAltText
        shopLogoAltText
      }
      pageTitlesInHead {
        verifyAccount
      }
    }
    components {
      addressVerification {
        addressErrorBoldText
        addressErrorText
        editManuallyText
        editOnlyText
        editOrSuggestionText
        enteredAddressText
        invalidZipCodeText
        keepEnteredButtonText
        reviewAddressText
        suggestedAddressText
        titleText
        useSuggestedButtonText
        zipErrorBoldText
        zipErrorText
      }
      customNotFound {
        cartButtonText
        headingText
        homeButtonText
        subHeadingText
      }
      errorModal {
        errorHeadingText
        okText
        visitOurLinkForAssistanceText
      }
      orderProcessing {
        headingText
        subHeadingText
      }
      exchangeReturnByDate {
        exchangeText
        returnByText
      }
      footer {
        allRightsReserved
      }
      price {
        eachPriceText
        regularPriceText
      }
    }
  }
}
    `;

/**
 * __useLocalizationQuery__
 *
 * To run a query within a React component, call `useLocalizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocalizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LocalizationQuery, LocalizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocalizationQuery, LocalizationQueryVariables>(LocalizationDocument, options);
      }
export function useLocalizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocalizationQuery, LocalizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocalizationQuery, LocalizationQueryVariables>(LocalizationDocument, options);
        }
export type LocalizationQueryHookResult = ReturnType<typeof useLocalizationQuery>;
export type LocalizationLazyQueryHookResult = ReturnType<typeof useLocalizationLazyQuery>;
export type LocalizationQueryResult = Apollo.QueryResult<LocalizationQuery, LocalizationQueryVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($email: String!, $password: String!) {
  loginUser(input: {email: $email, password: $password}) {
    id
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const LogoutUserDocument = gql`
    mutation logoutUser {
  logoutUser {
    id
  }
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($input: ResetUserPasswordInput!) {
  resetUserPassword(input: $input) {
    id
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const RestrictedItemsByZipCodeDocument = gql`
    query RestrictedItemsByZipCode($zip: String!) {
  restrictedItemsByZipCode(zip: $zip) {
    restrictedItems {
      id
    }
  }
}
    `;

/**
 * __useRestrictedItemsByZipCodeQuery__
 *
 * To run a query within a React component, call `useRestrictedItemsByZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictedItemsByZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictedItemsByZipCodeQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useRestrictedItemsByZipCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
      }
export function useRestrictedItemsByZipCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>(RestrictedItemsByZipCodeDocument, options);
        }
export type RestrictedItemsByZipCodeQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeQuery>;
export type RestrictedItemsByZipCodeLazyQueryHookResult = ReturnType<typeof useRestrictedItemsByZipCodeLazyQuery>;
export type RestrictedItemsByZipCodeQueryResult = Apollo.QueryResult<RestrictedItemsByZipCodeQuery, RestrictedItemsByZipCodeQueryVariables>;
export const RetrieveAddressDocument = gql`
    query RetrieveAddress($id: String!) {
  retrieveAddress(id: $id) {
    items {
      line1
      line2
      city
      state
      zip
      country
    }
  }
}
    `;

/**
 * __useRetrieveAddressQuery__
 *
 * To run a query within a React component, call `useRetrieveAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetrieveAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RetrieveAddressQuery, RetrieveAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RetrieveAddressQuery, RetrieveAddressQueryVariables>(RetrieveAddressDocument, options);
      }
export function useRetrieveAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RetrieveAddressQuery, RetrieveAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RetrieveAddressQuery, RetrieveAddressQueryVariables>(RetrieveAddressDocument, options);
        }
export type RetrieveAddressQueryHookResult = ReturnType<typeof useRetrieveAddressQuery>;
export type RetrieveAddressLazyQueryHookResult = ReturnType<typeof useRetrieveAddressLazyQuery>;
export type RetrieveAddressQueryResult = Apollo.QueryResult<RetrieveAddressQuery, RetrieveAddressQueryVariables>;
export const SearchDiscountsDocument = gql`
    query SearchDiscounts($input: SearchDiscountsInput!) {
  searchDiscounts(input: $input) {
    discounts {
      ...Discount
    }
  }
}
    ${DiscountFragmentDoc}`;

/**
 * __useSearchDiscountsQuery__
 *
 * To run a query within a React component, call `useSearchDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDiscountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchDiscountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchDiscountsQuery, SearchDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchDiscountsQuery, SearchDiscountsQueryVariables>(SearchDiscountsDocument, options);
      }
export function useSearchDiscountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchDiscountsQuery, SearchDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchDiscountsQuery, SearchDiscountsQueryVariables>(SearchDiscountsDocument, options);
        }
export type SearchDiscountsQueryHookResult = ReturnType<typeof useSearchDiscountsQuery>;
export type SearchDiscountsLazyQueryHookResult = ReturnType<typeof useSearchDiscountsLazyQuery>;
export type SearchDiscountsQueryResult = Apollo.QueryResult<SearchDiscountsQuery, SearchDiscountsQueryVariables>;
export const CreateSetupIntentDocument = gql`
    mutation CreateSetupIntent {
  createSetupIntent {
    clientSecret
  }
}
    `;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSetupIntentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument, options);
      }
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const SkipOrderSubscriptionDocument = gql`
    mutation SkipOrderSubscription($id: UUID4!) {
  skipOrderSubscription(id: $id) {
    id
  }
}
    `;
export type SkipOrderSubscriptionMutationFn = Apollo.MutationFunction<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>;

/**
 * __useSkipOrderSubscriptionMutation__
 *
 * To run a mutation, you first call `useSkipOrderSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipOrderSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipOrderSubscriptionMutation, { data, loading, error }] = useSkipOrderSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSkipOrderSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>(SkipOrderSubscriptionDocument, options);
      }
export type SkipOrderSubscriptionMutationHookResult = ReturnType<typeof useSkipOrderSubscriptionMutation>;
export type SkipOrderSubscriptionMutationResult = Apollo.MutationResult<SkipOrderSubscriptionMutation>;
export type SkipOrderSubscriptionMutationOptions = Apollo.BaseMutationOptions<SkipOrderSubscriptionMutation, SkipOrderSubscriptionMutationVariables>;
export const SubmitOrderDocument = gql`
    mutation SubmitOrder($orderId: String!, $input: SubmitOrderInput!) {
  submitOrder(orderId: $orderId, input: $input) {
    id
    appId
    contactInfo {
      bazaarvoice {
        encryptedEmail
        encryptionKeyId
      }
      email
      userString
      phone
      shippingAddress {
        ...EmbeddedAddress
      }
      username
    }
    customerPo
    submissionUid: externalOrderId
    paymentRequest {
      billingAddress {
        ...EmbeddedAddress
      }
      isBillingEqualShipping
      paymentMethod
    }
    price {
      ...PriceV2
      items {
        id
        ...PriceItem
      }
    }
    requestedDeliveryDate
  }
}
    ${EmbeddedAddressFragmentDoc}
${PriceV2FragmentDoc}
${PriceItemFragmentDoc}`;
export type SubmitOrderMutationFn = Apollo.MutationFunction<SubmitOrderMutation, SubmitOrderMutationVariables>;

/**
 * __useSubmitOrderMutation__
 *
 * To run a mutation, you first call `useSubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOrderMutation, { data, loading, error }] = useSubmitOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitOrderMutation, SubmitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitOrderMutation, SubmitOrderMutationVariables>(SubmitOrderDocument, options);
      }
export type SubmitOrderMutationHookResult = ReturnType<typeof useSubmitOrderMutation>;
export type SubmitOrderMutationResult = Apollo.MutationResult<SubmitOrderMutation>;
export type SubmitOrderMutationOptions = Apollo.BaseMutationOptions<SubmitOrderMutation, SubmitOrderMutationVariables>;
export const SubmittedOrderDocument = gql`
    query SubmittedOrder($orderId: UUID4!) {
  submittedOrder(orderId: $orderId) {
    displayName
    isExternalOrder
    submittedAt
    contactInfo {
      shippingAddress {
        ...EmbeddedAddress
      }
    }
    paymentRequest {
      isBillingEqualShipping
      paymentMethod
      billingAddress {
        ...EmbeddedAddress
      }
    }
    paymentInfo {
      cardExpirationDate
      cardholderName
      email
      externalId
      last4
      paymentMethod
      paymentType
      paypalEmail
      uniqueNumberIdentifier
    }
    price {
      ...PriceSubmittedOrder
    }
    requestedDeliveryDate
    fulfillments {
      status
      tracking {
        carrierName
        status
        trackingNumber
        trackingUrl
      }
      items {
        quantity
        subscriptionIntervalInDays
        item {
          id
          title
          price
          imgUrl
          productsPerPack
          fluidOzPerPack
          subscriptionMetadata {
            isSubscribable
            subscriptionPrice
          }
        }
      }
    }
  }
}
    ${EmbeddedAddressFragmentDoc}
${PriceSubmittedOrderFragmentDoc}`;

/**
 * __useSubmittedOrderQuery__
 *
 * To run a query within a React component, call `useSubmittedOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSubmittedOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubmittedOrderQuery, SubmittedOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmittedOrderQuery, SubmittedOrderQueryVariables>(SubmittedOrderDocument, options);
      }
export function useSubmittedOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmittedOrderQuery, SubmittedOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmittedOrderQuery, SubmittedOrderQueryVariables>(SubmittedOrderDocument, options);
        }
export type SubmittedOrderQueryHookResult = ReturnType<typeof useSubmittedOrderQuery>;
export type SubmittedOrderLazyQueryHookResult = ReturnType<typeof useSubmittedOrderLazyQuery>;
export type SubmittedOrderQueryResult = Apollo.QueryResult<SubmittedOrderQuery, SubmittedOrderQueryVariables>;
export const SubmittedOrderForOrderConfirmationDocument = gql`
    query SubmittedOrderForOrderConfirmation($id: UUID4!) {
  submittedOrder(orderId: $id) {
    customerPo
    id
    displayName
    submittedAt
    price {
      ...PriceSubmittedOrder
    }
    fulfillments {
      id
      insertedAt
      tracking {
        carrierName
        status
        trackingNumber
        trackingUrl
      }
      status
      items {
        quantity
        item {
          id
          title
          imgUrl
        }
      }
    }
    paymentInfo {
      last4
      paymentType
      cardExpirationDate
    }
    contactInfo {
      shippingAddress {
        ...EmbeddedAddress
      }
      email
      phone
    }
    giftorName
    paymentRequest {
      paymentMethod
      isBillingEqualShipping
      billingAddress {
        ...EmbeddedAddress
      }
    }
  }
}
    ${PriceSubmittedOrderFragmentDoc}
${EmbeddedAddressFragmentDoc}`;

/**
 * __useSubmittedOrderForOrderConfirmationQuery__
 *
 * To run a query within a React component, call `useSubmittedOrderForOrderConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrderForOrderConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrderForOrderConfirmationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmittedOrderForOrderConfirmationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>(SubmittedOrderForOrderConfirmationDocument, options);
      }
export function useSubmittedOrderForOrderConfirmationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>(SubmittedOrderForOrderConfirmationDocument, options);
        }
export type SubmittedOrderForOrderConfirmationQueryHookResult = ReturnType<typeof useSubmittedOrderForOrderConfirmationQuery>;
export type SubmittedOrderForOrderConfirmationLazyQueryHookResult = ReturnType<typeof useSubmittedOrderForOrderConfirmationLazyQuery>;
export type SubmittedOrderForOrderConfirmationQueryResult = Apollo.QueryResult<SubmittedOrderForOrderConfirmationQuery, SubmittedOrderForOrderConfirmationQueryVariables>;
export const SubmittedOrdersDocument = gql`
    query SubmittedOrders($pagination: PaginationInput = {limit: 1000, page: 1}) {
  submittedOrders(pagination: $pagination) {
    pagination {
      totalPages
    }
    submittedOrders {
      id
      isExternalOrder
      orderSubscriptionRelationship
      displayName
      submittedAt
      requestedDeliveryDate
      price {
        total
        items {
          item {
            gasExchangeInfo {
              enabled
            }
          }
        }
      }
      contactInfo {
        shippingAddress {
          nickname
          line1
          line2
          firstName
          lastName
          city
          state
          zip
        }
      }
      fulfillments {
        id
      }
    }
  }
}
    `;

/**
 * __useSubmittedOrdersQuery__
 *
 * To run a query within a React component, call `useSubmittedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedOrdersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSubmittedOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(SubmittedOrdersDocument, options);
      }
export function useSubmittedOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>(SubmittedOrdersDocument, options);
        }
export type SubmittedOrdersQueryHookResult = ReturnType<typeof useSubmittedOrdersQuery>;
export type SubmittedOrdersLazyQueryHookResult = ReturnType<typeof useSubmittedOrdersLazyQuery>;
export type SubmittedOrdersQueryResult = Apollo.QueryResult<SubmittedOrdersQuery, SubmittedOrdersQueryVariables>;
export const SubscriptionDocument = gql`
    query Subscription($id: UUID4!) {
  orderSubscription(id: $id) {
    id
    canceledAt
    title
    insertedAt
    nextDeliveryDate
    nextOrderCreationDates
    price {
      subtotal
      tax
      total
      shipping
    }
    status
    statusReason
    address {
      city
      firstName
      id
      lastName
      line1
      line2
      state
      zip
    }
    user {
      paymentMethods {
        creditCards {
          last4
          expirationMonth
          expirationYear
          cardholderName
          cardType
        }
        paypalAccounts {
          email
        }
        applePayCards {
          last4
          expirationMonth
          expirationYear
          cardholderName
          cardType
        }
      }
    }
    paymentInfo {
      uniqueNumberIdentifier
      paymentMethod
      email
      last4
    }
    intervalInDays
    orderSubscriptionItems {
      priceItem {
        subscriptionIntervalInDays
        price {
          total
          discount
          shipping
          subtotal
          tax
          taxItems {
            amount
            impositionTypeId
            impositionValue
          }
        }
        basePrice
        item {
          id
          imgUrl
          title
          fluidOzPerPack
          productsPerPack
          subscriptionMetadata {
            subscriptionPrice
            isSubscribable
          }
        }
        quantity
      }
    }
    originatingOrder {
      price {
        shipping
      }
    }
  }
}
    `;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
      }
export function useSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionQueryResult = Apollo.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export const SubscriptionAddressesDocument = gql`
    query SubscriptionAddresses {
  orderSubscriptions {
    orderSubscriptions {
      address {
        id
      }
    }
  }
}
    `;

/**
 * __useSubscriptionAddressesQuery__
 *
 * To run a query within a React component, call `useSubscriptionAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionAddressesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>(SubscriptionAddressesDocument, options);
      }
export function useSubscriptionAddressesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>(SubscriptionAddressesDocument, options);
        }
export type SubscriptionAddressesQueryHookResult = ReturnType<typeof useSubscriptionAddressesQuery>;
export type SubscriptionAddressesLazyQueryHookResult = ReturnType<typeof useSubscriptionAddressesLazyQuery>;
export type SubscriptionAddressesQueryResult = Apollo.QueryResult<SubscriptionAddressesQuery, SubscriptionAddressesQueryVariables>;
export const SubscriptionForAddressUpdateDocument = gql`
    query SubscriptionForAddressUpdate($id: UUID4!) {
  orderSubscription(id: $id) {
    id
    title
    address {
      id
    }
    orderSubscriptionItems {
      priceItem {
        currentItem {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSubscriptionForAddressUpdateQuery__
 *
 * To run a query within a React component, call `useSubscriptionForAddressUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionForAddressUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionForAddressUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionForAddressUpdateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>(SubscriptionForAddressUpdateDocument, options);
      }
export function useSubscriptionForAddressUpdateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>(SubscriptionForAddressUpdateDocument, options);
        }
export type SubscriptionForAddressUpdateQueryHookResult = ReturnType<typeof useSubscriptionForAddressUpdateQuery>;
export type SubscriptionForAddressUpdateLazyQueryHookResult = ReturnType<typeof useSubscriptionForAddressUpdateLazyQuery>;
export type SubscriptionForAddressUpdateQueryResult = Apollo.QueryResult<SubscriptionForAddressUpdateQuery, SubscriptionForAddressUpdateQueryVariables>;
export const SubscriptionsDocument = gql`
    query Subscriptions {
  orderSubscriptions {
    orderSubscriptions {
      id
      title
      intervalInDays
      insertedAt
      nextDeliveryDate
      status
      statusReason
      orderSubscriptionItems {
        priceItem {
          currentItem {
            imgUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const TenantDocument = gql`
    query Tenant {
  tenant {
    analyticsConfig {
      gtm {
        containerId
      }
      projectId
      writeKey
    }
    botProtection {
      active
      provider
      siteKey {
        web
      }
    }
    giftCardConfig {
      giftCardsEnabled
    }
    brandConfig {
      customCss
      audience
      copyright
      optInTextLocalized
      contactUrl
      supportEmail
      customizations {
        account {
          signinPageTitle
          signupPageTitle
          profilePageTitle
          valueprops {
            imgUrl
            text
          }
        }
        contacts {
          city
          countryCode
          line1
          line2
          phoneNumber
          showCountry
          state
          type
          zip
        }
        fonts {
          name
          style
          urls {
            format
            local
            url
          }
          weight
          meta {
            key
            value
          }
        }
        images {
          name
          src
          alt
        }
        links {
          location
          position
          title
          url
          newTab
        }
      }
      email
      logoUrl
      supportEmail
      title
      trackingFonts {
        isTrackingRequired
        resource
      }
      yearsAgeGate
      customTexts {
        body
        links {
          type
          key
          linkValue
          displayValue
        }
        location
        position
        type
      }
    }
    capabilities {
      signUp {
        enabled
      }
    }
    checkout {
      paymentOptions {
        defaultCurrencyCode
      }
      shippingOptions {
        shippingMethodsEnabled
      }
      vatInclusivePricing
      version
    }
    giftConfig {
      giftingEnabled
    }
    contactConfig {
      shippingAddressConfig {
        addressNickname
        addressSpecialInstructions
        companyName
        countriesAllowed {
          id
          name
        }
        isStateRequired
        note
        phoneNumberCountryCodesAllowed {
          code
          country
        }
        requireValidation
        statesConfig {
          countryId
          statesAllowed {
            id
            name
          }
        }
        taxId
      }
    }
    domain
    fallbackUrl
    id
    paymentConfig {
      processor
      publicPaymentToken
      billingAddressConfig {
        requireValidation
        countriesAllowed {
          id
          name
        }
        note
        statesConfig {
          countryId
          statesAllowed {
            id
            name
          }
        }
      }
      paymentTypes {
        brandImgUrl
        id
        name
      }
      processor
      publicPaymentToken
    }
    shippingConfig {
      maxDeliveryWindowInDays
    }
    shoppingBagConfig {
      maxAmountForSelect
      minimumPurchaseAmount
      minimumPurchaseQty
      availableSubscriptionIntervalsInDays
      orderSubscriptionsEnabled
      subscriptionIntervalsInDays
    }
    userExperience {
      hasRequestedDeliveryDate
    }
  }
}
    `;

/**
 * __useTenantQuery__
 *
 * To run a query within a React component, call `useTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TenantQuery, TenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
      }
export function useTenantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TenantQuery, TenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
        }
export type TenantQueryHookResult = ReturnType<typeof useTenantQuery>;
export type TenantLazyQueryHookResult = ReturnType<typeof useTenantLazyQuery>;
export type TenantQueryResult = Apollo.QueryResult<TenantQuery, TenantQueryVariables>;
export const UpdateCartItemDocument = gql`
    mutation UpdateCartItem($id: UUID4, $itemId: UUID4!, $quantity: Int!, $subscriptionIntervalInDays: Int, $customizations: Json) {
  updateCartItem(
    input: {id: $id, itemId: $itemId, quantity: $quantity, subscriptionIntervalInDays: $subscriptionIntervalInDays, customizations: $customizations}
  ) {
    ...Cart
  }
}
    ${CartFragmentDoc}`;
export type UpdateCartItemMutationFn = Apollo.MutationFunction<UpdateCartItemMutation, UpdateCartItemMutationVariables>;

/**
 * __useUpdateCartItemMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemMutation, { data, loading, error }] = useUpdateCartItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      itemId: // value for 'itemId'
 *      quantity: // value for 'quantity'
 *      subscriptionIntervalInDays: // value for 'subscriptionIntervalInDays'
 *      customizations: // value for 'customizations'
 *   },
 * });
 */
export function useUpdateCartItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCartItemMutation, UpdateCartItemMutationVariables>(UpdateCartItemDocument, options);
      }
export type UpdateCartItemMutationHookResult = ReturnType<typeof useUpdateCartItemMutation>;
export type UpdateCartItemMutationResult = Apollo.MutationResult<UpdateCartItemMutation>;
export type UpdateCartItemMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>;
export const UpdateCreditCardDefaultDocument = gql`
    mutation UpdateCreditCardDefault($input: UpdateCreditCardDefaultInput!) {
  updateCreditCardDefault(input: $input) {
    default
  }
}
    `;
export type UpdateCreditCardDefaultMutationFn = Apollo.MutationFunction<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>;

/**
 * __useUpdateCreditCardDefaultMutation__
 *
 * To run a mutation, you first call `useUpdateCreditCardDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditCardDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditCardDefaultMutation, { data, loading, error }] = useUpdateCreditCardDefaultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCreditCardDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>(UpdateCreditCardDefaultDocument, options);
      }
export type UpdateCreditCardDefaultMutationHookResult = ReturnType<typeof useUpdateCreditCardDefaultMutation>;
export type UpdateCreditCardDefaultMutationResult = Apollo.MutationResult<UpdateCreditCardDefaultMutation>;
export type UpdateCreditCardDefaultMutationOptions = Apollo.BaseMutationOptions<UpdateCreditCardDefaultMutation, UpdateCreditCardDefaultMutationVariables>;
export const UpdateUserFirstLastNameDocument = gql`
    mutation UpdateUserFirstLastName($input: UpdateUserFirstLastNameInput!) {
  updateUserFirstLastName(input: $input) {
    id
  }
}
    `;
export type UpdateUserFirstLastNameMutationFn = Apollo.MutationFunction<UpdateUserFirstLastNameMutation, UpdateUserFirstLastNameMutationVariables>;

/**
 * __useUpdateUserFirstLastNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserFirstLastNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFirstLastNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFirstLastNameMutation, { data, loading, error }] = useUpdateUserFirstLastNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserFirstLastNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserFirstLastNameMutation, UpdateUserFirstLastNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserFirstLastNameMutation, UpdateUserFirstLastNameMutationVariables>(UpdateUserFirstLastNameDocument, options);
      }
export type UpdateUserFirstLastNameMutationHookResult = ReturnType<typeof useUpdateUserFirstLastNameMutation>;
export type UpdateUserFirstLastNameMutationResult = Apollo.MutationResult<UpdateUserFirstLastNameMutation>;
export type UpdateUserFirstLastNameMutationOptions = Apollo.BaseMutationOptions<UpdateUserFirstLastNameMutation, UpdateUserFirstLastNameMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($orderId: UUID4!, $input: UpdateOrderInput!) {
  updateOrder(orderId: $orderId, input: $input) {
    id
    status
    cart {
      ...Cart
    }
    contactInfo {
      email
      phone
      shippingAddress {
        ...EmbeddedAddress
      }
    }
    paymentRequest {
      billingAddress {
        ...EmbeddedAddress
      }
      isBillingEqualShipping
      paymentMethod
    }
    requestedDeliveryDate
    submissionUid
  }
}
    ${CartFragmentDoc}
${EmbeddedAddressFragmentDoc}`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UpdateOrderSubscriptionAddressDocument = gql`
    mutation UpdateOrderSubscriptionAddress($input: UpdateOrderSubscriptionAddressInput!) {
  updateOrderSubscriptionAddress(input: $input) {
    id
  }
}
    `;
export type UpdateOrderSubscriptionAddressMutationFn = Apollo.MutationFunction<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>;

/**
 * __useUpdateOrderSubscriptionAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSubscriptionAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSubscriptionAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSubscriptionAddressMutation, { data, loading, error }] = useUpdateOrderSubscriptionAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderSubscriptionAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>(UpdateOrderSubscriptionAddressDocument, options);
      }
export type UpdateOrderSubscriptionAddressMutationHookResult = ReturnType<typeof useUpdateOrderSubscriptionAddressMutation>;
export type UpdateOrderSubscriptionAddressMutationResult = Apollo.MutationResult<UpdateOrderSubscriptionAddressMutation>;
export type UpdateOrderSubscriptionAddressMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSubscriptionAddressMutation, UpdateOrderSubscriptionAddressMutationVariables>;
export const UpdateOrderSubscriptionPaymentDocument = gql`
    mutation UpdateOrderSubscriptionPayment($input: UpdateOrderSubscriptionPaymentInput!) {
  updateOrderSubscriptionPayment(input: $input) {
    id
  }
}
    `;
export type UpdateOrderSubscriptionPaymentMutationFn = Apollo.MutationFunction<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>;

/**
 * __useUpdateOrderSubscriptionPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSubscriptionPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSubscriptionPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSubscriptionPaymentMutation, { data, loading, error }] = useUpdateOrderSubscriptionPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderSubscriptionPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>(UpdateOrderSubscriptionPaymentDocument, options);
      }
export type UpdateOrderSubscriptionPaymentMutationHookResult = ReturnType<typeof useUpdateOrderSubscriptionPaymentMutation>;
export type UpdateOrderSubscriptionPaymentMutationResult = Apollo.MutationResult<UpdateOrderSubscriptionPaymentMutation>;
export type UpdateOrderSubscriptionPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSubscriptionPaymentMutation, UpdateOrderSubscriptionPaymentMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($input: UpdateOrderSubscriptionInput!) {
  updateOrderSubscription(input: $input) {
    id
    title
  }
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const UpdateSubscriptionStatusDocument = gql`
    mutation UpdateSubscriptionStatus($input: UpdateOrderSubscriptionStatusInput!) {
  updateOrderSubscriptionStatus(input: $input) {
    id
  }
}
    `;
export type UpdateSubscriptionStatusMutationFn = Apollo.MutationFunction<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>;

/**
 * __useUpdateSubscriptionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionStatusMutation, { data, loading, error }] = useUpdateSubscriptionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>(UpdateSubscriptionStatusDocument, options);
      }
export type UpdateSubscriptionStatusMutationHookResult = ReturnType<typeof useUpdateSubscriptionStatusMutation>;
export type UpdateSubscriptionStatusMutationResult = Apollo.MutationResult<UpdateSubscriptionStatusMutation>;
export type UpdateSubscriptionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionStatusMutation, UpdateSubscriptionStatusMutationVariables>;
export const UpdateUserAddressDocument = gql`
    mutation UpdateUserAddress($id: UUID4!, $input: UserAddressInput!) {
  updateUserAddress(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateUserAddressMutationFn = Apollo.MutationFunction<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;

/**
 * __useUpdateUserAddressMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressMutation, { data, loading, error }] = useUpdateUserAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAddressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>(UpdateUserAddressDocument, options);
      }
export type UpdateUserAddressMutationHookResult = ReturnType<typeof useUpdateUserAddressMutation>;
export type UpdateUserAddressMutationResult = Apollo.MutationResult<UpdateUserAddressMutation>;
export type UpdateUserAddressMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;
export const UpdateUserAddressDefaultDocument = gql`
    mutation UpdateUserAddressDefault($id: UUID4!, $input: UserAddressIsDefaultInput!) {
  updateUserAddressIsDefault(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateUserAddressDefaultMutationFn = Apollo.MutationFunction<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>;

/**
 * __useUpdateUserAddressDefaultMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressDefaultMutation, { data, loading, error }] = useUpdateUserAddressDefaultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAddressDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>(UpdateUserAddressDefaultDocument, options);
      }
export type UpdateUserAddressDefaultMutationHookResult = ReturnType<typeof useUpdateUserAddressDefaultMutation>;
export type UpdateUserAddressDefaultMutationResult = Apollo.MutationResult<UpdateUserAddressDefaultMutation>;
export type UpdateUserAddressDefaultMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressDefaultMutation, UpdateUserAddressDefaultMutationVariables>;
export const UserAddressVerificationDocument = gql`
    mutation UserAddressVerification($input: VerifyAddressInput!) {
  userAddressVerification(input: $input) {
    ...VerifiedAddress
  }
}
    ${VerifiedAddressFragmentDoc}`;
export type UserAddressVerificationMutationFn = Apollo.MutationFunction<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>;

/**
 * __useUserAddressVerificationMutation__
 *
 * To run a mutation, you first call `useUserAddressVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAddressVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAddressVerificationMutation, { data, loading, error }] = useUserAddressVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAddressVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>(UserAddressVerificationDocument, options);
      }
export type UserAddressVerificationMutationHookResult = ReturnType<typeof useUserAddressVerificationMutation>;
export type UserAddressVerificationMutationResult = Apollo.MutationResult<UserAddressVerificationMutation>;
export type UserAddressVerificationMutationOptions = Apollo.BaseMutationOptions<UserAddressVerificationMutation, UserAddressVerificationMutationVariables>;
export const ValidatePasswordDocument = gql`
    query ValidatePassword($password: String!) {
  validatePassword(password: $password) {
    msg
    satisfied
  }
}
    `;

/**
 * __useValidatePasswordQuery__
 *
 * To run a query within a React component, call `useValidatePasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePasswordQuery({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useValidatePasswordQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidatePasswordQuery, ValidatePasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidatePasswordQuery, ValidatePasswordQueryVariables>(ValidatePasswordDocument, options);
      }
export function useValidatePasswordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidatePasswordQuery, ValidatePasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidatePasswordQuery, ValidatePasswordQueryVariables>(ValidatePasswordDocument, options);
        }
export type ValidatePasswordQueryHookResult = ReturnType<typeof useValidatePasswordQuery>;
export type ValidatePasswordLazyQueryHookResult = ReturnType<typeof useValidatePasswordLazyQuery>;
export type ValidatePasswordQueryResult = Apollo.QueryResult<ValidatePasswordQuery, ValidatePasswordQueryVariables>;
export const VerifyAddressForOrderDocument = gql`
    mutation VerifyAddressForOrder($input: VerifyAddressInput!, $orderId: String!) {
  verifyAddressForOrder(input: $input, orderId: $orderId) {
    ...VerifiedAddress
  }
}
    ${VerifiedAddressFragmentDoc}`;
export type VerifyAddressForOrderMutationFn = Apollo.MutationFunction<VerifyAddressForOrderMutation, VerifyAddressForOrderMutationVariables>;

/**
 * __useVerifyAddressForOrderMutation__
 *
 * To run a mutation, you first call `useVerifyAddressForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAddressForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAddressForOrderMutation, { data, loading, error }] = useVerifyAddressForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useVerifyAddressForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyAddressForOrderMutation, VerifyAddressForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyAddressForOrderMutation, VerifyAddressForOrderMutationVariables>(VerifyAddressForOrderDocument, options);
      }
export type VerifyAddressForOrderMutationHookResult = ReturnType<typeof useVerifyAddressForOrderMutation>;
export type VerifyAddressForOrderMutationResult = Apollo.MutationResult<VerifyAddressForOrderMutation>;
export type VerifyAddressForOrderMutationOptions = Apollo.BaseMutationOptions<VerifyAddressForOrderMutation, VerifyAddressForOrderMutationVariables>;